
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lEVfb", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");


var $1uFM6 = parcelRequire("1uFM6");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");

const $8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery = (0, $eSUdr.default)`query useIsEditorToolbarDockedAtTopEditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}`;
const $8a729a72887c33f8$export$39186427447356b2 = ({ defaultDockedAtTop: defaultDockedAtTop = false } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)($8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery, {
        fetchPolicy: 'cache-only',
        skip: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'control')
    });
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'control')) return true;
    if (loading) // while loading use the default docking preference
    return defaultDockedAtTop;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        // couldn't query for user's docking preference, use the default docking preference
        return defaultDockedAtTop;
    }
    // get graphql user preference value
    const dockingPreference = data?.userPreferences?.confluenceEditorSettings?.toolbarDockingInitialPosition;
    if (dockingPreference === 'top') return true;
    if (dockingPreference === 'none') return false;
    return defaultDockedAtTop;
};
module.exports["useIsEditorToolbarDockedAtTop"] = $8a729a72887c33f8$export$39186427447356b2;

});

parcelRegister("3o3i5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");

const $d83b6646de023a51$var$defaultRetrieveEditorTitleAndContent = ()=>Promise.resolve({
        title: '',
        adf: {
            type: ''
        }
    });
const $d83b6646de023a51$var$defaultEditorObjectHeaderContext = {
    saveDraft: ()=>Promise.resolve(),
    navigateOnClose: ()=>{},
    triggerAnalyticsEvent: ()=>{},
    version: 0,
    editorActions: {
        isDocumentEmpty: ()=>{}
    },
    title: '',
    retrieveEditorTitleAndContent: $d83b6646de023a51$var$defaultRetrieveEditorTitleAndContent,
    onPreviewClicked: ()=>{},
    isPublishingContent: false,
    userOffline: false,
    editorTitle: null,
    collabLimitReached: false,
    collabEditConnected: false,
    onClickPublish: ()=>{},
    shouldRenderPreview: false,
    isUnpublishedDraft: false,
    onHoverPublish: ()=>{}
};
const $d83b6646de023a51$var$EditorObjectHeaderContext = /*#__PURE__*/ (0, $42omo.createContext)($d83b6646de023a51$var$defaultEditorObjectHeaderContext);
const $d83b6646de023a51$var$memoizeDeepEq = (0, $2XqLN.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d83b6646de023a51$export$7cf4636ad0f38e12 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, value: value } = t0;
    let t1;
    if ($[0] !== value) {
        t1 = $d83b6646de023a51$var$memoizeDeepEq(value);
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    const memoizedValue = t1;
    const t2 = memoizedValue;
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d83b6646de023a51$var$EditorObjectHeaderContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
const $d83b6646de023a51$export$54525653dcbc614a = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d83b6646de023a51$var$EditorObjectHeaderContext);
    if (!context) throw new Error("useEditorObjectHeaderContext must be used within a EditorObjectHeaderContextProvider, and a `value` must be provided to EditorObjectHeaderContextProvider");
    return context;
};
module.exports["EditorObjectHeaderContextProvider"] = $d83b6646de023a51$export$7cf4636ad0f38e12;
module.exports["useEditorObjectHeaderContext"] = $d83b6646de023a51$export$54525653dcbc614a;

});

parcelRegister("1ch0f", function(module, exports) {

var $6s78L = parcelRequire("6s78L");

/**
 * @generated SignedSource<<a0e28b59f2eaa66a8360f55eca07eeab>>
 * @relayHash 9c1433a098b8d67c1d47d21323cdafeb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99dc6e26456dc3cca27a70a32c753eeb82bec6079452a0d1db666a1f8956e864
const $39485bf2a989af16$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "action"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "action",
                    "variableName": "action"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "DeleteContentResponsePayload",
            "kind": "LinkedField",
            "name": "deleteContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "wasDeleted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DeleteDraftMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "DeleteDraftMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9c1433a098b8d67c1d47d21323cdafeb",
            "id": "99dc6e26456dc3cca27a70a32c753eeb82bec6079452a0d1db666a1f8956e864",
            "metadata": {},
            "name": "DeleteDraftMutation",
            "operationKind": "mutation",
            "text": "mutation DeleteDraftMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId,wasDeleted}}"
        }
    };
}();
$39485bf2a989af16$var$node.hash = "d5524f7ebeca5db81e74baaef5bc18f4";
var $39485bf2a989af16$export$2e2bcd8739ae039 = $39485bf2a989af16$var$node;


const $70727fac6b2369a2$export$20904b77028459e9 = ({ isUnpublishedDraft: isUnpublishedDraft, isSingleUserSession: isSingleUserSession, hasTitle: hasTitle, hasBody: hasBody, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, hasRestrictions: hasRestrictions, hasLabels: hasLabels })=>{
    const isBlank = isSingleUserSession && isUnpublishedDraft && !hasTitle && !hasBody && !hasEmoji && !hasEmoji && !hasCoverPicture && !hasContentState && !hasRestrictions && !hasLabels;
    return {
        isBlank: isBlank,
        isUnpublishedDraft: isUnpublishedDraft,
        isSingleUserSession: isSingleUserSession,
        hasTitle: hasTitle,
        hasBody: hasBody,
        hasEmoji: hasEmoji,
        hasCoverPicture: hasCoverPicture,
        hasContentState: hasContentState,
        hasRestrictions: hasRestrictions,
        hasLabels: hasLabels
    };
};
const $70727fac6b2369a2$export$96599dcc2d34575a = ({ contentId: contentId, deleteOnlyIfBlank: deleteOnlyIfBlank })=>(0, $6s78L.mutateInterop)({
        mutation: (0, $39485bf2a989af16$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId,
            action: deleteOnlyIfBlank ? 'DELETE_DRAFT_IF_BLANK' : 'DELETE_DRAFT'
        }
    });
module.exports["blankDraftInfo"] = $70727fac6b2369a2$export$20904b77028459e9;
module.exports["deleteDraft"] = $70727fac6b2369a2$export$96599dcc2d34575a;

});

parcelRegister("2unW6", function(module, exports) {
/**
 * @generated SignedSource<<60ef1a07767b4db0131d92957d173675>>
 * @relayHash 848f1836e2238dbfdcc045c2ec137644
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f16220b95acf270f365810e4dc35125e23fa8938ab963384bae1e3f51467f3f3
const $e3a32f09a5f0d53b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": {
                                        "direction": "ASCENDING",
                                        "sortField": "LABELLING_CREATIONDATE"
                                    }
                                }
                            ],
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                }
                            ],
                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsLabelCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsLabelCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "848f1836e2238dbfdcc045c2ec137644",
            "id": "f16220b95acf270f365810e4dc35125e23fa8938ab963384bae1e3f51467f3f3",
            "metadata": {},
            "name": "useLabelsLabelCountQuery",
            "operationKind": "query",
            "text": "query useLabelsLabelCountQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count}}}}"
        }
    };
}();
$e3a32f09a5f0d53b$var$node.hash = "b0ad7041e68cadecf202efbc623c838f";
var $e3a32f09a5f0d53b$export$2e2bcd8739ae039 = $e3a32f09a5f0d53b$var$node;



var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");

const $0c936a0ccc8709d1$export$d6875122194c7b44 = (contentId)=>{
    const [hasLabels, setHasLabels] = (0, $42omo.useState)(true);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $e3a32f09a5f0d53b$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId
        }
    });
    (0, $42omo.useEffect)(()=>{
        setHasLabels((data?.content?.nodes?.[0]?.labels?.count ?? 0) > 0);
    }, [
        data
    ]);
    return hasLabels;
};
module.exports["useLabels"] = $0c936a0ccc8709d1$export$d6875122194c7b44;

});

parcelRegister("gDbO8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $efvKr = parcelRequire("efvKr");


var $82Ooj = parcelRequire("82Ooj");





var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $dAYOx = parcelRequire("dAYOx");


var $iXCQx = parcelRequire("iXCQx");


var $x4n5k = parcelRequire("x4n5k");


var $1Zr9M = parcelRequire("1Zr9M");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $d0922dfcb7434c92$var$i18n = (0, $cgtv4.defineMessages)({
    modeToggleToEdit: {
        id: "live-pages-features.live-pages-mode-switcher.editing.edit-dropdown",
        defaultMessage: "Resume editing"
    },
    modeToggleToView: {
        id: "live-pages-features.live-pages-mode-switcher.editing.view-dropdown",
        defaultMessage: "Switch to viewing"
    }
});
const $d0922dfcb7434c92$export$7266636f729f5bc9 = ({ selectedMode: selectedMode, onChange: onChange, isDisabled: isDisabled, elemAfter: elemAfter })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const dropdownMenuContent = selectedMode === 'edit' ? $d0922dfcb7434c92$var$i18n.modeToggleToView : $d0922dfcb7434c92$var$i18n.modeToggleToEdit;
    const shortcut = selectedMode === 'edit' ? (0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW) : (0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT);
    const getShortcutComponent = ()=>{
        if (elemAfter) return elemAfter({
            shortcutKeys: [
                shortcut
            ],
            id: 'viewEditToggle'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: shortcut
        });
    };
    const Icon = selectedMode === 'edit' ? (0, (/*@__PURE__*/$parcel$interopDefault($x4n5k))) : (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: ""
        }),
        elemAfter: getShortcutComponent(),
        testId: "live-page-mode-toggle-label",
        onClick: ()=>onChange?.(selectedMode === 'view' ? 'edit' : 'view'),
        "aria-label": formatMessage(dropdownMenuContent),
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), dropdownMenuContent)));
};


const $074be0d28909724e$export$9674de41b3e1d3c1 = ({ contentId: contentId, isDisabled: isDisabled, flags: flags, analyticsSource: analyticsSource, elemAfter: elemAfter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ mode: livePageMode }, { setMode: setLivePageMode }] = (0, $efvKr.useLivePageMode)();
    const { showLivePageModeFlag: showLivePageModeFlag } = (0, $82Ooj.useLivePageModeFlag)(flags);
    const handleModeChange = (newMode)=>{
        showLivePageModeFlag(newMode);
        setLivePageMode(newMode);
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                source: analyticsSource,
                action: 'changed',
                actionSubject: 'mode',
                actionSubjectId: 'livePagesModeSwitcher',
                attributes: {
                    previousMode: livePageMode,
                    newMode: newMode
                },
                objectType: 'page',
                objectId: contentId
            }
        })?.fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d0922dfcb7434c92$export$7266636f729f5bc9), {
        selectedMode: livePageMode ?? 'view',
        onChange: handleModeChange,
        isDisabled: isDisabled,
        elemAfter: elemAfter
    });
};
module.exports["LivePagesModeChanger"] = $074be0d28909724e$export$9674de41b3e1d3c1;

});

parcelRegister("5rEAe", function(module, exports) {
/**
 * Gets the contentId of the specified draft content's parent by looking in the GraphQL cache.
 * If it's unable to find the parent, returns undefined.
 */ const $15544693a6bca546$export$15562ab063498253 = async (contentId, readFragmentInterop)=>{
    // Apollo's `readQuery` method will throw an error if ANY of the requested fields are missing.
    // We want to gracefully handle this and return `undefined`, so we use the try/catch block to swallow errors.
    let parentId = undefined;
    try {
        const draftData = readFragmentInterop({
            id: `Content:${contentId}`
        });
        parentId = draftData?.ancestors?.slice(-1)?.[0]?.id;
    } catch  {}
    return parentId;
};
module.exports["getParentOfDraft"] = $15544693a6bca546$export$15562ab063498253;

});

parcelRegister("3mmDo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hYoU4 = parcelRequire("hYoU4");


var $1ch0f = parcelRequire("1ch0f");

const $f928d6004096ea67$export$a0b893b7ce6fdcb3 = ({ isUnpublishedDraft: isUnpublishedDraft, isSingleUserSession: isSingleUserSession, hasTitle: hasTitle, hasBody: hasBody, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, hasRestrictions: hasRestrictions, hasLabels: hasLabels })=>{
    const [willDeleteBlankDraftOnClose, setWillDeleteBlankDraftOnClose] = (0, $42omo.useState)(false);
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    (0, $42omo.useEffect)(()=>{
        // necessary for showing correct tooltip on close button
        const { isBlank: isBlank } = (0, $1ch0f.blankDraftInfo)({
            isUnpublishedDraft: isUnpublishedDraft,
            isSingleUserSession: isSingleUserSession,
            hasTitle: hasTitle,
            hasBody: hasBody,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            hasContentState: hasContentState,
            hasRestrictions: hasRestrictions,
            hasLabels: hasLabels
        });
        setWillDeleteBlankDraftOnClose(collabEditConnected && isBlank);
    }, [
        isUnpublishedDraft,
        isSingleUserSession,
        hasTitle,
        hasBody,
        hasEmoji,
        hasCoverPicture,
        hasContentState,
        hasRestrictions,
        hasLabels,
        collabEditConnected
    ]);
    return willDeleteBlankDraftOnClose;
};
module.exports["useWillDeleteBlankDraftOnClose"] = $f928d6004096ea67$export$a0b893b7ce6fdcb3;

});

parcelRegister("lHzSp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $ktUCG = parcelRequire("ktUCG");


var $i5zxs = parcelRequire("i5zxs");


var $bJX6u = parcelRequire("bJX6u");

// Utility component to update state when subscription triggers.
// We can't call state setters in Subscribe's render prop because it's called in the render phase.
const $fb2260515fd87e61$var$StateSync = ({ value: value, setter: setter })=>{
    (0, $42omo.useEffect)(()=>{
        setter(value);
    }, [
        value,
        setter
    ]);
    return null;
};
const $fb2260515fd87e61$export$5ebd549b1d465b39 = ()=>{
    const [hasEmoji, setHasEmoji] = (0, $42omo.useState)(false);
    const [hasCoverPicture, setHasCoverPicture] = (0, $42omo.useState)(false);
    const [hasContentState, setHasContentState] = (0, $42omo.useState)(false);
    const emojiCoverPictureAndContentStateSubscription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer)
        ]
    }, (emojiTitleState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fb2260515fd87e61$var$StateSync, {
            value: !!emojiTitleState.state.selectedEmoji,
            setter: setHasEmoji
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fb2260515fd87e61$var$StateSync, {
            value: coverPictureState.state.hasCoverPicture,
            setter: setHasCoverPicture
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bJX6u.ContentStateStateContainer)
        ]
    }, (contentStateState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fb2260515fd87e61$var$StateSync, {
            value: !!contentStateState.state.contentState,
            setter: setHasContentState
        })));
    return {
        emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription,
        hasCoverPicture: hasCoverPicture,
        hasEmoji: hasEmoji,
        hasContentState: hasContentState
    };
};
module.exports["useEmojiTitleCoverPictureAndContentState"] = $fb2260515fd87e61$export$5ebd549b1d465b39;

});

parcelRegister("atF9V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $5nr5P = parcelRequire("5nr5P");

const $5d4782fa577ebcb8$export$e6d5ad5483367d52 = ()=>{
    const [hasRestrictions, setHasRestrictions] = (0, $42omo.useState)(false);
    const hasRestrictionsSubscription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $5nr5P.RestrictionsDataContainer)
        ]
    }, (restrictionsState)=>{
        setHasRestrictions(restrictionsState.state.hasRestrictions);
        return null;
    });
    return {
        hasRestrictionsSubscription: hasRestrictionsSubscription,
        hasRestrictions: hasRestrictions
    };
};
module.exports["useRestrictions"] = $5d4782fa577ebcb8$export$e6d5ad5483367d52;

});

parcelRegister("aXWbQ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $b8ad22721a0e1a1a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    requestToEdit: {
        defaultMessage: "Request to edit",
        id: "no-permission.request.to.edit.button.label"
    },
    editRequestSent: {
        defaultMessage: "Request sent",
        id: "no-permission.edit.request.sent.button.label"
    },
    notSentFlagTitle: {
        defaultMessage: "Your request wasn\u2019t sent",
        id: "no-permission.request.to.edit.not.sent.flag.title"
    },
    notSentFlagDescription: {
        defaultMessage: "We ran into a problem submitting your edit request. Try again or contact your admin.",
        id: "no-permission.request.to.edit.not.sent.flag.description"
    },
    requestSentFlagTitle: {
        defaultMessage: "Request to edit sent",
        id: "no-permission.request.to.edit.request.sent.flag.title"
    },
    requestSentFlagShortTitle: {
        defaultMessage: "Request sent",
        id: "no-permission.request.to.edit.request.sent.flag.short.title"
    },
    requestSentFlagDescription: {
        defaultMessage: "We've asked the owner to give you edit access. You'll get an email once the request is approved.",
        id: "no-permission.request.to.edit.request.sent.flag.description"
    },
    requestSentFlagAction: {
        defaultMessage: "Got it",
        id: "no-permission.request.to.edit.request.sent.flag.action"
    }
});
module.exports["messages"] = $b8ad22721a0e1a1a$export$defe85febe8b728c;

});

parcelRegister("bLtXM", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<67f7e9692855d5e97a00595e34e00d73>>
 * @relayHash beefa4502029b9edf583f29096ec6d94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59253e139e4d9f22296c7edc1165a5ca96d099ffa2525bc52eb27ea54676e3f6
const $1fb504ddbdec34a4$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ContentHeaderPresenceUserQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ContentHeaderPresenceUserQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "beefa4502029b9edf583f29096ec6d94",
            "id": "59253e139e4d9f22296c7edc1165a5ca96d099ffa2525bc52eb27ea54676e3f6",
            "metadata": {},
            "name": "ContentHeaderPresenceUserQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceUserQuery{user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$1fb504ddbdec34a4$var$node.hash = "0834d99c9aa942b8576e3c3061916b0b";
var $1fb504ddbdec34a4$export$2e2bcd8739ae039 = $1fb504ddbdec34a4$var$node;



var $axutP = parcelRequire("axutP");


var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $jMyy4 = parcelRequire("jMyy4");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $3jwuS = parcelRequire("3jwuS");


var $2VZOl = parcelRequire("2VZOl");


var $de2j9 = parcelRequire("de2j9");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $cLo2u = parcelRequire("cLo2u");


var $7Sm4c = parcelRequire("7Sm4c");


var $efvKr = parcelRequire("efvKr");


var $lkApp = parcelRequire("lkApp");


var $9VtwR = parcelRequire("9VtwR");


var $0ejZ8 = parcelRequire("0ejZ8");


var $jmjWc = parcelRequire("jmjWc");


const $1e82291b1be231ce$var$PagePresence = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6Cexk",
    name: "PagePresence",
    loader: async ()=>(await (parcelRequire("hGuer"))).PagePresence
});

const $1e82291b1be231ce$var$CanvasPresence = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TGyYR",
    name: "CanvasPresence",
    loader: async ()=>(await (parcelRequire("lMRy5"))).CanvasPresence
});
const $1e82291b1be231ce$var$ContentHeaderPresenceContentSettingsQuery = (0, $axutP.default);
const $1e82291b1be231ce$var$createDefaultParticipant = ({ presenceId: presenceId, activity: activity, user: user, isGuest: isGuest })=>{
    if (!user) return undefined;
    const sessions = {
        [(0, $9VtwR.CURRENT_USER_DUMMY_SESSION_ID)]: {
            activity: activity
        }
    };
    const usablePresenceId = user?.id ?? presenceId;
    return {
        id: usablePresenceId,
        userId: user?.id ?? 'unidentified',
        presenceId: usablePresenceId,
        name: user?.displayName ?? '',
        src: user?.photos?.[0]?.value ?? '',
        isCurrentUser: true,
        isGuest: isGuest,
        sessions: sessions
    };
};
const $1e82291b1be231ce$var$UFO_SEGMENT_NAME = 'content-header-presence';
const $1e82291b1be231ce$export$a8d99186a74b60f6 = ({ collaborators: collaborators, contentId: contentId, contentType: contentType, isViewMode: isViewMode, analyticSource: analyticSource })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const isEditPage = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { fetchAnonymousAsset: fetchAnonymousAsset } = (0, $0ejZ8.useAnonymousAsset)();
    const isCanvasType = contentType === 'whiteboard' || contentType === 'database';
    const { data: userData, error: userQueryError } = (0, $jMyy4.useQueryInterop)((0, $1fb504ddbdec34a4$export$2e2bcd8739ae039));
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $42omo.useRef)(presenceId);
    let contentMode = 'view';
    if (isLivePage) contentMode = 'live';
    else if (isEditPage) contentMode = 'edit';
    const activity = contentMode === 'edit' || contentMode === 'live' && (isLiveEditMode || !isViewMode) ? 'editor' : 'viewer';
    const { data: settingData, error: settingsQueryError } = (0, $jMyy4.useQueryInterop)($1e82291b1be231ce$var$ContentHeaderPresenceContentSettingsQuery, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: isCanvasType || contentMode !== 'view'
    });
    const error = userQueryError || settingsQueryError;
    const isSettingEnabledOnView = (0, $42omo.useCallback)(()=>{
        return isCanvasType || settingData?.confluence_teamPresenceContentSetting?.isEnabledOnContentView === true;
    }, [
        isCanvasType,
        settingData
    ]);
    const handleError = (err)=>{
        experienceTracker.fail({
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
            error: err
        });
        (0, $7Sm4c.markErrorAsHandled)(err);
        return null;
    };
    if (!contentType) return null;
    if (error) handleError(error);
    if (contentMode === 'view' && !isSettingEnabledOnView()) {
        experienceTracker.abort({
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
            reason: `Real-time visibility is disabled on view mode`
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lkApp.PresenceStoreContainer), {
        participant: $1e82291b1be231ce$var$createDefaultParticipant({
            presenceId: presenceIdRef.current,
            activity: activity,
            user: userData?.user,
            isGuest: isGuest
        }),
        fetchAnonymousAsset: fetchAnonymousAsset,
        onError: handleError
    }, isCanvasType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1e82291b1be231ce$var$CanvasPresence, {
        collaborators: collaborators,
        contentId: contentId,
        contentType: contentType,
        analyticSource: analyticSource
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1e82291b1be231ce$var$PagePresence, {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        activity: activity,
        analyticSource: analyticSource
    }));
};
const $1e82291b1be231ce$export$52baa28b583c9835 = (props)=>{
    const $ = (0, $frIzR.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1e82291b1be231ce$export$a8d99186a74b60f6, props);
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props.contentId || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).COLLABORATION_PRESENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: $1e82291b1be231ce$var$UFO_SEGMENT_NAME
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
            scope: props.contentId
        }, t0, t1)));
        $[3] = props.contentId;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
module.exports["ContentHeaderPresence"] = $1e82291b1be231ce$export$52baa28b583c9835;

});

parcelRegister("lkApp", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $jyw2s = parcelRequire("jyw2s");


var $9VtwR = parcelRequire("9VtwR");

// yes, all this is hella messy right now, will be refactoring and moving out of a store
const $2960af57d9597263$var$PresenceStore = (0, $1P1Tu.createStore)({
    initialState: {
        participants: new Map(),
        telepointers: new Map()
    },
    actions: {
        add: (participant)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                // can't be null in confluence, ultimately is the userId for logged in users and presenceId for anonymous
                const { presenceId: id } = participant;
                const currentParticipants = new Map(participants);
                if (id) {
                    const previousParticipant = currentParticipants.get(id);
                    const entry = {
                        id: id,
                        userId: participant.userId,
                        presenceId: participant.presenceId,
                        name: participant.name,
                        isGuest: participant.isGuest,
                        isCurrentUser: Boolean(previousParticipant?.isCurrentUser),
                        src: participant.avatar,
                        sessions: {
                            ...previousParticipant?.sessions,
                            [participant.sessionId]: {
                                activity: participant.presenceActivity ?? 'viewer'
                            }
                        }
                    };
                    currentParticipants.set(id, entry);
                    setState({
                        participants: currentParticipants
                    });
                } else // eslint-disable-next-line no-console
                console.error("presenceId is null for participant when it shouldn't be for ", participant);
            },
        remove: (sessionId)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                const currentParticipants = new Map(participants);
                const participant = (0, $9VtwR.getCurrentUserFromMap)(participants, sessionId);
                if (participant) {
                    if (Object.keys(participant.sessions).length === 1) {
                        currentParticipants.delete(participant.id);
                        setState({
                            participants: currentParticipants
                        });
                    } else {
                        delete participant.sessions[sessionId];
                        currentParticipants.set(participant.id, participant);
                        setState({
                            participants: currentParticipants
                        });
                    }
                } else // eslint-disable-next-line no-console
                console.error('Could not remove participant with sessionId of ', sessionId);
            },
        addTelepointerData: (data)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const participant = (0, $9VtwR.getCurrentUserFromMap)(state.participants, data.sessionId);
                if (// Don't track the telepointer data for the current user
                Boolean(participant?.isCurrentUser)) return;
                const telepointers = new Map(state.telepointers);
                telepointers.set(data.sessionId, {
                    ...data,
                    timestamp: Date.now()
                });
                setState({
                    telepointers: telepointers
                });
            }
    },
    name: 'PresenceStore'
});
const $2960af57d9597263$export$7033f12ef2e1cbf5 = (0, $9zUhf.createHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$afdb9ee4b69111fa = (0, $9zUhf.createActionsHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$23e4fe06e7659b53 = (0, $9zUhf.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: (state)=>state.participants
});
const $2960af57d9597263$export$d8ba5bfd88808651 = (state, props)=>{
    const { participants: participants } = state;
    const currentUser = (0, $9VtwR.getCurrentUserFromMap)(participants, props.sessionId);
    const participantValues = [
        ...participants.values()
    ].filter((p)=>p.presenceId !== currentUser?.presenceId);
    if (currentUser) participantValues.unshift(currentUser);
    return participantValues.map((participant)=>{
        const isAnonymous = participant.userId === (0, $9VtwR.UNIDENTIFIED);
        // When the user is anonymous, we attempt to use the localized name from the anonymous asset or a default name
        const name = isAnonymous ? participant.name || props.anonymousName : participant.name;
        return {
            ...participant,
            participantColor: isAnonymous ? (0, $jyw2s.getParticipantColor)(participant.id).color.backgroundColor : undefined,
            isCurrentUser: participant.isCurrentUser || participant.id === currentUser?.id,
            name: name,
            activity: participant.isCurrentUser && currentUser ? (0, $9VtwR.getActivityToDisplay)(participant.sessions, props.sessionId, props.activity) : (0, $9VtwR.getActivityToDisplay)(participant.sessions)
        };
    });
};
const $2960af57d9597263$export$5a5a291828ecb5e4 = (0, $9zUhf.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$d8ba5bfd88808651
});
const $2960af57d9597263$export$172cef4c4690b3ab = (state, sessions)=>Object.keys(sessions).map((sId)=>state.telepointers.get(sId)).filter((tData)=>!!tData).sort((a, b)=>b?.timestamp - a?.timestamp)?.[0];
const $2960af57d9597263$export$f1a08937c1f9340b = (0, $9zUhf.createHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$172cef4c4690b3ab
});
const $2960af57d9597263$export$f642eede20cf74c0 = (0, $FOT9i.createContainer)($2960af57d9597263$var$PresenceStore, {
    onInit: ()=>({ setState: setState }, { participant: participant, fetchAnonymousAsset: fetchAnonymousAsset, onError: onError })=>{
            if (participant) {
                const defaultParticipants = new Map();
                if (participant.userId === (0, $9VtwR.UNIDENTIFIED)) fetchAnonymousAsset(participant.presenceId).then((asset)=>{
                    defaultParticipants.set(participant.id, {
                        ...participant,
                        src: asset?.src || participant.src,
                        name: asset?.name || participant.name
                    });
                }).catch(onError).finally(()=>{
                    setState({
                        participants: defaultParticipants
                    });
                });
                else {
                    defaultParticipants.set(participant.id, {
                        ...participant
                    });
                    setState({
                        participants: defaultParticipants
                    });
                }
            } else setState({
                participants: new Map()
            });
        }
});
module.exports["usePresenceStoreActions"] = $2960af57d9597263$export$afdb9ee4b69111fa;
module.exports["useParticipants"] = $2960af57d9597263$export$23e4fe06e7659b53;
module.exports["useTransformedParticipants"] = $2960af57d9597263$export$5a5a291828ecb5e4;
module.exports["useActiveTelepointerBySessions"] = $2960af57d9597263$export$f1a08937c1f9340b;
module.exports["PresenceStoreContainer"] = $2960af57d9597263$export$f642eede20cf74c0;

});

parcelRegister("9VtwR", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $jyw2s = parcelRequire("jyw2s");

var $aFUXX = parcelRequire("aFUXX");


var $T9xHm = parcelRequire("T9xHm");


var $6mKj3 = parcelRequire("6mKj3");

const $6bda54ffb0f4283a$export$2fbd87a2176aa7cf = (id)=>{
    if (!id) return (0, $aFUXX.participantColors)[0];
    return (0, $jyw2s.getParticipantColor)(id).color;
};
const $6bda54ffb0f4283a$export$fecb54e21647ae4f = ()=>{
    return {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    };
};
const $6bda54ffb0f4283a$export$a8078789f7ade13a = (participants, sessionId)=>{
    if (sessionId) return [
        ...participants.values()
    ].find((p)=>p.sessions[sessionId]);
};
const $6bda54ffb0f4283a$export$8c4801f1df434a3 = (sessionData, currentUserSessionId, defaultActivity)=>{
    if (currentUserSessionId) return sessionData[currentUserSessionId]?.activity ?? defaultActivity ?? 'viewer';
    else {
        const hasEditor = Object.keys(sessionData).find((sessionId)=>sessionData[sessionId]?.activity === 'editor');
        return hasEditor ? 'editor' : 'viewer';
    }
};
const $6bda54ffb0f4283a$export$cd367e77e21c7f3d = ()=>{
    const route = 'collab-presence-confluence';
    if (window.location.hostname === 'localhost' && true) {
        const host = window.__backendOriginHost;
        return `https://${host}/${route}`;
    }
    return `${window.location.origin}/${route}`;
};
const $6bda54ffb0f4283a$export$324e5039614a122a = (cloudId, activationId)=>{
    let path = '';
    if ((0, $T9xHm.isIsolatedCloud)() && (0, $6mKj3.expVal)('platform_editor_use_pmr_for_collab_presence_in_ic', 'isEnabled', false) || !(0, $T9xHm.isIsolatedCloud)() && (0, $6mKj3.expVal)('platform_editor_use_pmr_for_collab_presence_non_ic', 'isEnabled', false)) {
        const presencePrefix = '/ncs-presence';
        path = `${presencePrefix}/${cloudId}/${activationId}/confluence`;
    }
    return path;
};
const $6bda54ffb0f4283a$var$presenceCanvasContentTypes = [
    'database',
    'whiteboard'
];
const $6bda54ffb0f4283a$export$ea7ca1acbbc07168 = (contentType)=>$6bda54ffb0f4283a$var$presenceCanvasContentTypes.includes(contentType);
const $6bda54ffb0f4283a$export$73e42e5abf6898ab = ()=>`presence-${(0, $9HkI0.v4)()}`;
const $6bda54ffb0f4283a$export$dd4b75f1a6268a6b = 4;
const $6bda54ffb0f4283a$export$a9b806721f7a3927 = 'dummy-session-id';
const $6bda54ffb0f4283a$export$72a96dbd0b162542 = 'unidentified';
module.exports["getParticipantColors"] = $6bda54ffb0f4283a$export$2fbd87a2176aa7cf;
module.exports["getCurrentUserColors"] = $6bda54ffb0f4283a$export$fecb54e21647ae4f;
module.exports["getCurrentUserFromMap"] = $6bda54ffb0f4283a$export$a8078789f7ade13a;
module.exports["getActivityToDisplay"] = $6bda54ffb0f4283a$export$8c4801f1df434a3;
module.exports["getPresenceServiceUrl"] = $6bda54ffb0f4283a$export$cd367e77e21c7f3d;
module.exports["getPresenceServicePath"] = $6bda54ffb0f4283a$export$324e5039614a122a;
module.exports["isCanvasContentType"] = $6bda54ffb0f4283a$export$ea7ca1acbbc07168;
module.exports["getPresenceClientId"] = $6bda54ffb0f4283a$export$73e42e5abf6898ab;
module.exports["MAX_GROUP_SIZE"] = $6bda54ffb0f4283a$export$dd4b75f1a6268a6b;
module.exports["CURRENT_USER_DUMMY_SESSION_ID"] = $6bda54ffb0f4283a$export$a9b806721f7a3927;
module.exports["UNIDENTIFIED"] = $6bda54ffb0f4283a$export$72a96dbd0b162542;

});

parcelRegister("0ejZ8", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jyw2s = parcelRequire("jyw2s");


var $83Vfg = parcelRequire("83Vfg");


var $9VtwR = parcelRequire("9VtwR");

const $fd1de2fc32fd6664$export$ed360de126596689 = ()=>{
    const $ = (0, $frIzR.c)(1);
    const fetchAnonymousAsset = $fd1de2fc32fd6664$var$_temp;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            fetchAnonymousAsset: fetchAnonymousAsset
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $fd1de2fc32fd6664$var$_temp(presenceId) {
    const hashCode = presenceId ? (0, $jyw2s.getHashCode)(presenceId) : 0;
    const primaryIndex = hashCode;
    const svgBackgroundColor = (0, $9VtwR.getParticipantColors)(presenceId).svgBackgroundColor;
    return (0, $83Vfg.getAnonymousAvatarWithStyling)({
        styleProperties: {
            "background-color": svgBackgroundColor
        },
        index: primaryIndex
    });
}
module.exports["useAnonymousAsset"] = $fd1de2fc32fd6664$export$ed360de126596689;

});

parcelRegister("hGuer", function(module, exports) {

let $cdfdcf5cf0610a29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdfdcf5cf0610a29$var$load("bWAYG"),
    $cdfdcf5cf0610a29$var$load("k5Ch2"),
    $cdfdcf5cf0610a29$var$load("djob1"),
    $cdfdcf5cf0610a29$var$load("dVEpf"),
    $cdfdcf5cf0610a29$var$load("1dyrX"),
    $cdfdcf5cf0610a29$var$load("jplsw"),
    $cdfdcf5cf0610a29$var$load("exa5h"),
    $cdfdcf5cf0610a29$var$load("aTrJR")
]).then(()=>parcelRequire('gLdsO'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("lMRy5", function(module, exports) {

let $fdc79e5bedacb2a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fdc79e5bedacb2a3$var$load("k5Ch2"),
    $fdc79e5bedacb2a3$var$load("djob1"),
    $fdc79e5bedacb2a3$var$load("1dyrX"),
    $fdc79e5bedacb2a3$var$load("b1YSZ")
]).then(()=>parcelRequire('lx2Vu'));

});

parcelRegister("JJ6wk", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<8b01de59b52ef28edc97e2621fa79862>>
 * @relayHash 3e1b8ad99323925f7f9acd3b0a8da699
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 578f8900b035c8aabb9585b20ffa9eba064b10f20e4fb991d7f807712f2538f9
const $dbf5442f5a3b49c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useObjectHeader"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current",
                "draft"
            ]
        }
    ], v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "contentTypeModified"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "kind": "ScalarField",
            "name": "friendlyWhen"
        }
    ], v4 = {
        "condition": "useObjectHeader",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v3 /*: any*/ 
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": v3 /*: any*/ 
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "useContentBasicInfoFragment"
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "useContentSpaceFragment"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3e1b8ad99323925f7f9acd3b0a8da699",
            "id": "578f8900b035c8aabb9585b20ffa9eba064b10f20e4fb991d7f807712f2538f9",
            "metadata": {},
            "name": "ContentTypesHeaderQuery",
            "operationKind": "query",
            "text": "query ContentTypesHeaderQuery($contentId:ID,$useObjectHeader:Boolean!){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{...useContentBasicInfoFragment,space{...useContentSpaceFragment,id},operations{operation,targetType},version@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen}\n      draftVersion@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen},id}}}fragment useContentBasicInfoFragment on Content{id,title,type,subType,status}fragment useContentSpaceFragment on Space{id,name,key,alias}"
        }
    };
}();
$dbf5442f5a3b49c0$var$node.hash = "b00a2b355a74b39fcbb57135227bc5cf";
var $dbf5442f5a3b49c0$export$2e2bcd8739ae039 = $dbf5442f5a3b49c0$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $T1bCI = parcelRequire("T1bCI");


var $j1Ss3 = parcelRequire("j1Ss3");


var $5izcQ = parcelRequire("5izcQ");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $8zMP3 = parcelRequire("8zMP3");


var $8dwdz = parcelRequire("8dwdz");


var $hzkzq = parcelRequire("hzkzq");


var $cgsIj = parcelRequire("cgsIj");


var $2VQ4B = parcelRequire("2VQ4B");


var $io723 = parcelRequire("io723");


var $40pD8 = parcelRequire("40pD8");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $6S5EB = parcelRequire("6S5EB");


var $bvJwp = parcelRequire("bvJwp");


var $99t4P = parcelRequire("99t4P");


var $cuWTe = parcelRequire("cuWTe");


var $1ggpj = parcelRequire("1ggpj");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $cVfpT = parcelRequire("cVfpT");


var $3WXN2 = parcelRequire("3WXN2");


var $4aGJ9 = parcelRequire("4aGJ9");


var $7xVCs = parcelRequire("7xVCs");


var $lyx2E = parcelRequire("lyx2E");


var $deZfn = parcelRequire("deZfn");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $8z0fF = parcelRequire("8z0fF");


var $9wGTI = parcelRequire("9wGTI");


var $47zp4 = parcelRequire("47zp4");


var $jvYFk = parcelRequire("jvYFk");


var $aWwYt = parcelRequire("aWwYt");


var $dPJCf = parcelRequire("dPJCf");


var $bj5fB = parcelRequire("bj5fB");


var $l7iY7 = parcelRequire("l7iY7");


var $1NBp8 = parcelRequire("1NBp8");


var $4VJDS = parcelRequire("4VJDS");


var $hQBR9 = parcelRequire("hQBR9");


var $6LsQQ = parcelRequire("6LsQQ");


var $3u0dr = parcelRequire("3u0dr");








var $jMyy4 = parcelRequire("jMyy4");

const $574d761bd3a496fb$export$b84ae570a1bec29f = (0, $3u0dr.isReactCompilerActiveV2)() ? (query, params, selectors)=>{
    const $ = (0, $frIzR.c)(7);
    const result = (0, $jMyy4.useQueryInterop)(query, params);
    const { data: data, loading: loading } = result;
    let t0;
    bb0: {
        if (loading || !data) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = {};
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        let fragmentRefsResult;
        if ($[1] !== data || $[2] !== selectors) {
            fragmentRefsResult = {};
            for(const key in selectors){
                const selector = selectors?.[key];
                const entity = selector ? selector(data) : data?.[key];
                if (!entity) throw new Error(`useFragmentizedQuery: Expected entity for fragment key "${String(key)}" but it was not found in the query data. Make sure the query includes the necessary fields for this fragment.`);
                if (!entity.__typename || !entity.id) throw new Error(`useFragmentizedQuery: Entity for fragment key "${String(key)}" is missing required fields (__typename or id).`);
                fragmentRefsResult[key] = {
                    __typename: entity.__typename,
                    id: entity.id
                };
            }
            $[1] = data;
            $[2] = selectors;
            $[3] = fragmentRefsResult;
        } else fragmentRefsResult = $[3];
        t0 = fragmentRefsResult;
    }
    const fragmentRefs = t0;
    let t1;
    if ($[4] !== fragmentRefs || $[5] !== result) {
        t1 = {
            ...result,
            fragmentRefs: fragmentRefs
        };
        $[4] = fragmentRefs;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : (query, params, selectors)=>{
    const result = (0, $jMyy4.useQueryInterop)(query, params);
    const { data: data, loading: loading } = result;
    const fragmentRefs = (0, $42omo.useMemo)(()=>{
        // Don't compute fragmentRefs during loading or when data is not available
        if (loading || !data) return {};
        const fragmentRefsResult = {};
        for(const key in selectors){
            const selector = selectors?.[key];
            // Use selector if provided, otherwise fall back to direct key access
            const entity = selector ? selector(data) : data?.[key];
            if (!entity) throw new Error(`useFragmentizedQuery: Expected entity for fragment key "${String(key)}" but it was not found in the query data. Make sure the query includes the necessary fields for this fragment.`);
            if (!entity.__typename || !entity.id) throw new Error(`useFragmentizedQuery: Entity for fragment key "${String(key)}" is missing required fields (__typename or id).`);
            fragmentRefsResult[key] = {
                __typename: entity.__typename,
                id: entity.id
            };
        }
        return fragmentRefsResult;
    }, [
        data,
        loading,
        selectors
    ]);
    return {
        ...result,
        fragmentRefs: fragmentRefs
    };
};



var $5qUgM = parcelRequire("5qUgM");











var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");







var $a3fRD = parcelRequire("a3fRD");


var $lUjjs = parcelRequire("lUjjs");


var $91xA1 = parcelRequire("91xA1");


var $4noo5 = parcelRequire("4noo5");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");














var $lt6Lx = parcelRequire("lt6Lx");


var $7Sm4c = parcelRequire("7Sm4c");


var $bT0se = parcelRequire("bT0se");


var $7QM6o = parcelRequire("7QM6o");


var $kSPGK = parcelRequire("kSPGK");











var $1B6Lx = parcelRequire("1B6Lx");


var $kXsBa = parcelRequire("kXsBa");




const $778018eca844ead1$export$f6d8ac9231e1baff = 60;
const $778018eca844ead1$export$3e7822b6c7b36880 = (error)=>{
    return error.message.includes('exists with the same title in this space');
};
const $778018eca844ead1$var$i18n = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "content-types-header.content-types-title.placeholder",
        defaultMessage: "Untitled whiteboard"
    },
    databaseTitlePlaceholder: {
        id: "content-types-header.content-types-title.database-title-placeholder",
        defaultMessage: "Untitled database"
    },
    embedTitlePlaceholder: {
        id: "content-types-header.content-types-title.embed-title-placeholder",
        defaultMessage: "Untitled Smart Link"
    },
    renameTooltip: {
        id: "content-types-header.content-types-title.rename-tooltip",
        defaultMessage: "Rename"
    },
    permissionsTooltip: {
        id: "content-types-header.content-types-title.permissions-tooltip",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You don't have permission to edit this whiteboard"
    },
    databasePermissionsTooltip: {
        id: "content-types-header.content-types-title.database-permissions-tooltip",
        defaultMessage: "You don\u2019t have permission to edit this database"
    },
    embedPermissionsTooltip: {
        id: "content-types-header.content-types-title.embed-permissions-tooltip",
        defaultMessage: "You don\u2019t have permission to edit this Smart Link"
    },
    duplicateTitleError: {
        id: "content-types-header.content-types-title.duplicate-title-error",
        defaultMessage: "A whiteboard with this title already exists in this space"
    },
    emptyTitleError: {
        id: "content-types-header.content-types-title.empty-title-error",
        defaultMessage: "Title cannot be empty"
    },
    duplicateDatabaseTitleError: {
        id: "content-types-header.content-types-title.duplicate-database-title-error",
        defaultMessage: "A database with this title already exists in this space"
    },
    duplicateEmbedTitleError: {
        id: "content-types-header.content-types-title.duplicate-embed-title-error",
        defaultMessage: "A Smart Link with this title already exists in this space"
    },
    generalError: {
        id: "content-types-header.content-types-title.general-error",
        defaultMessage: "There was an error on our end. Refresh and try again."
    },
    titleLengthError: {
        id: "content-types-header.content-types-title.title-length-error",
        defaultMessage: "{maxLength, plural, one {Title has a maximum of {maxLength} character} other {Title has a maximum of {maxLength} characters}}"
    },
    onboardingSpotlightBody: {
        id: "content-types-header.content-types-title.onboarding-spotlight-body",
        defaultMessage: "Give your whiteboard a unique name"
    }
});
const $778018eca844ead1$var$i18nByContentType = {
    duplicateTitleError: {
        database: $778018eca844ead1$var$i18n.duplicateDatabaseTitleError,
        whiteboard: $778018eca844ead1$var$i18n.duplicateTitleError,
        embed: $778018eca844ead1$var$i18n.duplicateEmbedTitleError
    },
    permissionsTooltip: {
        database: $778018eca844ead1$var$i18n.databasePermissionsTooltip,
        whiteboard: $778018eca844ead1$var$i18n.permissionsTooltip,
        embed: $778018eca844ead1$var$i18n.embedPermissionsTooltip
    },
    placeholder: {
        database: $778018eca844ead1$var$i18n.databaseTitlePlaceholder,
        embed: $778018eca844ead1$var$i18n.embedTitlePlaceholder,
        whiteboard: $778018eca844ead1$var$i18n.placeholder
    }
};
const $778018eca844ead1$var$height = '20px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$Title = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _k48p1wq8 _1bsb1ns9 _v7e5idpf _hpvwidpf _v9uvidpf _2aw0idpf _zaczidpf _152kidpf _pm1xidpf _1s7bidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // This needs to be a tagged template expression because @compiled isn't applying the `attr(data-value)`
const $778018eca844ead1$var$EditViewContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _szplfhey _1n6qd9x7 _10ku15vq _bdrc15vq _1kt9zxco _cfu11txw _w09a1osq _1y8lzdsj _1h3dgktf _9tn1qvpr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$TextViewContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { errorIcon: errorIcon, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _11twfhey _1lt8wu06 _1d6tgktf _15ffs4qr",
            __cmplp.errorIcon && "_clh8idpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $778018eca844ead1$var$readOnlyContainerStyles = (0, $ecnYn.xcss)({
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'space.250',
    maxWidth: '100%',
    paddingRight: 'space.075',
    paddingLeft: 'space.075',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'text',
    fontWeight: 'font.weight.bold',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $778018eca844ead1$var$readOnlyMobileAppStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'none',
    userSelect: 'none',
    touchAction: 'none'
});
const $778018eca844ead1$var$popupContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.200',
    color: 'color.text'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$ErrorIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _kqaxgktf _1expgktf _autin7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $778018eca844ead1$var$readOnlyTitleWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.025' //to match 2px transparent border on InlineEdit readView
});
const $778018eca844ead1$var$tooltipStyles = null; // same styles as a tooltip but with no width restriction to accommodate longer messages
const $778018eca844ead1$export$7574cd0e3a4be128 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ToolTipOverride(t0, ref) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_11q71aqn _2rkofajl _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12f1pna"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props || $[6] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
            ...props,
            ref: ref,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = ref;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
});
const $778018eca844ead1$var$spotlightWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
function $778018eca844ead1$var$onFocus(evt) {
    evt.target.select();
}
const $778018eca844ead1$export$42d61ec2afde455f = (t0)=>{
    const $ = (0, $frIzR.c)(85);
    const { title: title, contentId: contentId, spaceName: spaceName, readOnly: readOnly, updateContentTree: updateContentTree, contentType: contentType, onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler } = t0;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isMobileAppWhiteboard = isMobileApp && contentType === "whiteboard";
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== contentType || $[1] !== intl) {
        t1 = intl.formatMessage($778018eca844ead1$var$i18nByContentType.placeholder[contentType] || $778018eca844ead1$var$i18n.placeholder);
        $[0] = contentType;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    const placeholderText = t1;
    const { isEditing: isEditing, setIsEditing: setIsEditing, setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub, updateLoading: updateLoading, updateError: updateError, updateTitle: updateTitle, updateCache: updateCache } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    let t2;
    if ($[3] !== isEditing || $[4] !== setUpdatedTitleFromPubsub || $[5] !== updateCache || $[6] !== updateContentTree) {
        t2 = async (_aris, pubsubRequestBody)=>{
            const title_0 = pubsubRequestBody?.contentTitleUpdateRequestBody.contentTitle;
            if (!(0, $9wGTI.fg)("cc_fps_migration_content-title") || ![
                "DUAL",
                "GRAPHQL"
            ].includes((0, $4VJDS.default).getString("confluence-migrate-fps-to-graphql-subscription", ""))) {
                if (!isEditing) {
                    updateCache(title_0);
                    updateContentTree();
                    setUpdatedTitleFromPubsub(undefined);
                } else setUpdatedTitleFromPubsub(title_0);
            }
        };
        $[3] = isEditing;
        $[4] = setUpdatedTitleFromPubsub;
        $[5] = updateCache;
        $[6] = updateContentTree;
        $[7] = t2;
    } else t2 = $[7];
    const onPubSubEvent = t2;
    const t3 = `titleUpdated:${contentType}`;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $9wGTI.fg)("cc_fps_migration_content-title") && (0, $4VJDS.default).getString("confluence-migrate-fps-to-graphql-subscription", "") === "GRAPHQL";
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== contentId || $[10] !== contentType || $[11] !== onPubSubEvent || $[12] !== t3) {
        t5 = {
            contentId: contentId,
            contentType: contentType,
            eventName: t3,
            onEvent: onPubSubEvent,
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES,
            skip: t4
        };
        $[9] = contentId;
        $[10] = contentType;
        $[11] = onPubSubEvent;
        $[12] = t3;
        $[13] = t5;
    } else t5 = $[13];
    (0, $bT0se.usePubSubEvent)(t5);
    const [isTitleSpotlightActive, setIsTitleSpotlightActive] = (0, $42omo.useState)(false);
    let t6;
    let t7;
    if ($[14] !== contentType || $[15] !== createAnalyticsEvent || $[16] !== isTitleSpotlightActive) {
        t6 = ()=>{
            if (isTitleSpotlightActive) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingSpotlightScreen",
                    attributes: {
                        contentType: contentType,
                        spotlight: "spotlight-content-type-title"
                    },
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        t7 = [
            contentType,
            createAnalyticsEvent,
            isTitleSpotlightActive
        ];
        $[14] = contentType;
        $[15] = createAnalyticsEvent;
        $[16] = isTitleSpotlightActive;
        $[17] = t6;
        $[18] = t7;
    } else {
        t6 = $[17];
        t7 = $[18];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[19] !== registerShowTitleSpotlightHandler || $[20] !== setIsEditing) {
        t8 = ()=>{
            registerShowTitleSpotlightHandler?.(()=>{
                setIsEditing(true);
                setIsTitleSpotlightActive(true);
            });
        };
        t9 = [
            registerShowTitleSpotlightHandler,
            setIsEditing,
            setIsTitleSpotlightActive
        ];
        $[19] = registerShowTitleSpotlightHandler;
        $[20] = setIsEditing;
        $[21] = t8;
        $[22] = t9;
    } else {
        t8 = $[21];
        t9 = $[22];
    }
    (0, $42omo.useEffect)(t8, t9);
    let t10;
    if ($[23] !== isTitleSpotlightActive || $[24] !== onCloseTitleSpotlight) {
        t10 = ()=>{
            if (isTitleSpotlightActive) {
                setIsTitleSpotlightActive(false);
                onCloseTitleSpotlight?.();
            }
        };
        $[23] = isTitleSpotlightActive;
        $[24] = onCloseTitleSpotlight;
        $[25] = t10;
    } else t10 = $[25];
    const showNextSpotlight = t10;
    let t11;
    let t12;
    if ($[26] !== updateError) {
        t11 = ()=>{
            if (updateError && $778018eca844ead1$export$3e7822b6c7b36880(updateError)) (0, $7Sm4c.markErrorAsHandled)(updateError);
        };
        t12 = [
            updateError
        ];
        $[26] = updateError;
        $[27] = t11;
        $[28] = t12;
    } else {
        t11 = $[27];
        t12 = $[28];
    }
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    if ($[29] !== contentType || $[30] !== intl || $[31] !== placeholderText || $[32] !== updateError || $[33] !== updateLoading) {
        t13 = (t14)=>{
            const { errorMessage: errorMessage, ...fieldProps } = t14;
            const error = !!(fieldProps.isInvalid || updateError);
            const renderElemAfterInput = ()=>{
                if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$ErrorIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious",
                    label: "error"
                }));
                return null;
            };
            const renderErrorMessage = ()=>{
                if (fieldProps.isInvalid) return errorMessage;
                else {
                    if (updateError && $778018eca844ead1$export$3e7822b6c7b36880(updateError)) return intl.formatMessage($778018eca844ead1$var$i18nByContentType.duplicateTitleError[contentType] || $778018eca844ead1$var$i18n.duplicateTitleError);
                    else return intl.formatMessage($778018eca844ead1$var$i18n.generalError);
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$EditViewContainer, {
                "data-value": fieldProps.value
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$TextViewContainer, {
                errorIcon: error
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                autoFocus: false,
                isOpen: error,
                placement: "bottom-start",
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $778018eca844ead1$var$popupContainerStyles
                    }, renderErrorMessage()),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                        ...triggerProps,
                        ...fieldProps,
                        testId: "content-types-title-input",
                        width: "auto",
                        isCompact: true,
                        className: "text-field-input",
                        placeholder: placeholderText,
                        autoComplete: "off",
                        onFocus: $778018eca844ead1$var$onFocus,
                        autoFocus: true,
                        isDisabled: updateLoading,
                        isInvalid: error,
                        maxLength: $778018eca844ead1$export$f6d8ac9231e1baff + 1,
                        elemAfterInput: renderElemAfterInput()
                    }),
                shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-truedisco")
            })));
        };
        $[29] = contentType;
        $[30] = intl;
        $[31] = placeholderText;
        $[32] = updateError;
        $[33] = updateLoading;
        $[34] = t13;
    } else t13 = $[34];
    const renderEditView = t13;
    let t14;
    if ($[35] !== contentType || $[36] !== isMobileAppWhiteboard || $[37] !== readOnly || $[38] !== title) {
        t14 = ()=>{
            const permissionsMessage = $778018eca844ead1$var$i18nByContentType.permissionsTooltip[contentType] || $778018eca844ead1$var$i18n.permissionsTooltip;
            const message = readOnly ? permissionsMessage : $778018eca844ead1$var$i18n.renameTooltip;
            const TooltipComponent = isMobileAppWhiteboard ? (0, $42omo.Fragment) : (0, $3gadb.default);
            const tooltipProps = isMobileAppWhiteboard ? {
                content: undefined
            } : {
                component: $778018eca844ead1$export$7574cd0e3a4be128,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), message)
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TooltipComponent, tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $778018eca844ead1$var$readOnlyContainerStyles
            }, title));
        };
        $[35] = contentType;
        $[36] = isMobileAppWhiteboard;
        $[37] = readOnly;
        $[38] = title;
        $[39] = t14;
    } else t14 = $[39];
    const renderReadView = t14;
    let t15;
    if ($[40] !== intl) {
        t15 = (value)=>{
            if (!value || value.length === 0) return intl.formatMessage($778018eca844ead1$var$i18n.emptyTitleError);
            if (value.length > $778018eca844ead1$export$f6d8ac9231e1baff) return intl.formatMessage($778018eca844ead1$var$i18n.titleLengthError, {
                maxLength: $778018eca844ead1$export$f6d8ac9231e1baff
            });
        };
        $[40] = intl;
        $[41] = t15;
    } else t15 = $[41];
    const validateName = t15;
    let t16;
    if ($[42] !== contentId || $[43] !== createAnalyticsEvent || $[44] !== setIsEditing || $[45] !== spaceId) {
        t16 = ()=>{
            setIsEditing(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contentTypeHeaderTitle",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        $[42] = contentId;
        $[43] = createAnalyticsEvent;
        $[44] = setIsEditing;
        $[45] = spaceId;
        $[46] = t16;
    } else t16 = $[46];
    const onTitleEdit = t16;
    const { setOptimisticTitle: setOptimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, title);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    let t17;
    if ($[47] !== contentId || $[48] !== createAnalyticsEvent || $[49] !== setOptimisticTitle || $[50] !== showNextSpotlight || $[51] !== spaceId || $[52] !== updateContentTree || $[53] !== updateTimestampCache || $[54] !== updateTitle) {
        t17 = async (value_0)=>{
            await updateTitle(value_0);
            setOptimisticTitle(value_0);
            updateContentTree();
            if ((0, $9wGTI.fg)("confluence_frontend_content_wrapper")) updateTimestampCache({
                contentId: contentId
            });
            showNextSpotlight();
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "updated",
                    actionSubject: "contentTypeHeaderTitle",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        $[47] = contentId;
        $[48] = createAnalyticsEvent;
        $[49] = setOptimisticTitle;
        $[50] = showNextSpotlight;
        $[51] = spaceId;
        $[52] = updateContentTree;
        $[53] = updateTimestampCache;
        $[54] = updateTitle;
        $[55] = t17;
    } else t17 = $[55];
    const onTitleUpdate = t17;
    let t18;
    if ($[56] !== isEditing || $[57] !== onTitleEdit || $[58] !== onTitleUpdate || $[59] !== renderEditView || $[60] !== renderReadView || $[61] !== title || $[62] !== validateName) {
        t18 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lUjjs.default), {
                isEditing: isEditing,
                onEdit: onTitleEdit,
                validate: validateName,
                onConfirm: onTitleUpdate,
                defaultValue: title,
                editView: renderEditView,
                readView: renderReadView,
                hideActionButtons: true
            });
        $[56] = isEditing;
        $[57] = onTitleEdit;
        $[58] = onTitleUpdate;
        $[59] = renderEditView;
        $[60] = renderReadView;
        $[61] = title;
        $[62] = validateName;
        $[63] = t18;
    } else t18 = $[63];
    const renderInlineEdit = t18;
    let t19;
    if ($[64] !== isMobileAppWhiteboard || $[65] !== renderReadView) {
        t19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                testId: "content-types-title-read-only-view",
                xcss: [
                    $778018eca844ead1$var$readOnlyTitleWrapperStyles,
                    isMobileAppWhiteboard && $778018eca844ead1$var$readOnlyMobileAppStyles
                ]
            }, renderReadView());
        $[64] = isMobileAppWhiteboard;
        $[65] = renderReadView;
        $[66] = t19;
    } else t19 = $[66];
    const renderReadOnlyTitle = t19;
    let t20;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $5qUgM.CONTENT_TYPES_HEADER_TITLE_SEGMENT)
        });
        $[67] = t20;
    } else t20 = $[67];
    let t21;
    if ($[68] !== updateError) {
        t21 = updateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: updateError
        });
        $[68] = updateError;
        $[69] = t21;
    } else t21 = $[69];
    let t22;
    if ($[70] !== spaceName || $[71] !== title) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
            contentTitle: title,
            contentSpace: spaceName
        });
        $[70] = spaceName;
        $[71] = title;
        $[72] = t22;
    } else t22 = $[72];
    let t23;
    if ($[73] !== readOnly || $[74] !== renderInlineEdit || $[75] !== renderReadOnlyTitle) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$Title, null, readOnly ? renderReadOnlyTitle() : renderInlineEdit());
        $[73] = readOnly;
        $[74] = renderInlineEdit;
        $[75] = renderReadOnlyTitle;
        $[76] = t23;
    } else t23 = $[76];
    let t24;
    if ($[77] !== isTitleSpotlightActive) {
        t24 = isTitleSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $778018eca844ead1$var$spotlightWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91xA1.default), {
            key: "whiteboard-onboarding-title-target",
            width: 287
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $778018eca844ead1$var$i18n.onboardingSpotlightBody)));
        $[77] = isTitleSpotlightActive;
        $[78] = t24;
    } else t24 = $[78];
    let t25;
    if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            metric: (0, $5qUgM.CONTENT_TYPES_HEADER_TITLE_SEGMENT)
        });
        $[79] = t25;
    } else t25 = $[79];
    let t26;
    if ($[80] !== t21 || $[81] !== t22 || $[82] !== t23 || $[83] !== t24) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t20, t21, t22, t23, t24, t25);
        $[80] = t21;
        $[81] = t22;
        $[82] = t23;
        $[83] = t24;
        $[84] = t26;
    } else t26 = $[84];
    return t26;
};


const $4cb3eaaf01c9d693$export$dce52735e291d3da = {
    showMove: true,
    showArchive: true,
    showCopy: true,
    showBreadcrumbs: true,
    showFavourite: true,
    showShare: true,
    showMainActions: true,
    showMoreActions: true,
    showClassificationMenuAction: false,
    showContentRestrictions: true,
    showWatchDialog: true,
    showLastEdited: true,
    showPresence: true,
    showWhiteboardTeammate: true
};


const $71c531080fb6afdc$export$753f77420b5437b9 = ({ isSpaceOverviewPage: isSpaceOverviewPage, contentMode: contentMode, editorTitle: editorTitle, contentTitle: contentTitle })=>{
    if (isSpaceOverviewPage) // Pass an undefined string to contentTitle to prevent the breadcrumbs from rendering
    // a title when this is a Space Overview page
    return undefined;
    // intentionally exclude live mode, we want to return published content title since live mode publishes their title on every change
    if (contentMode === 'edit' || contentMode === 'draft') // pass the editorTitle as-is, even if it is an empty string (empty strings will be transformed into "Untitled")
    // pass in contentTitle if editorTitle is not available to prevent any breadcrumbs layout shifting during load (especially for drafts)
    return typeof editorTitle === 'string' ? editorTitle : typeof contentTitle === 'string' ? contentTitle : undefined;
    return contentTitle ?? undefined;
};









var $9vvQJ = parcelRequire("9vvQJ");


var $1qfLF = parcelRequire("1qfLF");


var $gqqjz = parcelRequire("gqqjz");





var $iAOfI = parcelRequire("iAOfI");


var $cxCWb = parcelRequire("cxCWb");





var $4c4ke = parcelRequire("4c4ke");


var $9SsRl = parcelRequire("9SsRl");


var $5EoFB = parcelRequire("5EoFB");


var $jLw6A = parcelRequire("jLw6A");








var $hAnPj = parcelRequire("hAnPj");





var $jFm04 = parcelRequire("jFm04");


var $3dPSK = parcelRequire("3dPSK");


var $2cKGu = parcelRequire("2cKGu");











var $4wEOc = parcelRequire("4wEOc");

'use no memo';
const $66bd5ba8343e39f0$var$isContentTypeApplicable = (contentType, isLivePage = false)=>{
    if (contentType === 'page' && isLivePage) return true;
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
const $66bd5ba8343e39f0$export$48cea123122bbc52 = (contentType, isLivePage = false, shouldSkipEnablementQuery = false)=>{
    const { isEnabled: isClassificationEnabledForOrg } = (0, $4wEOc.useIsDataClassificationEnabledForOrg)({
        skip: shouldSkipEnablementQuery
    });
    // when object header is enabled, it's enabled for all content types
    return ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || $66bd5ba8343e39f0$var$isContentTypeApplicable(contentType, isLivePage)) && isClassificationEnabledForOrg;
};









var $jeQ9x = parcelRequire("jeQ9x");














var $jypE9 = parcelRequire("jypE9");


var $dj7jL = parcelRequire("dj7jL");

var $1DfVr = parcelRequire("1DfVr");


var $gK1lf = parcelRequire("gK1lf");




const $0f9c0b3d7e5360a3$export$7c95b5e4cc9d3256 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $4VJDS.default).getString("confluence_page_preview_panel_testing", "");
        $[0] = t0;
    } else t0 = $[0];
    const previewPanelUrl = t0;
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE);
    const isOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    if (!previewPanelUrl) return null;
    let t1;
    if ($[1] !== closeConfluencePagePreviewPanel || $[2] !== isOpen || $[3] !== openConfluencePagePreviewPanel) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))),
            label: "Preview Panel Test",
            onClick: ()=>isOpen ? closeConfluencePagePreviewPanel() : openConfluencePagePreviewPanel(previewPanelUrl)
        });
        $[1] = closeConfluencePagePreviewPanel;
        $[2] = isOpen;
        $[3] = openConfluencePagePreviewPanel;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const previewPanelUrl = (0, $4VJDS.default).getString('confluence_page_preview_panel_testing', '');
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE);
    const isOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    if (!previewPanelUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))),
        label: "Preview Panel Test",
        onClick: ()=>isOpen ? closeConfluencePagePreviewPanel() : openConfluencePagePreviewPanel(previewPanelUrl)
    });
};



var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");


var $jmjWc = parcelRequire("jmjWc");


const $fc0e6c31b10b3145$export$ad537527a445740e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GFqC1",
    name: "AgentPresenceLoader",
    loader: async ()=>(await (parcelRequire("hg6fN"))).AgentPresence
});



var $6mKj3 = parcelRequire("6mKj3");


var $cxu5H = parcelRequire("cxu5H");


var $bjZbA = parcelRequire("bjZbA");


var $dA1Sn = parcelRequire("dA1Sn");


var $3o3i5 = parcelRequire("3o3i5");











var $1kaTo = parcelRequire("1kaTo");





var $8jTDW = parcelRequire("8jTDW");


var $imt6g = parcelRequire("imt6g");


var $jY68A = parcelRequire("jY68A");

var $5194c70d50ff0c56$export$cffcd5612128d7f0 = /*#__PURE__*/ function(ContentStatusName) {
    ContentStatusName["OFFLINE"] = "offline";
    ContentStatusName["SAVING"] = "saving";
    ContentStatusName["SAVED"] = "saved";
    ContentStatusName["HIDDEN"] = "hidden";
    return ContentStatusName;
}({});
const $5194c70d50ff0c56$var$Icons = {
    saved: (0, (/*@__PURE__*/$parcel$interopDefault($imt6g))),
    saving: (0, (/*@__PURE__*/$parcel$interopDefault($jY68A))),
    offline: (0, (/*@__PURE__*/$parcel$interopDefault($8jTDW)))
};
const $5194c70d50ff0c56$export$37094bddf66458ca = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { status: status, label: label } = t0;
    const Icon = $5194c70d50ff0c56$var$Icons[status];
    const t1 = `${status}-icon`;
    let t2;
    if ($[0] !== Icon || $[1] !== label || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            color: "var(--ds-icon-subtle, #505258)",
            label: label,
            testId: t1
        });
        $[0] = Icon;
        $[1] = label;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $5194c70d50ff0c56$export$437945b454cdf5e5 = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { contentStatus: contentStatus } = t0;
    const [inProp, setInProp] = (0, $42omo.useState)(false);
    const [currentStatus, setCurrentStatus] = (0, $42omo.useState)("hidden");
    let t1;
    if ($[0] !== contentStatus.status || $[1] !== currentStatus) {
        t1 = ()=>{
            setInProp(contentStatus.status !== currentStatus);
            setCurrentStatus(contentStatus.status);
        };
        $[0] = contentStatus.status;
        $[1] = currentStatus;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== contentStatus || $[4] !== currentStatus) {
        t2 = [
            contentStatus,
            currentStatus
        ];
        $[3] = contentStatus;
        $[4] = currentStatus;
        $[5] = t2;
    } else t2 = $[5];
    (0, $42omo.useEffect)(t1, t2);
    const t3 = `indicator-icon-${contentStatus.status}`;
    let t4;
    if ($[6] !== contentStatus.status || $[7] !== contentStatus.tooltipText) {
        t4 = contentStatus.status !== "hidden" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$var$IndicatorIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$export$37094bddf66458ca, {
            status: contentStatus.status,
            label: contentStatus.tooltipText
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-types-hidden-status"
        });
        $[6] = contentStatus.status;
        $[7] = contentStatus.tooltipText;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== currentStatus || $[10] !== inProp || $[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kaTo.default), {
            in: inProp,
            key: currentStatus,
            classNames: t3,
            timeout: 300
        }, t4);
        $[9] = currentStatus;
        $[10] = inProp;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== contentStatus.tooltipText || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$export$35212f567cb1e6e9, {
            "data-testid": "content-types-content-status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: contentStatus.tooltipText
        }, t5));
        $[14] = contentStatus.tooltipText;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
};
const $5194c70d50ff0c56$export$35212f567cb1e6e9 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2hwxu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5194c70d50ff0c56$var$IndicatorIconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkofajl _1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o _qn0x1fvh _x0eacs5v _1xlgidpf _r30bwdr0 _4u84cs5v _sapykb7n _10g31h7a _1abp1h6o _pc0t1fvh _ng5tkb7n _1x13kb7n _1u8zfnf5 _1omo1fvh _1hwbkb7n _py3nidpf _5r8x1fvh _1fb9t5al _1bytidpf _rdeb1xws _136x1xty _103wkb7n _zxs9kb7n _1kxwkb7n _1w6fidpf _1pci1fvh _1yg6kb7n _1svqfnf5 _eo5j163n _t44qymdr _1d1n12c5 _32o81h6o _4hkwkb7n _t095kb7n _1uc9kb7n _14t3163n _ozapymdr _1d0e12c5 _1xqi1h6o _1naj1fvh _2exnidpf _v68q163n _1m21ymdr _1cf012c5 _pcd11h6o _1cmokb7n _10f0kb7n _sycckb7n _7aw3163n _iz90ymdr _1owd12c5 _1a0w1h6o _11g8cs5v _1wq6idpf _st4e1u4m _1tgy1h6o _qadecs5v _1fk7idpf _1vdd1u4m _13ia1h6o _1sy1cs5v _yxttidpf _mkd3187n _zxim187n _1yh4a7yc _adowkb7n _2h9pzwfg _13pozwfg _138midpf _h9cnkb7n _xinxkb7n _irr3ysee",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});












var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48a5da156a2c7b78$var$StyledMainActions = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81nxw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $48a5da156a2c7b78$var$ConditionalWrapper = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
const $48a5da156a2c7b78$var$TooltipWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { mainAction: mainAction, children: children } = t0;
    const t1 = `${mainAction.id}-tooltip`;
    let t2;
    if ($[0] !== children || $[1] !== mainAction.tooltip || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: mainAction.tooltip,
            testId: t1
        }, children);
        $[0] = children;
        $[1] = mainAction.tooltip;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $48a5da156a2c7b78$export$a37ba60443eae06e = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { mainActions: mainActions } = t0;
    let t1;
    if ($[0] !== mainActions) {
        t1 = mainActions?.map($48a5da156a2c7b78$var$_temp);
        $[0] = mainActions;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $48a5da156a2c7b78$var$_temp(mainAction) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($48a5da156a2c7b78$var$StyledMainActions, {
        key: mainAction.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($48a5da156a2c7b78$var$ConditionalWrapper, {
        condition: mainAction.tooltip !== undefined,
        wrapper: (children)=>$48a5da156a2c7b78$var$TooltipWrapper({
                mainAction: mainAction,
                children: children
            })
    }, mainAction.buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        href: mainAction.buttonLink,
        appearance: mainAction.appearance,
        isSelected: mainAction.isSelected,
        onClick: mainAction.onClick,
        iconBefore: ()=>mainAction.icon,
        testId: mainAction.id,
        target: mainAction.openInNewTab ? "_blank" : "_self"
    }, mainAction.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: mainAction.appearance,
        isSelected: mainAction.isSelected,
        onClick: mainAction.onClick,
        iconBefore: ()=>mainAction.icon,
        testId: mainAction.id
    }, mainAction.text || mainAction.label)));
}






















var $4rwCt = parcelRequire("4rwCt");


var $6R5uz = parcelRequire("6R5uz");


var $1Zr9M = parcelRequire("1Zr9M");


var $4GKfl = parcelRequire("4GKfl");





var $fIcbd = parcelRequire("fIcbd");


var $6fjxX = parcelRequire("6fjxX");


var $1yB28 = parcelRequire("1yB28");





var $9VJDA = parcelRequire("9VJDA");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");













var $56M4r = parcelRequire("56M4r");


var $5tOl1 = parcelRequire("5tOl1");


var $eix0u = parcelRequire("eix0u");


var $4BqOc = parcelRequire("4BqOc");


var $isYda = parcelRequire("isYda");


var $fnaPh = parcelRequire("fnaPh");


var $kFjZK = parcelRequire("kFjZK");


var $9Q2dU = parcelRequire("9Q2dU");


var $3KUzn = parcelRequire("3KUzn");


var $ci7Ox = parcelRequire("ci7Ox");


var $kevJM = parcelRequire("kevJM");




var $2Fndw = parcelRequire("2Fndw");


var $avrhI = parcelRequire("avrhI");


var $kpYGL = parcelRequire("kpYGL");


var $9aGns = parcelRequire("9aGns");


var $jluld = parcelRequire("jluld");


var $fwDOR = parcelRequire("fwDOR");


var $bPdpL = parcelRequire("bPdpL");


var $isFEX = parcelRequire("isFEX");


var $4cOi8 = parcelRequire("4cOi8");


var $lJDEI = parcelRequire("lJDEI");


var $lvOsp = parcelRequire("lvOsp");





var $euL71 = parcelRequire("euL71");


var $gDbO8 = parcelRequire("gDbO8");





var $gEtAQ = parcelRequire("gEtAQ");





var $78wUU = parcelRequire("78wUU");


var $aYZaZ = parcelRequire("aYZaZ");


var $d8oE8 = parcelRequire("d8oE8");











var $6ykQV = parcelRequire("6ykQV");


var $eSLr0 = parcelRequire("eSLr0");


var $iEfsZ = parcelRequire("iEfsZ");


var $kxhju = parcelRequire("kxhju");


var $bHd1w = parcelRequire("bHd1w");


var $5FwhF = parcelRequire("5FwhF");


var $3J7TU = parcelRequire("3J7TU");














var $1Zthr = parcelRequire("1Zthr");


var $k22lL = parcelRequire("k22lL");


var $2WH1B = parcelRequire("2WH1B");


var $kRW4Y = parcelRequire("kRW4Y");


var $bQm3c = parcelRequire("bQm3c");





var $ln0hx = parcelRequire("ln0hx");

var $hjygH = parcelRequire("hjygH");



var $1kHsc = parcelRequire("1kHsc");


var $dcvq8 = parcelRequire("dcvq8");


var $c54hr = parcelRequire("c54hr");


var $aCrkK = parcelRequire("aCrkK");


var $5thep = parcelRequire("5thep");










const $ff966189b275be15$export$78b7a39935e0bb86 = (contentType, contentMode, isSpaceOverviewPage)=>{
    if (contentType === 'page' && !isSpaceOverviewPage) return contentMode === 'view';
    return false;
};
const $ff966189b275be15$export$a130e0ea03d42b0b = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$32820bf57e654cf8 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'edit';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$58a134bd2769b459 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'archived';
    else if (contentType === 'blogpost') return contentMode === 'view';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
const $ff966189b275be15$export$dec488a51a9b97f0 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'edit' || contentMode === 'draft';
    else if (contentType === 'blogpost') return contentMode === 'view' || contentMode === 'edit' || contentMode === 'draft';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$f7bde71715697ce0 = (contentType, contentMode, readOnly)=>{
    if (contentType === 'page') // Templates are always available on live/draft pages. For published (edit) pages we only expose
    // templates when `cc_snippets` is enabled.
    return contentMode === 'live' || contentMode === 'draft' || contentMode === 'edit' && (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false);
    if ((0, $1ggpj.isCanvasContentType)(contentType)) return !readOnly;
    return contentType === 'database' && contentMode !== 'archived' && !readOnly;
};
const $ff966189b275be15$export$a2eada40e8c9a2ed = (contentType, contentMode, isSpaceOverviewPage)=>{
    return (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'view' || contentMode === 'live') && !isSpaceOverviewPage;
};
const $ff966189b275be15$export$d790dfbcfcf44b71 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'edit' || contentMode === 'draft';
    return false;
};
const $ff966189b275be15$export$caca47bf68c8998 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' && !(0, $6mKj3.expVal)('confluence_content_history_updates', 'isEnabled', false) || contentMode === 'edit';
    else if (contentType === 'blogpost') return contentMode === 'edit';
    return false;
};
const $ff966189b275be15$export$71ad62dbe8638043 = (contentType, contentMode, hasEditPermission, livePageMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (!hasEditPermission) return false;
        if (contentType === 'page' && contentMode === 'live' && livePageMode === 'view') return false;
        return contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft';
    }
    return false;
};
const $ff966189b275be15$export$d0c33a26470e0efe = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode === 'edit';
    return false;
};
const $ff966189b275be15$export$493ddb7a4c710fed = (contentType, contentMode, isDeleteDraftAllowed, isAutoConvertedDraftRevertEnabled)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'edit' && isDeleteDraftAllowed) return true;
        else if (isAutoConvertedDraftRevertEnabled && contentType === 'page' && contentMode === 'draft') return true;
        else if (contentMode === 'view') return true;
    }
    return false;
};
const $ff966189b275be15$export$bb21210c1c36f22a = (contentType, contentMode, isSpaceOverviewPage)=>{
    if (contentType === 'page' && !isSpaceOverviewPage) return contentMode === 'view' || contentMode === 'live' || contentMode === 'archived';
    return false;
};
const $ff966189b275be15$export$49f8860e43af4419 = (contentType, contentMode)=>{
    return (contentType === 'page' || contentType === 'blogpost') && contentMode !== 'draft' && contentMode !== 'edit';
};
const $ff966189b275be15$export$8623af461a2f6a54 = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode === 'live' || contentMode === 'view';
    return false;
};
const $ff966189b275be15$export$46e46e0c15d57a1 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$1711931c27adfab0 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
const $ff966189b275be15$export$11233ac17765daec = (contentType)=>{
    return contentType === 'database' && !(0, $9wGTI.fg)('databases-frontend-content-wrapper') || contentType === 'embed';
};
const $ff966189b275be15$export$5e9136e7e220ab40 = (contentType)=>{
    if (contentType === 'page' || contentType === 'blogpost') // Classify content has moved to the details panel for all page & blogpost types
    return false;
    return contentType === 'database' && !(0, $9wGTI.fg)('databases-frontend-content-wrapper');
};
const $ff966189b275be15$export$3d371a49efa2fa0a = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode !== 'draft';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
const $ff966189b275be15$export$4a2abd609e31ae47 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType);
};
const $ff966189b275be15$export$37d144a1b557c80d = (contentType, contentMode)=>{
    return contentType === 'page' && contentMode === 'live';
};
const $ff966189b275be15$export$74e87e549c7a0f96 = (contentType, contentMode)=>{
    return (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'edit' || contentMode === 'draft');
};
const $ff966189b275be15$export$458bbd6d88041c9d = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'archived';
    else if (contentType === 'blogpost') return contentMode === 'view';
    return false;
};








const $1b70db1d5649f5f3$export$5dc260e4e702b5d0 = (contentType)=>{
    return ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database') && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments');
};









var $6hmtW = parcelRequire("6hmtW");


var $9BVDK = parcelRequire("9BVDK");


var $6eFi0 = parcelRequire("6eFi0");


var $2E1L5 = parcelRequire("2E1L5");


var $ai7NK = parcelRequire("ai7NK");


var $2kB0r = parcelRequire("2kB0r");

/* VersionHistoryOnboardingSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1lhEF = parcelRequire("1lhEF");





var $dh538 = parcelRequire("dh538");

// These custom styles are neccessary so the SpotlightPulse doesn't get cut off by the bounds of the menu.
const $330cc2928c11abea$var$spotlightStyles = null; // Migrated pulse animation styles matching the original SpotlightPulse behavior
const $330cc2928c11abea$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $330cc2928c11abea$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $330cc2928c11abea$var$pulseKeyframes = null;
const $330cc2928c11abea$var$pulseAnimationStyles = null;
const $330cc2928c11abea$export$cf692ceb431cd214 = ({ children: children, contentType: contentType, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'versionHistorySpotlightPulse',
                attributes: {
                    source: source,
                    objectType: contentType
                }
            }
        }).fire(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $dh538.fg)('confluence_frontend_spolitlight_ads_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "version-history-spotlight-pulse",
        className: (0, $gMc0m.default)([
            "_2rko12b0 _5sagi11n _tip812c5 _j7hqfamb _1pglmcjr _16qs1peg _18u0v77o _2hwxv77o _1bumglyw _sedtglyw"
        ])
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
        "data-testId": "version-history-spotlight-pulse",
        radius: 3,
        className: (0, $gMc0m.default)([
            "_18u0v77o _2hwxv77o"
        ])
    }, children);
};



var $5KL6w = parcelRequire("5KL6w");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $4GDP8 = parcelRequire("4GDP8");


var $7J5Uc = parcelRequire("7J5Uc");


var $5yVAS = parcelRequire("5yVAS");


var $4ZXww = parcelRequire("4ZXww");


var $bzwhi = parcelRequire("bzwhi");





var $3eMfQ = parcelRequire("3eMfQ");


var $foQ4a = parcelRequire("foQ4a");





const $c06b6cca0a728bb0$export$154e7cde95b8409b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-pxiH",
    name: "LazyWatchSettingsOverflowMenuShortcut",
    loader: async ()=>(await (parcelRequire("lQ86k"))).WatchSettingsOverflowMenuShortcut
});


/**
 * @graphql cc
 */ 













var $eSUdr = parcelRequire("eSUdr");















var $8cjip = parcelRequire("8cjip");


var $fCjCI = parcelRequire("fCjCI");





var $1o4fX = parcelRequire("1o4fX");





var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $1uFM6 = parcelRequire("1uFM6");





var $8Lx5S = parcelRequire("8Lx5S");





var $f9HtC = parcelRequire("f9HtC");








var $7aRa9 = parcelRequire("7aRa9");




/**
 * @graphql cc
 */ 





















var $3pU8m = parcelRequire("3pU8m");

var $fKL7x = parcelRequire("fKL7x");




















var $jle6C = parcelRequire("jle6C");

const $d49593a2f9070b10$var$i18n = (0, $cgtv4.defineMessages)({
    watchThisContent: {
        id: "watch-dialog.overflow-menu.watch-this-content",
        defaultMessage: "Watch this content"
    },
    watchChildItems: {
        id: "watch-dialog.overflow-menu.watch-child-items",
        defaultMessage: "Watch child items"
    },
    watchNewBlogposts: {
        id: "watch-dialog.overflow-menu.watch-new-blog-posts",
        defaultMessage: "Watch new blog posts"
    },
    watchAllContent: {
        id: "watch-dialog.overflow-menu.watch-all-content",
        defaultMessage: "Watch all content in this space"
    },
    watchingContentTitle: {
        id: "watch-dialog.overflow-menu.watching-content-flag-title",
        defaultMessage: "You\u2019re watching this content"
    },
    watchingContentDescription: {
        id: "watch-dialog.overflow-menu.watching-content-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to it."
    },
    watchingWhiteboardTitle: {
        id: "watch-dialog.overflow-menu.watching-whiteboard-flag-title",
        defaultMessage: "You\u2019re watching this whiteboard"
    },
    watchingWhiteboardDescription: {
        id: "watch-dialog.overflow-menu.watching-whiteboard-flag-description",
        defaultMessage: "You\u2019ll receive email updates about mentions and comment replies."
    },
    watchingDatabaseTitle: {
        id: "watch-dialog.overflow-menu.watching-database-flag-title",
        defaultMessage: "You\u2019re watching this database"
    },
    watchingDatabaseDescription: {
        id: "watch-dialog.overflow-menu.watching-database-flag-description",
        defaultMessage: "You\u2019ll receive email updates about mentions and comment replies."
    },
    stoppedWatchingContentTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-content-flag-title",
        defaultMessage: "You stopped watching this content"
    },
    stoppedWatchingContentDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-content-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to it."
    },
    stoppedWatchingWhiteboardTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-whiteboard-flag-title",
        defaultMessage: "You stopped watching this whiteboard"
    },
    stoppedWatchingWhiteboardDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-whiteboard-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about mentions and comment replies."
    },
    stoppedWatchingDatabaseTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-database-flag-title",
        defaultMessage: "You stopped watching this database"
    },
    stoppedWatchingDatabaseDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-database-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about mentions and comment replies."
    },
    watchingSlideTitle: {
        id: "watch-dialog.overflow-menu.watching-slide-flag-title",
        defaultMessage: "You\u2019re watching this slide"
    },
    watchingSlideDescription: {
        id: "watch-dialog.overflow-menu.watching-slide-flag-description",
        defaultMessage: "You\u2019ll receive email updates about mentions and comment replies."
    },
    stoppedWatchingSlideTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-slide-flag-title",
        defaultMessage: "You stopped watching this slide"
    },
    stoppedWatchingSlideDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-slide-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about mentions and comment replies."
    },
    watchingNewBlogpostsTitle: {
        id: "watch-dialog.overflow-menu.watching-blogs-flag-title",
        defaultMessage: "You\u2019re watching for new blog posts"
    },
    watchingNewBlogpostsDescription: {
        id: "watch-dialog.overflow-menu.watching-blogs-flag-description",
        defaultMessage: "You\u2019ll receive email updates about new blog posts in this space."
    },
    stoppedWatchingBlogpostsTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-blogs-flag-title",
        defaultMessage: "You stopped watching for new blog posts"
    },
    stoppedWatchingBlogpostsDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-blogs-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about new blog posts in this space."
    },
    watchSpaceTitle: {
        id: "watch-dialog.overflow-menu.watching-space-flag-title",
        defaultMessage: "You\u2019re watching content in this space"
    },
    watchSpaceDescription: {
        id: "watch-dialog.overflow-menu.watching-space-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to content in this space."
    },
    stoppedWatchingSpaceTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-space-flag-title",
        defaultMessage: "You stopped watching content in this space"
    },
    stoppedWatchingSpaceDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-space-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to content in this space."
    },
    watchChildrenTitle: {
        id: "watch-dialog.overflow-menu.watching-children-flag-title",
        defaultMessage: "You\u2019re watching child items"
    },
    watchChildrenDescription: {
        id: "watch-dialog.overflow-menu.watching-children-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to this content\u2019s child items."
    },
    stoppedWatchingChildrenTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-children-flag-title",
        defaultMessage: "You stopped watching child items"
    },
    stoppedWatchingChildrenDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-children-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to this content\u2019s child items."
    },
    ancestorWatchStatus: {
        id: "watch-dialog.overflow-menu.ancestor-watch-status",
        defaultMessage: "You watch all items under a parent of this content. Adjust its settings anytime."
    }
});
const $d49593a2f9070b10$var$ancestorWatchStatusContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingRight: 'space.200',
    paddingLeft: 'space.200',
    maxWidth: '270px',
    font: 'font.body.small'
});
const $d49593a2f9070b10$var$AncestorWatchStatus = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d49593a2f9070b10$var$ancestorWatchStatusContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.ancestorWatchStatus));
};
const $d49593a2f9070b10$export$aa1e7bb13f611ba0 = ({ isCurrentUserWatching: isCurrentUserWatching, isWatchingSpace: isWatchingSpace, isWatchingBlogs: isWatchingBlogs, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, contentType: contentType, contentId: contentId, spaceId: spaceId, updateQueryHandler: updateQueryHandler, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isCurrentUserWatchingContent, setIsCurrentUserWatchingContent] = (0, $42omo.useState)(isCurrentUserWatching);
    const [isCurrentUserWatchingBlogs, setIsCurrentUserWatchingBlogs] = (0, $42omo.useState)(isWatchingBlogs);
    const [isCurrentUserWatchingSpace, setIsCurrentUserWatchingSpace] = (0, $42omo.useState)(isWatchingSpace);
    const [isCurrentUserWatchingChildren, setIsCurrentUserWatchingChildren] = (0, $42omo.useState)(isWatchingChildren);
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isWatchChildrenRendered = contentType !== 'blogpost' && !isSpaceOverviewPage;
    const watchContentTitleI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.watchingWhiteboardTitle,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.watchingDatabaseTitle,
        [(0, $1ggpj.ContentType).SLIDE]: $d49593a2f9070b10$var$i18n.watchingSlideTitle,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.watchingContentTitle,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.watchingContentTitle
    };
    const watchContentDescriptionI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.watchingWhiteboardDescription,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.watchingDatabaseDescription,
        [(0, $1ggpj.ContentType).SLIDE]: $d49593a2f9070b10$var$i18n.watchingSlideDescription,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.watchingContentDescription,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.watchingContentDescription
    };
    const stoppedWatchingContentTitleI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.stoppedWatchingWhiteboardTitle,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.stoppedWatchingDatabaseTitle,
        [(0, $1ggpj.ContentType).SLIDE]: $d49593a2f9070b10$var$i18n.stoppedWatchingSlideTitle,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentTitle,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentTitle
    };
    const stoppedWatchingContentDescriptionI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.stoppedWatchingWhiteboardDescription,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.stoppedWatchingDatabaseDescription,
        [(0, $1ggpj.ContentType).SLIDE]: $d49593a2f9070b10$var$i18n.stoppedWatchingSlideDescription,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentDescription,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentDescription
    };
    const fireWatchAnalyticsEvent = (action, actionSubject)=>{
        const isActionSubjectSpace = actionSubject === (0, $jle6C.UpdateContentType).SPACE;
        const contentObjectMetadata = {
            objectId: isActionSubjectSpace ? spaceId : contentId,
            objectType: isActionSubjectSpace ? 'space' : contentType
        };
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            source: 'overflowMenu',
            attributes: {
                componentVersion: 'v2'
            },
            ...contentObjectMetadata
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    };
    const [watchContentMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchContentMutation($id:ID!){watchContent(watchContentInput:{contentId:$id currentUser:true}){content{id currentUserIsWatching}}}`, {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CONTENT, data?.watchContent?.content?.currentUserIsWatching);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
            const titleI18n = watchContentTitleI18nMap[contentType];
            const descriptionI18n = watchContentDescriptionI18nMap[contentType];
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-content-success',
                title: formatMessage(titleI18n),
                description: formatMessage(descriptionI18n),
                isAutoDismiss: true
            });
        }
    });
    const [unwatchContentMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation($id:ID!){unwatchContent(watchContentInput:{contentId:$id currentUser:true}){content{id currentUserIsWatching}}}`, {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CONTENT, data?.unwatchContent?.content?.currentUserIsWatching);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).CONTENT);
            const titleI18n = stoppedWatchingContentTitleI18nMap[contentType];
            const descriptionI18n = stoppedWatchingContentDescriptionI18nMap[contentType];
            flags.showSuccessCircleFlag({
                id: `overflow-menu.watch-settings.stopped-watching-content-success`,
                title: formatMessage(titleI18n),
                description: formatMessage(descriptionI18n),
                isAutoDismiss: true
            });
        }
    });
    const [watchBlogsMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation($spaceId:ID!){watchBlogs(watchSpaceInput:{spaceId:$spaceId currentUser:true}){space{id currentUser{isWatchingBlogs}}}}`, {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).BLOGS_IN_SPACE, data?.watchBlogs?.space?.currentUser?.isWatchingBlogs);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-blogs-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchingNewBlogpostsTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchingNewBlogpostsDescription),
                isAutoDismiss: true
            });
        }
    });
    const [unwatchBlogsMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation($spaceId:ID!){unwatchBlogs(watchSpaceInput:{spaceId:$spaceId currentUser:true}){space{id currentUser{isWatchingBlogs}}}}`, {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).BLOGS_IN_SPACE, data?.unwatchBlogs?.space?.currentUser?.isWatchingBlogs);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.unwatch-blogs-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingBlogpostsTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingBlogpostsDescription),
                isAutoDismiss: true
            });
        }
    });
    const [watchSpaceMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation($spaceId:ID!){watchSpace(watchSpaceInput:{spaceId:$spaceId currentUser:true}){space{id currentUser{isWatched}}}}`, {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).SPACE, data?.watchSpace?.space?.currentUser?.isWatched);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-space-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchSpaceTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchSpaceDescription),
                isAutoDismiss: true
            });
        }
    });
    const [unwatchSpaceMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation($spaceId:ID!){unwatchSpace(watchSpaceInput:{spaceId:$spaceId currentUser:true}){space{id currentUser{isWatched}}}}`, {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).SPACE, data?.unwatchSpace?.space?.currentUser?.isWatched);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.unwatch-space-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingSpaceTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingSpaceDescription),
                isAutoDismiss: true
            });
        }
    });
    const [watchChildrenMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation($id:ID!$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id currentUser:true includeChildren:$includeChildren}){content{id currentUserIsWatchingChildren}}}`, {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CHILDREN, data?.watchContent?.content.currentUserIsWatchingChildren);
        },
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
                attributes: {
                    startWatchingChildren: true,
                    contentType: contentType
                }
            });
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CHILDREN);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-children-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchChildrenTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchChildrenDescription),
                isAutoDismiss: true
            });
        },
        onError: (mutationError)=>{
            handleWatchChildrenError(mutationError, true);
        }
    });
    const [unwatchChildrenMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation($id:ID!$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id currentUser:true includeChildren:$includeChildren}){content{id currentUserIsWatchingChildren}}}`, {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CHILDREN, data?.watchContent?.content.currentUserIsWatchingChildren);
        },
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
                attributes: {
                    startWatchingChildren: false,
                    contentType: contentType
                }
            });
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).CHILDREN);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.stopped-watching-children-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingChildrenTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingChildrenDescription),
                isAutoDismiss: true
            });
        },
        onError: (mutationError)=>{
            handleWatchChildrenError(mutationError, false);
        }
    });
    const handleWatchChildrenError = (mutationError, startWatchingChildren)=>{
        if ((0, $1uFM6.isUnauthorizedError)(mutationError)) experienceTracker.abort({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            reason: mutationError.message,
            attributes: {
                startWatchingChildren: startWatchingChildren,
                contentType: contentType,
                isUnauthorized: true
            }
        });
        else experienceTracker.fail({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            error: mutationError.message,
            attributes: {
                startWatchingChildren: startWatchingChildren,
                contentType: contentType
            }
        });
    };
    const onWatchContentChange = (0, $42omo.useCallback)(async ()=>{
        if (isCurrentUserWatchingContent) {
            await unwatchContentMutation({
                variables: {
                    id: contentId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    unwatchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatching: false
                        }
                    }
                }
            });
            setIsCurrentUserWatchingContent(false);
        } else {
            await watchContentMutation({
                variables: {
                    id: contentId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatching: true
                        }
                    }
                }
            });
            setIsCurrentUserWatchingContent(true);
        }
    }, [
        isCurrentUserWatchingContent,
        contentId,
        unwatchContentMutation,
        watchContentMutation
    ]);
    const onWatchBlogpostsChange = (0, $42omo.useCallback)(async ()=>{
        if (isCurrentUserWatchingBlogs) {
            await unwatchBlogsMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    unwatchBlogs: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                __typename: 'SpaceUserMetadata',
                                isWatchingBlogs: false
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingBlogs(false);
        } else {
            await watchBlogsMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchBlogs: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                __typename: 'SpaceUserMetadata',
                                isWatchingBlogs: true
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingBlogs(true);
        }
    }, [
        isCurrentUserWatchingBlogs,
        spaceId,
        unwatchBlogsMutation,
        watchBlogsMutation
    ]);
    const onWatchSpaceChange = (0, $42omo.useCallback)(async ()=>{
        if (isCurrentUserWatchingSpace) {
            await unwatchSpaceMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    unwatchSpace: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                __typename: 'SpaceUserMetadata',
                                isWatched: false
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingSpace(false);
        } else {
            await watchSpaceMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchSpace: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                __typename: 'SpaceUserMetadata',
                                isWatched: true
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingSpace(true);
        }
    }, [
        isCurrentUserWatchingSpace,
        spaceId,
        unwatchSpaceMutation,
        watchSpaceMutation
    ]);
    const onWatchChildrenChange = (0, $42omo.useCallback)(async ()=>{
        experienceTracker.start({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            attributes: {
                startWatchingChildren: !isCurrentUserWatchingChildren,
                contentType: contentType
            }
        });
        if (isCurrentUserWatchingChildren) {
            await unwatchChildrenMutation({
                variables: {
                    id: contentId,
                    includeChildren: false
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatchingChildren: false
                        }
                    }
                }
            });
            setIsCurrentUserWatchingChildren(false);
        } else {
            await watchChildrenMutation({
                variables: {
                    id: contentId,
                    includeChildren: true
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatchingChildren: true
                        }
                    }
                }
            });
            setIsCurrentUserWatchingChildren(true);
        }
    }, [
        isCurrentUserWatchingChildren,
        contentId,
        unwatchChildrenMutation,
        watchChildrenMutation,
        contentType,
        experienceTracker
    ]);
    const watchContentCheckbox = ()=>{
        const isImplicitlyWatching = isWatchingSpace || hasAncestorWatchingChildren || isWatchingChildren;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pU8m.default), {
            id: "watch-this-content-option",
            testId: "watch-this-content-option",
            isSelected: isCurrentUserWatching || isImplicitlyWatching,
            isDisabled: isImplicitlyWatching,
            onClick: onWatchContentChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.watchThisContent));
    };
    const watchBlogpostsCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pU8m.default), {
            id: "watch-blogs-option",
            testId: "watch-blogs-option",
            isSelected: isWatchingBlogs || isWatchingSpace,
            isDisabled: isWatchingSpace,
            onClick: onWatchBlogpostsChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.watchNewBlogposts));
    };
    const watchChildrenCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pU8m.default), {
            id: "watch-children-option",
            testId: "watch-children-option",
            isSelected: hasAncestorWatchingChildren || isWatchingSpace || isWatchingChildren,
            isDisabled: hasAncestorWatchingChildren || isWatchingSpace,
            onClick: onWatchChildrenChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.watchChildItems));
    };
    const watchSpaceCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pU8m.default), {
            id: "watch-all-content-option",
            testId: "watch-all-content-option",
            isSelected: isWatchingSpace,
            onClick: onWatchSpaceChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.watchAllContent));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fKL7x.default), {
        id: "overflow-menu-watch-settings"
    }, hasAncestorWatchingChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d49593a2f9070b10$var$AncestorWatchStatus, null), watchContentCheckbox(), isSpaceOverviewPage && watchBlogpostsCheckbox(), isWatchChildrenRendered && watchChildrenCheckbox(), watchSpaceCheckbox());
};






var $gqsYd = parcelRequire("gqsYd");


var $pskhd = parcelRequire("pskhd");


var $49Q03 = parcelRequire("49Q03");

const $8b864d3fa23503bf$var$i18n = (0, $cgtv4.defineMessages)({
    watchSettings: {
        id: "watch-dialog.overflow-menu.watch-settings",
        defaultMessage: "Watch settings"
    },
    manageWatchers: {
        id: "watch-dialog.overflow-menu.manage-watchers",
        defaultMessage: "Manage watchers"
    },
    watchingIconLabel: {
        id: "watch-dialog.overflow-menu.watching-icon-label",
        defaultMessage: "Watching content"
    },
    notWatchingIconLabel: {
        id: "watch-dialog.overflow-menu.not-watching-icon-label",
        defaultMessage: "Not watching content"
    }
});
var $8b864d3fa23503bf$export$f216106e034bc0b0 = /*#__PURE__*/ function(WatchSettingsRadioOption) {
    WatchSettingsRadioOption["Unwatch"] = "unwatch";
    WatchSettingsRadioOption["ThisItem"] = "this-item";
    WatchSettingsRadioOption["ThisAndNewItems"] = "this-and-new-items";
    WatchSettingsRadioOption["AllContent"] = "all-content";
    return WatchSettingsRadioOption;
}({});
const $8b864d3fa23503bf$export$465e1505ba3dc1c5 = ({ isMenuOpen: isMenuOpen, contentId: contentId, contentType: contentType, spaceId: spaceId = '', spaceKey: spaceKey, setIsMenuOpen: setIsMenuOpen, flags: flags, onMenuClose: onMenuClose, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const updateQueryHandler = (watchTarget, newDataValue)=>{
        const contentData = (0, $l1uFv.readQueryInterop)({
            query: (0, $49Q03.WatchDialogComponentWithWatchChildrenQuery),
            variables: {
                contentId: contentId
            }
        });
        switch(watchTarget){
            case (0, $jle6C.UpdateContentType).CONTENT:
                if (contentData?.singleContent) contentData.singleContent.currentUserIsWatching = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).CHILDREN:
                if (contentData?.singleContent) contentData.singleContent.currentUserIsWatchingChildren = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).SPACE:
                if (contentData?.singleContent?.space) contentData.singleContent.space.currentUser.isWatched = newDataValue;
                break;
            default:
                if (contentData?.singleContent?.space) contentData.singleContent.space.currentUser.isWatchingBlogs = newDataValue;
                break;
        }
        if (contentData) (0, $fEmGS.writeQueryInterop)({
            query: (0, $49Q03.WatchDialogComponentWithWatchChildrenQuery),
            data: contentData
        });
    };
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const isWatchEnabled = isLicensed || isGuest;
    const { data: watchDialogData, error: watchDialogError, loading: watchDialogDataLoading } = (0, $jMyy4.useQueryInterop)((0, $49Q03.WatchDialogComponentWithWatchChildrenQuery), {
        variables: {
            contentId: contentId
        },
        skip: !isWatchEnabled,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const { isCurrentUserWatching: isCurrentUserWatching, isWatchingSpace: isWatchingSpace, isWatchingBlogs: isWatchingBlogs, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren } = (0, $pskhd.processWatchData)(watchDialogData);
    const isWatching = isWatchEnabled && (isCurrentUserWatching || isWatchingSpace);
    const { data: watchSettingsTrialDetailsData, error: watchSettingsTrialDetailsError } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query WatchSettingsItemTrialDetailsQuery{license{trialEndDate}}`, {
        skip: !isWatchEnabled || edition === (0, $gqsYd.CONFLUENCE_EDITION).FREE,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const handleWatchSettingsItemClick = (0, $42omo.useCallback)(()=>{
        onClick();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'content-watch-button',
                attributes: {
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                },
                source: 'overflowMenu'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const makeHandleManageWatchersClickHandler = (dialogs)=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'ManageWatcherDialogButton',
                    source: 'overflowMenu',
                    attributes: {
                        source: 'v2',
                        isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                    }
                }
            }).fire();
            dialogs.showDialog((0, $f9HtC.ManageWatcherDialogLoader), {
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                contentType: contentType,
                defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE
            });
            setIsMenuOpen(false);
        };
    };
    const isSpaceAdmin = watchDialogData?.singleContent?.space?.operations?.some((op)=>op?.operation === 'administer') ?? false;
    let inTrial = false;
    if (watchSettingsTrialDetailsError) inTrial = true;
    else {
        const trialEndDate = watchSettingsTrialDetailsData?.license?.trialEndDate;
        if (trialEndDate) {
            const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialEndDate) ?? null;
            inTrial = trialDaysLeft !== null && trialDaysLeft > 0;
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        placement: "left-start",
        isOpen: isMenuOpen,
        onOpenChange: ({ isOpen: isOpen })=>{
            if (!isOpen) onMenuClose();
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                ...triggerProps,
                ref: triggerRef,
                isDisabled: !isWatchEnabled || watchDialogDataLoading,
                elemBefore: isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))), {
                    label: formatMessage($8b864d3fa23503bf$var$i18n.watchingIconLabel)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
                    label: formatMessage($8b864d3fa23503bf$var$i18n.notWatchingIconLabel)
                }),
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    size: "small"
                }),
                testId: "nested-watch-menu-trigger",
                onClick: handleWatchSettingsItemClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8b864d3fa23503bf$var$i18n.watchSettings))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d49593a2f9070b10$export$aa1e7bb13f611ba0), {
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingSpace: isWatchingSpace,
        isWatchingBlogs: isWatchingBlogs,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren,
        contentId: contentId,
        contentType: contentType,
        spaceId: spaceId,
        updateQueryHandler: updateQueryHandler,
        flags: flags
    }), isSpaceAdmin && edition !== (0, $gqsYd.CONFLUENCE_EDITION).FREE && !inTrial && !watchDialogError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: makeHandleManageWatchersClickHandler(dialogs)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8b864d3fa23503bf$var$i18n.manageWatchers)))));
};
const $8b864d3fa23503bf$export$f9409fd8f8b5a92d = (0, $7aRa9.withFlags)($8b864d3fa23503bf$export$465e1505ba3dc1c5);


/**
 * @generated SignedSource<<aa028ee47ad368b7283e2b69db29abfe>>
 * @relayHash b73eeb07332d614a1e170c288004fb18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f2683e6eae220f79d199a910afd2dcf7eb08534396a7873f206554f42cea781
const $1acaf91cfec33c88$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "contentOperations",
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavouriteMenuItemQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavouriteMenuItemQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "b73eeb07332d614a1e170c288004fb18",
            "id": "1f2683e6eae220f79d199a910afd2dcf7eb08534396a7873f206554f42cea781",
            "metadata": {},
            "name": "FavouriteMenuItemQuery",
            "operationKind": "query",
            "text": "query FavouriteMenuItemQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
        }
    };
}();
$1acaf91cfec33c88$var$node.hash = "b2cb562e5c9d7e229a13677a47c445f2";
var $1acaf91cfec33c88$export$2e2bcd8739ae039 = $1acaf91cfec33c88$var$node;



































var $77a1U = parcelRequire("77a1U");

var $cf6nm = parcelRequire("cf6nm");




/**
 * @generated SignedSource<<642c3d33e174f011359216d3b6b2c1c5>>
 * @relayHash 87747e14238de77ee6b608c3fa7ceb25
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e83b49a9735e1da791b68dbd15f5e410431ed040eea10f46b8a29d51d7d64974
const $acbeb5139d925032$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "contentOperations",
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavouriteContentShortcutListenerQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavouriteContentShortcutListenerQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "87747e14238de77ee6b608c3fa7ceb25",
            "id": "e83b49a9735e1da791b68dbd15f5e410431ed040eea10f46b8a29d51d7d64974",
            "metadata": {},
            "name": "FavouriteContentShortcutListenerQuery",
            "operationKind": "query",
            "text": "query FavouriteContentShortcutListenerQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
        }
    };
}();
$acbeb5139d925032$var$node.hash = "6ff7d72d61283f21b554c99c3279a8f9";
var $acbeb5139d925032$export$2e2bcd8739ae039 = $acbeb5139d925032$var$node;




















const $85cfaddd6945fc1f$var$getStarShortcut = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft') return {
            deprecatedAccelerator: undefined,
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
        };
        else if (contentMode === 'view') return {
            deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
        };
        else return {
            deprecatedAccelerator: undefined,
            accelerator: undefined
        };
    } else // for all other content types, use both keyboard shortcuts
    return {
        deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
    };
};
const $85cfaddd6945fc1f$export$380f18fd66f69c3e = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft' || contentMode === 'view') return 0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT;
        else return null;
    } else return 0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT;
};
const $85cfaddd6945fc1f$export$2846eba8e457bfb = ({ contentId: contentId, contentTitle: contentTitle, contentMode: contentMode, contentType: contentType, source: source = 'FavouriteMoreActionsMenuItem' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator } = $85cfaddd6945fc1f$var$getStarShortcut(contentType, contentMode);
    const FavouriteContentShortcutListenerQuery = (0, $acbeb5139d925032$export$2e2bcd8739ae039);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(FavouriteContentShortcutListenerQuery, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-first'
    });
    if (loading || error || !accelerator) return null;
    const isStarred = Boolean(data?.singleContent?.metadata.currentuser?.favourited?.isFavourite);
    const handleShortcut = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: true,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft'
                    },
                    source: source
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $77a1U.PageStar), {
        contentId: contentId,
        isStarred: isStarred,
        contentTitle: contentTitle,
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: deprecatedAccelerator,
            accelerator: accelerator,
            listener: handleShortcut(toggleStar)
        }));
};


// This component is a dropdown menu item version of the favorite page star button. It is completely standalone and queries for it's own isFavourited data.
// It does not include any shortcut listener and should be used in conjunction with FavouriteContentShortcutListener.tsx if you need to add a listener.
// It is currently used in the page header more actions menu item
const $daed94f8e5673bda$var$FavouriteMenuItemQuery = (0, $1acaf91cfec33c88$export$2e2bcd8739ae039);
const $daed94f8e5673bda$export$ab53347da13f94fa = ({ contentId: contentId, contentTitle: contentTitle, contentMode: contentMode })=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($daed94f8e5673bda$var$FavouriteMenuItemQuery, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-first'
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    const isStarred = Boolean(data?.singleContent?.metadata.currentuser?.favourited?.isFavourite);
    const contentType = data?.singleContent?.type;
    const shortcut = (0, $85cfaddd6945fc1f$export$380f18fd66f69c3e)(contentType || '', contentMode);
    const handleClick = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: false,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft',
                        isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') // for now, this will always be true since FavouriteMenuItem is only used in Content Wrapper as of now
                    },
                    source: 'FavouriteMoreActionsMenuItem'
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $77a1U.PageStar), {
        contentId: contentId,
        isStarred: isStarred,
        contentTitle: contentTitle,
        analytics: {
            source: 'FavouriteMoreActionsMenuItem',
            attributes: {
                componentVersion: 'more-actions-menu-item',
                pageType: contentType
            }
        },
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: handleClick(toggleStar),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf6nm.StarIcon), {
                isStarred: isStarred,
                spacing: "none"
            }),
            elemAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: shortcut
            }),
            isDisabled: !isLoggedIn
        }, isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $daed94f8e5673bda$var$i18n.unstar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $daed94f8e5673bda$var$i18n.star))));
};
const $daed94f8e5673bda$var$i18n = (0, $cgtv4.defineMessages)({
    star: {
        id: "favourite-button.content.star.label",
        defaultMessage: "Star"
    },
    unstar: {
        id: "favourite-button.content.unstar.label",
        defaultMessage: "Unstar"
    }
});




var $kPqqM = parcelRequire("kPqqM");
/**
 * @generated SignedSource<<8d9de81b4d3b896f32ad1a009badc1e1>>
 * @relayHash c27dc099805c7eec7a9354a821bd73cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 717eb51b235f5f25635e4ecef7a7a139da3e0a671a31ec57022615806587618b
const $92084701ec630418$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c27dc099805c7eec7a9354a821bd73cc",
            "id": "717eb51b235f5f25635e4ecef7a7a139da3e0a671a31ec57022615806587618b",
            "metadata": {},
            "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
            "operationKind": "query",
            "text": "query SpaceStarShortcutListenerIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id,alias,name,key,currentUser{isFavourited}}}"
        }
    };
}();
$92084701ec630418$var$node.hash = "ee6489b807b5c87efd54daae89947f35";
var $92084701ec630418$export$2e2bcd8739ae039 = $92084701ec630418$var$node;















var $f9jv7 = parcelRequire("f9jv7");





var $iCPvv = parcelRequire("iCPvv");




const $e6d97f54b872b96e$var$handleError = (error, createAnalyticsEvent)=>{
    // Temporarily log errors to debug why some are not being marked as handled
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: 'spaceStarShortcutListener',
            source: 'spaceStarShortcutListener',
            attributes: {
                error: JSON.stringify(error),
                isNotFoundError: (0, $f9jv7.isNotFoundError)(error)
            }
        }
    }).fire();
    if ((0, $f9jv7.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
};
const $e6d97f54b872b96e$export$385015a3c6790101 = ({ spaceKey: spaceKey, contentMode: contentMode, source: source = 'FavouriteMoreActionsMenuItem' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: spaceFavouriteStatusData, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $92084701ec630418$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first',
        onError: (error)=>{
            $e6d97f54b872b96e$var$handleError(error, createAnalyticsEvent);
        }
    });
    if (loading) return null;
    if (error) {
        $e6d97f54b872b96e$var$handleError(error, createAnalyticsEvent);
        return null;
    }
    const isStarred = spaceFavouriteStatusData?.space?.currentUser?.isFavourited || false;
    const spaceName = spaceFavouriteStatusData?.space?.name || spaceFavouriteStatusData?.space?.alias || spaceFavouriteStatusData?.space?.key || '';
    const spaceId = spaceFavouriteStatusData?.space?.id || '';
    const handleShortcut = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'spaceStar',
                    attributes: {
                        triggeredByKeyboardShortcut: true,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'edit'
                    },
                    source: source
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iCPvv.SpaceStar), {
        spaceId: spaceId,
        spaceKey: spaceKey,
        isStarred: isStarred,
        spaceName: spaceName,
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
            listener: handleShortcut(toggleStar)
        }));
};



var $lOeVN = parcelRequire("lOeVN");


var $efvKr = parcelRequire("efvKr");


var $b66o6 = parcelRequire("b66o6");


var $cMvQV = parcelRequire("cMvQV");


var $kM55L = parcelRequire("kM55L");


var $1PC5x = parcelRequire("1PC5x");


var $4vC63 = parcelRequire("4vC63");





const $b742140c6b014561$export$fcc1c0135b5761c6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F85M0",
    name: "LazyForgeContentTools",
    loader: async ()=>(await (parcelRequire("kxAIf"))).ForgeContentTools
});



var $1jQpq = parcelRequire("1jQpq");











var $xQxzY = parcelRequire("xQxzY");











var $6fil2 = parcelRequire("6fil2");


var $5ZqQS = parcelRequire("5ZqQS");





var $ayQVU = parcelRequire("ayQVU");




const $0633edcc0f21cf62$export$38d9182f14dddb00 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { contentId: contentId, contentType: contentType } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query useIsPageOrBlogAutoConvertedQuery($contentId:ID$versionOverride:Int$status:[String]){content(id:$contentId version:$versionOverride status:$status){nodes{id type properties(key:"editor"){nodes{id key value}}operations{operation targetType}body{dynamic{representation}}metadata{frontend{fabricEditorSupported}}}}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true) ? [
            "draft",
            "current"
        ] : null;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== contentId) {
        t3 = {
            contentId: contentId,
            status: t2
        };
        $[2] = contentId;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = !(contentType === "page" || contentType === "blogpost");
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = {
            variables: t3,
            skip: t4,
            fetchPolicy: (0, $9wGTI.fg)("confluence_frontend_fix_revert_btn_tiny") ? "cache-and-network" : "cache-first"
        };
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const { data: contentPropertiesData, error: error } = (0, $xQxzY.useQuery)(t1, t5);
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
        return false;
    }
    if (contentPropertiesData) {
        const t6 = contentPropertiesData?.content?.nodes?.[0];
        let t7;
        if ($[7] !== t6) {
            t7 = (0, $ayQVU.getAutoConvertionInfo)(t6);
            $[7] = t6;
            $[8] = t7;
        } else t7 = $[8];
        const { isAutoConverted: isAutoConverted } = t7;
        const isNewPage = contentPropertiesData?.content?.nodes?.length === 0;
        return !!isAutoConverted && !isNewPage;
    }
    return false;
};









var $kyKWe = parcelRequire("kyKWe");





var $e0ycV = parcelRequire("e0ycV");


var $BCkug = parcelRequire("BCkug");








var $bqMNb = parcelRequire("bqMNb");




const $690df6788a087387$export$d91fa1ff1d654586 = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { item: item, contentMode: contentMode, spaceId: spaceId, flags: flags, spaceKey: spaceKey, contentId: contentId, closeParentMenu: closeParentMenu } = t0;
    const { retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, saveDraft: saveDraft } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentMode || $[2] !== flags || $[3] !== push || $[4] !== retrieveEditorTitleAndContent || $[5] !== saveDraft || $[6] !== spaceId || $[7] !== spaceKey) {
        t1 = contentMode === "view" ? {
            contentId: contentId,
            spaceId: spaceId,
            isUnpublishedDraft: false,
            flags: flags,
            analyticsSource: "viewPageScreen",
            adfOrigin: "RENDERER",
            onSuccessfulConversion: ()=>{
                push((0, $1NBp8.VIEW_PAGE).toUrl({
                    spaceKey: spaceKey,
                    contentId: contentId
                }, {
                    query: {
                        [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    }
                }));
            },
            retrieveEditorTitleAndContent: undefined
        } : {
            contentId: contentId,
            spaceId: spaceId,
            isUnpublishedDraft: contentMode === "draft",
            flags: flags,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            saveDraft: saveDraft,
            analyticsSource: "ellipsisDropdownComponent",
            adfOrigin: "EDITOR",
            onSuccessfulConversion: ()=>{
                push((0, $1NBp8.VIEW_PAGE).toUrl({
                    spaceKey: spaceKey,
                    contentId: contentId
                }));
            }
        };
        $[0] = contentId;
        $[1] = contentMode;
        $[2] = flags;
        $[3] = push;
        $[4] = retrieveEditorTitleAndContent;
        $[5] = saveDraft;
        $[6] = spaceId;
        $[7] = spaceKey;
        $[8] = t1;
    } else t1 = $[8];
    const useSwitchToLivePagesProps = t1;
    const switchToLivePage = (0, $BCkug.useSwitchToLivePage)(useSwitchToLivePagesProps);
    let t2;
    if ($[9] !== closeParentMenu || $[10] !== switchToLivePage) {
        t2 = ()=>{
            closeParentMenu();
            switchToLivePage();
        };
        $[9] = closeParentMenu;
        $[10] = switchToLivePage;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))), {
            label: ""
        });
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== item.id || $[14] !== item.label || $[15] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: item.id,
            onClick: t2,
            elemBefore: t3
        }, item.label);
        $[13] = item.id;
        $[14] = item.label;
        $[15] = t2;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
};




















var $c4sKh = parcelRequire("c4sKh");











// this is to keep consistent with ContentTools PopupMenuGroup
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcd7f3eccb1861ca$var$StyledDropdownItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $ahaN7.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1ul91wdt _p12f1c3h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $bcd7f3eccb1861ca$var$DropdownItemLabelContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $bcd7f3eccb1861ca$var$badgeContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.075'
});
const $bcd7f3eccb1861ca$export$7a3b78bc1d3676d9 = (styleClass)=>{
    return !styleClass?.includes('aui-button') ? styleClass : '';
};
const $bcd7f3eccb1861ca$export$49b1344a56b06112 = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { label: label, items: items, isNestedMenuOpen: isNestedMenuOpen, onClick: onClick, iconBefore: iconBefore, forgeMenuItems: forgeMenuItems, onMenuClose: onMenuClose, id: id } = t0;
    if (!items.length && !forgeMenuItems?.length) return null;
    let t1;
    if ($[0] !== onMenuClose) {
        t1 = (t2)=>{
            const { isOpen: isOpen } = t2;
            if (!isOpen) onMenuClose();
        };
        $[0] = onMenuClose;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== iconBefore || $[3] !== id || $[4] !== label || $[5] !== onClick) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                ...triggerProps,
                ref: triggerRef,
                onClick: onClick,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    size: "small"
                }),
                elemBefore: iconBefore,
                testId: `${id}-button`
            }, label);
        };
        $[2] = iconBefore;
        $[3] = id;
        $[4] = label;
        $[5] = onClick;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== items) {
        t3 = items.map($bcd7f3eccb1861ca$var$_temp);
        $[7] = items;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== forgeMenuItems) {
        t4 = forgeMenuItems && forgeMenuItems.length > 0 && forgeMenuItems.map($bcd7f3eccb1861ca$var$_temp2);
        $[9] = forgeMenuItems;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bcd7f3eccb1861ca$var$StyledDropdownItemGroup, null, t3, t4);
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== isNestedMenuOpen || $[15] !== t1 || $[16] !== t2 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            placement: "left-start",
            isOpen: isNestedMenuOpen,
            onOpenChange: t1,
            trigger: t2
        }, t5);
        $[14] = isNestedMenuOpen;
        $[15] = t1;
        $[16] = t2;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
};
function $bcd7f3eccb1861ca$var$_temp(item) {
    if (item.customComponent) return item.customComponent();
    const { id: id_0, url: url, label: itemLabel, badgeLabel: badgeLabel, tooltip: tooltip, closeParentMenu: closeParentMenu } = item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: $bcd7f3eccb1861ca$export$7a3b78bc1d3676d9(item?.styleClass),
        key: id_0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        href: url,
        onClick: closeParentMenu,
        UNSAFE_shouldDisableRouterLink: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bcd7f3eccb1861ca$var$DropdownItemLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, itemLabel || tooltip), badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $bcd7f3eccb1861ca$var$badgeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, badgeLabel)))));
}
function $bcd7f3eccb1861ca$var$_temp2(forgeMenuItem) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
        key: forgeMenuItem?.props?.extension?.id,
        module: forgeMenuItem?.props?.extension
    }, forgeMenuItem);
}
















var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");










var $4TcLf = parcelRequire("4TcLf");





var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const { IS_MORE_ACTIONS_HINT_VISIBLE: $4af5663ac404949d$var$IS_MORE_ACTIONS_HINT_VISIBLE } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $4af5663ac404949d$var$i18n = (0, $cgtv4.defineMessages)({
    tryingToFindSomething: {
        id: "content-types-header.content-types.more-actions.trying-to-find-something",
        defaultMessage: "Trying to find something? Check the <strong>Details</strong> panel in the floating action bar. <link>Show me</link>"
    },
    dontTellMeAgain: {
        id: "content-types-header.content-types.more-actions.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $4af5663ac404949d$var$missingActionsHintMenuItemStyles = (0, $ecnYn.xcss)({
    margin: 'space.150'
});
const $4af5663ac404949d$var$textStyles = (0, $ecnYn.xcss)({
    width: '216px'
});
const $4af5663ac404949d$var$underlinedButtonStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    textDecoration: 'underline',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    ':hover': {
        textDecoration: 'none'
    }
});
const $4af5663ac404949d$var$linkButtonStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    marginLeft: 'space.050'
});
const $4af5663ac404949d$export$b0ffdc20cd96b8d0 = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { setIsMenuOpen: setIsMenuOpen } = t0;
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { goToStep: goToStep } = (0, $4TcLf.useMoreActionsObjectSidebarTourActions)();
    const { setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    let t1;
    if ($[0] !== goToStep || $[1] !== setIsMenuOpen || $[2] !== setSidebarControlExpandCollapsedState) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $4af5663ac404949d$var$textStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$4af5663ac404949d$var$i18n.tryingToFindSomething,
            values: {
                strong: $4af5663ac404949d$var$_temp,
                link: (text_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                        onClick: ()=>{
                            setSidebarControlExpandCollapsedState("expanded");
                            setIsMenuOpen(false);
                            goToStep((0, $bzwhi.MoreActionsObjectSidebarTourSteps).FIRST);
                        },
                        padding: "space.0",
                        backgroundColor: "color.background.neutral.subtle",
                        xcss: $4af5663ac404949d$var$linkButtonStyles
                    }, text_0)
            }
        }));
        $[0] = goToStep;
        $[1] = setIsMenuOpen;
        $[2] = setSidebarControlExpandCollapsedState;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== setOnboardingState) {
        t2 = ()=>setOnboardingState({
                key: $4af5663ac404949d$var$IS_MORE_ACTIONS_HINT_VISIBLE,
                value: "false"
            });
        $[4] = setOnboardingState;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4af5663ac404949d$var$i18n.dontTellMeAgain);
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            onClick: t2,
            padding: "space.0",
            backgroundColor: "color.background.neutral.subtle",
            xcss: $4af5663ac404949d$var$underlinedButtonStyles
        }, t3);
        $[7] = t2;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            alignInline: "start",
            space: "space.300",
            xcss: $4af5663ac404949d$var$missingActionsHintMenuItemStyles
        }, t1, t4));
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $4af5663ac404949d$var$_temp(text) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        as: "strong"
    }, text);
}




















var $i25hX = parcelRequire("i25hX");


var $h7YX1 = parcelRequire("h7YX1");


var $jyA9t = parcelRequire("jyA9t");

const $eb923bf92acc93d7$var$i18n = (0, $cgtv4.defineMessages)({
    whiteboardToLiveDocWithAi: {
        id: "content-types-header.content-types.more-actions.whiteboard-create-live-doc-with-rovo",
        defaultMessage: "Create live doc with Rovo"
    }
});
const $eb923bf92acc93d7$export$240f536835ebe1cf = 'Create a live doc from this whiteboard.';
const $eb923bf92acc93d7$export$43890b7edce69789 = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { spaceKey: spaceKey, contentId: contentId } = t0;
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)("ai-mate");
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($eb923bf92acc93d7$var$i18n.whiteboardToLiveDocWithAi);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const title = t1;
    let t2;
    if ($[2] !== contentId || $[3] !== createAnalyticsEvent || $[4] !== openModal || $[5] !== publish || $[6] !== spaceKey || $[7] !== title) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "whiteboardToLiveDocWithAi",
                    source: "overflowMenu"
                }
            }).fire();
            openModal("whiteboardToLiveDocAiConversion", spaceKey, undefined, true, {
                id: contentId,
                type: "whiteboard"
            });
            publish({
                type: "chat-new",
                source: "CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON",
                openChat: false,
                data: {
                    name: title,
                    dialogues: [],
                    prompt: $eb923bf92acc93d7$export$240f536835ebe1cf,
                    contentContext: "staging-area",
                    sourceId: contentId
                }
            });
        };
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = openModal;
        $[5] = publish;
        $[6] = spaceKey;
        $[7] = title;
        $[8] = t2;
    } else t2 = $[8];
    const handleWhiteboardToLiveDocWithAi = t2;
    let t3;
    if ($[9] !== handleWhiteboardToLiveDocWithAi || $[10] !== title) {
        t3 = {
            id: "whiteboard-to-live-doc-with-ai",
            text: title,
            onClick: handleWhiteboardToLiveDocWithAi
        };
        $[9] = handleWhiteboardToLiveDocWithAi;
        $[10] = title;
        $[11] = t3;
    } else t3 = $[11];
    const item = t3;
    const { id: id, onClick: onClick, text: text } = item;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
            label: ""
        });
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== id || $[14] !== onClick || $[15] !== text) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemBefore: t4,
            key: id,
            onClick: onClick
        }, text);
        $[13] = id;
        $[14] = onClick;
        $[15] = text;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
};






















var $fxBfz = parcelRequire("fxBfz");





var $4CxKE = parcelRequire("4CxKE");


var $6767u = parcelRequire("6767u");





var $tvI67 = parcelRequire("tvI67");


var $4WZ5N = parcelRequire("4WZ5N");


var $u9agA = parcelRequire("u9agA");


var $2MuFw = parcelRequire("2MuFw");





var $82gXq = parcelRequire("82gXq");


var $hw7wB = parcelRequire("hw7wB");


var $eG1e2 = parcelRequire("eG1e2");


var $9RVmI = parcelRequire("9RVmI");


var $gKvd9 = parcelRequire("gKvd9");





var $hFGQl = parcelRequire("hFGQl");


var $jBnsv = parcelRequire("jBnsv");






var $1AbrA = parcelRequire("1AbrA");


var $jcM8h = parcelRequire("jcM8h");


var $l3C2L = parcelRequire("l3C2L");





var $d8J72 = parcelRequire("d8J72");




var $k9WFY = parcelRequire("k9WFY");


var $iVd6X = parcelRequire("iVd6X");










const $434c765ed6791bfa$export$68013e639efb767f = 'action-apps';
const $434c765ed6791bfa$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    export: {
        id: "content-types-header.ellipsis.open.ellipsis.export",
        defaultMessage: "Export"
    },
    convert: {
        id: "content-types-header.ellipsis.open.ellipsis.convert",
        defaultMessage: "Convert"
    },
    duplicate: {
        id: "content-types-header.ellipsis.open.ellipsis.duplicate",
        defaultMessage: "Duplicate"
    },
    makeACopy: {
        id: "content-types-header.ellipsis.open.ellipsis.makeACopy",
        defaultMessage: "Make a copy"
    },
    duplicateDatabase: {
        id: "content-types-header.ellipsis.open.ellipsis.duplicate.database",
        defaultMessage: "Duplicate database"
    },
    makeACopyOfDatabase: {
        id: "content-types-header.ellipsis.open.ellipsis.makeACopy.database",
        defaultMessage: "Make a copy of database"
    },
    archive: {
        id: "content-types-header.ellipsis.open.ellipsis.archive",
        defaultMessage: "Archive"
    },
    deleteDraftLabel: {
        id: "content-types-header.content-types.more-actions.delete-draft",
        defaultMessage: "Delete draft"
    },
    deleteLabel: {
        id: "content-types-header.content-types.more-actions.delete",
        defaultMessage: "Delete"
    },
    archiveAndDeleteLabel: {
        id: "content-types-header.content-types.more-actions.archive-and-delete",
        defaultMessage: "Archive and delete"
    },
    viewChangesTitle: {
        id: "content-types-header.content-types.view.changes.title",
        defaultMessage: "Latest changes"
    },
    viewChangesLabel: {
        id: "content-types-header.content-types.view.changes.label",
        defaultMessage: "View changes"
    },
    automationsModalTitle: {
        id: "content-types-header.automations.title",
        defaultMessage: "Page automations"
    },
    automationsLabel: {
        id: "content-types-header.automations.label",
        defaultMessage: "Automations"
    },
    advancedLabel: {
        id: "content-types-header.advanced.label",
        defaultMessage: "Advanced details"
    },
    pageAppsLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.page.apps",
        defaultMessage: "Apps"
    }
});
var $434c765ed6791bfa$export$8bf1ff90935c8832 = /*#__PURE__*/ function(NestedMenuTypes) {
    NestedMenuTypes["Export"] = "export";
    NestedMenuTypes["Convert"] = "convert";
    NestedMenuTypes["Archive"] = "archive";
    NestedMenuTypes["Advanced"] = "advanced";
    NestedMenuTypes["Attachments"] = "attachments";
    NestedMenuTypes["Apps"] = "apps";
    NestedMenuTypes["ContentOwnership"] = "content-ownership";
    NestedMenuTypes["MoreSupport"] = "more-support";
    NestedMenuTypes["CopyDatabase"] = "copy-database";
    NestedMenuTypes["Help"] = "help";
    NestedMenuTypes["Watch"] = "watch";
    NestedMenuTypes["TemplatesAndImport"] = "templates-and-import";
    return NestedMenuTypes;
}({});
const $434c765ed6791bfa$var$ConvertMenuItemComponent = ({ webItemsMap: webItemsMap, isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, spaceKey: spaceKey, contentId: contentId, dialogs: dialogs, handleNestedMenuItemClose: handleNestedMenuItemClose, contentMode: contentMode, flags: flags, spaceId: spaceId, closeParentMenu: closeParentMenu, isConvertToFolderHighlighted: isConvertToFolderHighlighted })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const convertItems = [
        (0, $511857b10ace36ca$export$10f4bed2ae52719b),
        (0, $511857b10ace36ca$export$7767afe5b675f4b1),
        (0, $511857b10ace36ca$export$5497d83bbd1b1232)
    ].map((id)=>{
        const item = webItemsMap[id];
        if (id === (0, $511857b10ace36ca$export$7767afe5b675f4b1) && item) {
            item.url = '';
            item.urlWithoutContextPath = '';
            return {
                ...item,
                customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8J72.ConvertToFolderItem), {
                        key: item.completeKey,
                        sectionItem: item,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        dialogs: dialogs,
                        shouldHighlight: isConvertToFolderHighlighted,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                            label: ""
                        }),
                        onClick: closeParentMenu
                    })
            };
        } else if (id === (0, $511857b10ace36ca$export$5497d83bbd1b1232) && item) {
            item.url = '';
            item.urlWithoutContextPath = '';
            const makePublishPageAsBlogDialogOpener = ()=>{
                closeParentMenu();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'publishPageAsBlog',
                        source: 'contentTypesHeader'
                    }
                }).fire();
                dialogs.showDialog((0, $k9WFY.PublishPageAsBlogDialog), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: (0, $iVd6X.PublishPageAsBlogSources).ViewPage
                });
            };
            return {
                ...item,
                customComponent: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        key: item.completeKey,
                        ...item,
                        onClick: makePublishPageAsBlogDialogOpener,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                            label: ""
                        })
                    });
                }
            };
        } else if (id === (0, $511857b10ace36ca$export$10f4bed2ae52719b) && item) return {
            ...item,
            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $690df6788a087387$export$d91fa1ff1d654586), {
                    item: item,
                    contentMode: contentMode,
                    spaceId: spaceId,
                    flags: flags,
                    spaceKey: spaceKey,
                    contentId: contentId,
                    closeParentMenu: closeParentMenu
                })
        };
        else return null;
    }).filter((item_0)=>item_0 && item_0.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.convert),
        items: convertItems,
        isNestedMenuOpen: isNestedMenuOpen,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
            label: ""
        }),
        key: (0, $511857b10ace36ca$export$3192aea0628d957a),
        onMenuClose: handleNestedMenuItemClose
    });
};
const $434c765ed6791bfa$export$1a264aaf74bdd787 = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { webItemsMap: webItemsMap, nestedPopup: nestedPopup, handleNestedMenuItemClick: handleNestedMenuItemClick, spaceKey: spaceKey, contentId: contentId, handleNestedMenuItemClose: handleNestedMenuItemClose, flags: flags, spaceId: spaceId, contentMode: contentMode, closeParentMenu: closeParentMenu, isConvertToFolderHighlighted: isConvertToFolderHighlighted } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleNestedMenuItemClick) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowExportAndConvert",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("convert");
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleNestedMenuItemClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleConvertMenuItemClick = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== closeParentMenu || $[5] !== contentId || $[6] !== contentMode || $[7] !== flags || $[8] !== handleConvertMenuItemClick || $[9] !== handleNestedMenuItemClose || $[10] !== isConvertToFolderHighlighted || $[11] !== nestedPopup || $[12] !== spaceId || $[13] !== spaceKey || $[14] !== webItemsMap) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t2
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$var$ConvertMenuItemComponent, {
                webItemsMap: webItemsMap,
                dialogs: dialogs,
                isNestedMenuOpen: nestedPopup === "convert",
                handleClick: handleConvertMenuItemClick,
                contentId: contentId,
                spaceKey: spaceKey,
                flags: flags,
                spaceId: spaceId,
                handleNestedMenuItemClose: handleNestedMenuItemClose,
                contentMode: contentMode,
                closeParentMenu: closeParentMenu,
                isConvertToFolderHighlighted: isConvertToFolderHighlighted
            }));
        $[4] = closeParentMenu;
        $[5] = contentId;
        $[6] = contentMode;
        $[7] = flags;
        $[8] = handleConvertMenuItemClick;
        $[9] = handleNestedMenuItemClose;
        $[10] = isConvertToFolderHighlighted;
        $[11] = nestedPopup;
        $[12] = spaceId;
        $[13] = spaceKey;
        $[14] = webItemsMap;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
};
const $434c765ed6791bfa$export$b945ccaa4d42d330 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { webItemsMap: webItemsMap, handleNestedMenuItemClick: handleNestedMenuItemClick, nestedPopup: nestedPopup, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $511857b10ace36ca$export$5da5719a925f973),
            (0, $511857b10ace36ca$export$bbe81b5a8b0eaf4)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== closeParentMenu || $[2] !== webItemsMap) {
        t2 = t1.map((id)=>{
            const item = webItemsMap[id];
            return {
                ...item,
                closeParentMenu: closeParentMenu
            };
        }).filter($434c765ed6791bfa$var$_temp);
        $[1] = closeParentMenu;
        $[2] = webItemsMap;
        $[3] = t2;
    } else t2 = $[3];
    const exportItems = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== handleNestedMenuItemClick) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowExport",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("export");
        };
        $[4] = createAnalyticsEvent;
        $[5] = handleNestedMenuItemClick;
        $[6] = t3;
    } else t3 = $[6];
    const handleExportMenuItemClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.export);
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
            label: ""
        });
        $[8] = t5;
    } else t5 = $[8];
    const t6 = nestedPopup === "export";
    let t7;
    if ($[9] !== exportItems || $[10] !== handleExportMenuItemClick || $[11] !== handleNestedMenuItemClose || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t4,
            items: exportItems,
            iconBefore: t5,
            isNestedMenuOpen: t6,
            onClick: handleExportMenuItemClick,
            key: (0, $511857b10ace36ca$export$ab4fe2a2881747b5),
            onMenuClose: handleNestedMenuItemClose
        });
        $[9] = exportItems;
        $[10] = handleExportMenuItemClick;
        $[11] = handleNestedMenuItemClose;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
const $434c765ed6791bfa$export$5ac124715785374c = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { onDeleteClick: onDeleteClick, contentMode: contentMode, createAnalyticsEvent: createAnalyticsEvent } = t0;
    const label = contentMode === "draft" ? $434c765ed6791bfa$export$a7357cdd1f0b0168.deleteDraftLabel : $434c765ed6791bfa$export$a7357cdd1f0b0168.deleteLabel;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== createAnalyticsEvent || $[2] !== label || $[3] !== onDeleteClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1,
            key: `container-${(0, $511857b10ace36ca$export$da4fec526a505196)}`
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "overflowDelete",
                            source: "overflowMenu"
                        }
                    }).fire();
                    onDeleteClick(dialogs);
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), label)));
        $[1] = createAnalyticsEvent;
        $[2] = label;
        $[3] = onDeleteClick;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $434c765ed6791bfa$export$f4be76d677f42fda = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onArchiveClick: onArchiveClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onArchiveClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1,
            key: `container-${(0, $511857b10ace36ca$export$d81a93c80838b765)}`
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                onClick: ()=>{
                    onArchiveClick(dialogs);
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4WZ5N))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.archive)));
        $[1] = onArchiveClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
const $434c765ed6791bfa$export$a05f0dd30396f811 = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { webItems: webItems, isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, onArchiveClick: onArchiveClick, onDeleteClick: onDeleteClick, contentMode: contentMode, createAnalyticsEvent: createAnalyticsEvent, handleNestedMenuItemClose: handleNestedMenuItemClose } = t0;
    let t1;
    if ($[0] !== contentMode || $[1] !== createAnalyticsEvent || $[2] !== onArchiveClick || $[3] !== onDeleteClick || $[4] !== webItems) {
        let t2;
        if ($[6] !== contentMode || $[7] !== createAnalyticsEvent || $[8] !== onArchiveClick || $[9] !== onDeleteClick) {
            t2 = (item_0)=>{
                if (item_0.id === (0, $511857b10ace36ca$export$d81a93c80838b765)) return {
                    ...item_0,
                    customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$f4be76d677f42fda, {
                            onArchiveClick: onArchiveClick
                        })
                };
                else {
                    if (item_0.id === (0, $511857b10ace36ca$export$da4fec526a505196)) return {
                        ...item_0,
                        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$5ac124715785374c, {
                                onDeleteClick: onDeleteClick,
                                contentMode: contentMode,
                                createAnalyticsEvent: createAnalyticsEvent
                            })
                    };
                }
                return item_0;
            };
            $[6] = contentMode;
            $[7] = createAnalyticsEvent;
            $[8] = onArchiveClick;
            $[9] = onDeleteClick;
            $[10] = t2;
        } else t2 = $[10];
        t1 = webItems.filter($434c765ed6791bfa$var$_temp2).map(t2);
        $[0] = contentMode;
        $[1] = createAnalyticsEvent;
        $[2] = onArchiveClick;
        $[3] = onDeleteClick;
        $[4] = webItems;
        $[5] = t1;
    } else t1 = $[5];
    const archiveItems = t1;
    let t2;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.archiveAndDeleteLabel);
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            label: ""
        });
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== archiveItems || $[14] !== handleClick || $[15] !== handleNestedMenuItemClose || $[16] !== isNestedMenuOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t2,
            items: archiveItems,
            isNestedMenuOpen: isNestedMenuOpen,
            onClick: handleClick,
            iconBefore: t3,
            onMenuClose: handleNestedMenuItemClose
        });
        $[13] = archiveItems;
        $[14] = handleClick;
        $[15] = handleNestedMenuItemClose;
        $[16] = isNestedMenuOpen;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
};
const $434c765ed6791bfa$export$d206439c03b979ee = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { shortcutKeys: shortcutKeys, id: id } = t0;
    let t1;
    if ($[0] !== id || $[1] !== shortcutKeys) {
        let t2;
        if ($[3] !== id) {
            t2 = (key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    key: `${id}-shortcut-${key}`,
                    shortcut: key
                });
            $[3] = id;
            $[4] = t2;
        } else t2 = $[4];
        t1 = shortcutKeys.map(t2);
        $[0] = id;
        $[1] = shortcutKeys;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), null, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $434c765ed6791bfa$export$b605bf507f6a39c = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { item: item, icon: icon, testId: testId } = t0;
    const { id: id, url: url, target: target, onClick: onClick, shortcutText: shortcutText, text: text, showToggle: showToggle, isDisabled: isDisabled } = item;
    let t1;
    if ($[0] !== id || $[1] !== shortcutText || $[2] !== showToggle) {
        t1 = ()=>{
            if (shortcutText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$d206439c03b979ee, {
                shortcutKeys: shortcutText.split("+"),
                id: id
            });
            else {
                if (showToggle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
                    isChecked: showToggle.isChecked,
                    isDisabled: showToggle.isDisabled
                });
            }
            return null;
        };
        $[0] = id;
        $[1] = shortcutText;
        $[2] = showToggle;
        $[3] = t1;
    } else t1 = $[3];
    const ElementAfter = t1;
    const t2 = icon ?? null;
    let t3;
    if ($[4] !== ElementAfter) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ElementAfter, null);
        $[4] = ElementAfter;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== id || $[7] !== isDisabled || $[8] !== onClick || $[9] !== t2 || $[10] !== t3 || $[11] !== target || $[12] !== testId || $[13] !== text || $[14] !== url) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemBefore: t2,
            key: id,
            testId: testId,
            href: url,
            target: target,
            onClick: onClick,
            isDisabled: isDisabled,
            elemAfter: t3
        }, text);
        $[6] = id;
        $[7] = isDisabled;
        $[8] = onClick;
        $[9] = t2;
        $[10] = t3;
        $[11] = target;
        $[12] = testId;
        $[13] = text;
        $[14] = url;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
};
const $434c765ed6791bfa$export$36ee254e582a74c2 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { setIsCopyContentModalOpen: setIsCopyContentModalOpen, closeParentMenu: closeParentMenu, item: item, showIcon: t1 } = t0;
    const showIcon = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== closeParentMenu || $[1] !== setIsCopyContentModalOpen) {
        t2 = ()=>{
            closeParentMenu();
            setIsCopyContentModalOpen(true);
        };
        $[0] = closeParentMenu;
        $[1] = setIsCopyContentModalOpen;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== showIcon) {
        t3 = showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: ""
        }) : null;
        $[3] = showIcon;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== item.label || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: (0, $511857b10ace36ca$export$94db61d2b880af44),
            onClick: t2,
            elemBefore: t3
        }, item.label);
        $[5] = item.label;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
const $434c765ed6791bfa$export$3131530af790ffe2 = ({ isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, copyDatabaseItem: copyDatabaseItem, copyStructureItem: copyStructureItem, setIsCopyContentModalOpen: setIsCopyContentModalOpen, contentMode: contentMode, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const copyDatabaseLabel = formatMessage((0, $6mKj3.expValEquals)('make_a_copy_cta', 'cohort', 'test') ? $434c765ed6791bfa$export$a7357cdd1f0b0168.makeACopyOfDatabase : $434c765ed6791bfa$export$a7357cdd1f0b0168.duplicateDatabase);
    const copyOnClick = copyStructureItem.onClick;
    copyStructureItem.onClick = ()=>{
        closeParentMenu();
        copyOnClick?.();
    };
    if (contentMode === 'archived') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$b605bf507f6a39c, {
        item: copyStructureItem,
        key: copyStructureItem.id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: ""
        })
    });
    const copyStructureItemWithComponent = {
        ...copyStructureItem,
        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$b605bf507f6a39c, {
                item: copyStructureItem,
                key: copyStructureItem.id
            })
    };
    const copyItems = [
        {
            ...copyDatabaseItem,
            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$36ee254e582a74c2, {
                    setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                    closeParentMenu: closeParentMenu,
                    item: {
                        ...copyDatabaseItem,
                        label: copyDatabaseLabel
                    },
                    showIcon: false
                })
        },
        copyStructureItemWithComponent
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $6mKj3.expValEquals)('make_a_copy_cta', 'cohort', 'test') ? $434c765ed6791bfa$export$a7357cdd1f0b0168.makeACopy : $434c765ed6791bfa$export$a7357cdd1f0b0168.duplicate),
        items: copyItems,
        isNestedMenuOpen: isNestedMenuOpen,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: ""
        }),
        onMenuClose: handleNestedMenuItemClose
    });
};
const $434c765ed6791bfa$export$f28b24dc0422311f = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { contentId: contentId, dialogs: dialogs, saveDraft: saveDraft, createAnalyticsEvent: createAnalyticsEvent } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== dialogs || $[3] !== intl || $[4] !== saveDraft) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowViewChanges",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.();
            dialogs.showModal((0, $l3C2L.ViewChangesDialogLoader), {
                contentId: contentId,
                title: intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.viewChangesTitle)
            });
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = dialogs;
        $[3] = intl;
        $[4] = saveDraft;
        $[5] = t1;
    } else t1 = $[5];
    const onClick = t1;
    let t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CxKE))), {
            label: ""
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.viewChangesLabel);
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    let t4;
    if ($[8] !== onClick) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: "view-changes",
            onClick: onClick,
            elemBefore: t2
        }, t3);
        $[8] = onClick;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
};
const $434c765ed6791bfa$export$2ca3e90bac67fd87 = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { item: item, nestedPopup: nestedPopup, setNestedPopup: setNestedPopup, contentId: contentId, setIsMenuOpen: setIsMenuOpen } = t0;
    let t1;
    if ($[0] !== setIsMenuOpen) {
        t1 = ()=>{
            setIsMenuOpen(false);
        };
        $[0] = setIsMenuOpen;
        $[1] = t1;
    } else t1 = $[1];
    const handleMenuClose = t1;
    let t2;
    if ($[2] !== nestedPopup || $[3] !== setNestedPopup) {
        t2 = ()=>{
            if (nestedPopup === "content-ownership") setNestedPopup(undefined);
            else setNestedPopup("content-ownership");
        };
        $[2] = nestedPopup;
        $[3] = setNestedPopup;
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClick = t2;
    let t3;
    if ($[5] !== setNestedPopup) {
        t3 = ()=>{
            setNestedPopup(undefined);
        };
        $[5] = setNestedPopup;
        $[6] = t3;
    } else t3 = $[6];
    const handlePopupClose = t3;
    const t4 = nestedPopup === "content-ownership";
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: ""
        }) : null;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== contentId || $[9] !== handleMenuClose || $[10] !== handleOnClick || $[11] !== handlePopupClose || $[12] !== item.id || $[13] !== item.label || $[14] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jcM8h.ContentOwnerPopupComponent), {
            contentId: contentId,
            itemId: item.id,
            itemLabel: item.label,
            isOpen: t4,
            onClick: handleOnClick,
            onCloseParent: handleMenuClose,
            onClosePopup: handlePopupClose,
            elemBefore: t5
        });
        $[8] = contentId;
        $[9] = handleMenuClose;
        $[10] = handleOnClick;
        $[11] = handlePopupClose;
        $[12] = item.id;
        $[13] = item.label;
        $[14] = t4;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
const $434c765ed6791bfa$export$f26eff3587fe7632 = ({ isAppsRendered: isAppsRendered, spaceKey: spaceKey, contentId: contentId, isMenuOpen: isMenuOpen, nestedPopup: nestedPopup, items: items, handleNestedMenuItemClick: handleNestedMenuItemClick, createAnalyticsEvent: createAnalyticsEvent, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu })=>{
    const pageAppItems = items.filter((item)=>item?.completeKey?.includes((0, $jBnsv.CONNECT_APP_PREFIX_KEY)) && item?.id !== (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID)).map((item)=>{
        item.closeParentMenu = closeParentMenu;
        return item;
    });
    const handleAppsMenuItemClick = ()=>{
        handleNestedMenuItemClick("apps");
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowApps',
                source: 'overflowMenu'
            }
        }).fire();
    };
    return {
        name: $434c765ed6791bfa$export$68013e639efb767f,
        shouldRender: isAppsRendered,
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b742140c6b014561$export$fcc1c0135b5761c6), {
                spaceKey: spaceKey,
                contentId: contentId,
                onLoadComplete: ()=>{},
                isDropdownMenuOpen: isMenuOpen
            }, (forgeMenuItems)=>pageAppItems.length > 0 || forgeMenuItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.pageAppsLabel),
                    items: pageAppItems,
                    isNestedMenuOpen: nestedPopup === "apps",
                    onClick: handleAppsMenuItemClick,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                        label: ""
                    }),
                    forgeMenuItems: forgeMenuItems,
                    onMenuClose: handleNestedMenuItemClose,
                    id: "third-party"
                }) : null)
    };
};
const $434c765ed6791bfa$export$7e059d95fddc01f4 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, pageTitle: pageTitle } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== createAnalyticsEvent || $[3] !== experienceTracker || $[4] !== intl || $[5] !== pageTitle || $[6] !== spaceKey) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS)
                    });
                    dialogs.showModal((0, $1AbrA.PageQuickActionAutomationMenu), {
                        pageId: contentId,
                        pageTitle: pageTitle || intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.automationsModalTitle),
                        spaceKey: spaceKey
                    });
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "overflowAutomations",
                            source: "overflowMenu"
                        }
                    }).fire();
                }
            }, intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.automationsLabel)));
        $[1] = contentId;
        $[2] = createAnalyticsEvent;
        $[3] = experienceTracker;
        $[4] = intl;
        $[5] = pageTitle;
        $[6] = spaceKey;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $434c765ed6791bfa$export$f404e2d5b48ab522 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { webItemsMap: webItemsMap, handleNestedMenuItemClick: handleNestedMenuItemClick, nestedPopup: nestedPopup, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const viewStorageFormatItem = webItemsMap[0, $511857b10ace36ca$export$da9876ab77cf10e8];
    const viewSourceItem = (0, $9wGTI.fg)("cc-page-experiences-enable-view-source-action-btn") ? webItemsMap[0, $511857b10ace36ca$export$ecf44b2b0a73d53f] : null;
    let advancedItems;
    if ($[0] !== closeParentMenu || $[1] !== viewSourceItem || $[2] !== viewStorageFormatItem) {
        advancedItems = [];
        if (viewSourceItem) {
            let t1;
            if ($[4] !== closeParentMenu || $[5] !== viewSourceItem) {
                t1 = {
                    ...viewSourceItem,
                    closeParentMenu: closeParentMenu
                };
                $[4] = closeParentMenu;
                $[5] = viewSourceItem;
                $[6] = t1;
            } else t1 = $[6];
            advancedItems.push(t1);
        }
        if (viewStorageFormatItem) {
            let t1;
            if ($[7] !== closeParentMenu || $[8] !== viewStorageFormatItem) {
                t1 = {
                    ...viewStorageFormatItem,
                    closeParentMenu: closeParentMenu
                };
                $[7] = closeParentMenu;
                $[8] = viewStorageFormatItem;
                $[9] = t1;
            } else t1 = $[9];
            advancedItems.push(t1);
        }
        $[0] = closeParentMenu;
        $[1] = viewSourceItem;
        $[2] = viewStorageFormatItem;
        $[3] = advancedItems;
    } else advancedItems = $[3];
    if (advancedItems.length === 0) return null;
    let t1;
    if ($[10] !== createAnalyticsEvent || $[11] !== handleNestedMenuItemClick) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowAdvanced",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("advanced");
        };
        $[10] = createAnalyticsEvent;
        $[11] = handleNestedMenuItemClick;
        $[12] = t1;
    } else t1 = $[12];
    const onClick = t1;
    let t2;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.advancedLabel);
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: "",
            size: "small"
        });
        $[14] = t3;
    } else t3 = $[14];
    const t4 = nestedPopup === "advanced";
    let t5;
    if ($[15] !== advancedItems || $[16] !== handleNestedMenuItemClose || $[17] !== onClick || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t2,
            items: advancedItems,
            iconBefore: t3,
            isNestedMenuOpen: t4,
            onClick: onClick,
            key: (0, $511857b10ace36ca$export$ab4fe2a2881747b5),
            onMenuClose: handleNestedMenuItemClose
        });
        $[15] = advancedItems;
        $[16] = handleNestedMenuItemClose;
        $[17] = onClick;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
function $434c765ed6791bfa$var$_temp(item_0) {
    return item_0.id;
}
function $434c765ed6791bfa$var$_temp2(item) {
    return item.id === (0, $511857b10ace36ca$export$d81a93c80838b765) || item.id === (0, $511857b10ace36ca$export$da4fec526a505196);
}























const $ac5cc0f86197b0c1$export$ea7f8a8a3c6349fc = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { label: label, isLivePage: isLivePage, contentType: contentType, itemId: t1, itemUrl: t2 } = t0;
    const itemId = t1 === undefined ? "" : t1;
    const itemUrl = t2 === undefined ? "" : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: ""
        });
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== contentType || $[2] !== createAnalyticsEvent || $[3] !== isLivePage) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "versionHistory",
                    source: "overflowMenu",
                    attributes: {
                        isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper"),
                        isNewContentHistory: (0, $6mKj3.expVal)("confluence_content_history_updates", "isEnabled", false),
                        isLivePage: isLivePage,
                        contentType: contentType
                    }
                }
            }).fire();
        };
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = isLivePage;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== itemId || $[6] !== itemUrl || $[7] !== label || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: itemId,
            elemBefore: t3,
            href: itemUrl,
            onClick: t4
        }, label);
        $[5] = itemId;
        $[6] = itemUrl;
        $[7] = label;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};



















var $iXCQx = parcelRequire("iXCQx");








var $fT2ta = parcelRequire("fT2ta");








var $dmDX7 = parcelRequire("dmDX7");


var $ewVsQ = parcelRequire("ewVsQ");

const $5d3293071a1569ba$var$i18n = (0, $cgtv4.defineMessages)({
    askToEditContentLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit",
        defaultMessage: "Ask to edit"
    },
    askToEditPendingLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.pending.label",
        defaultMessage: "Requested"
    },
    askToEditPendingRequestExistsFlagTitle: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.flag.title",
        defaultMessage: "Request pending"
    },
    askToEditPendingRequestExistsFlagDescription: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.flag.description",
        defaultMessage: "You already sent a request. We'll send you an email when it's been approved."
    }
});
const $5d3293071a1569ba$export$84d0de3613f64b9a = (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { contentType: contentType, contentId: contentId, flags: flags, triggerAnalyticsEvent: triggerAnalyticsEvent, askToEditKey: askToEditKey } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== flags || $[2] !== triggerAnalyticsEvent) {
        t1 = {
            contentId: contentId,
            flags: flags,
            triggerAnalyticsEvent: triggerAnalyticsEvent
        };
        $[0] = contentId;
        $[1] = flags;
        $[2] = triggerAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const { requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission } = (0, $ewVsQ.useRequestToEditContent)(t1);
    let t2;
    if ($[4] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[4] = contentId;
        $[5] = t2;
    } else t2 = $[5];
    const { pendingRequestExists: pendingRequestExists, isLoadingForFirstTime: pendingRequestCheckLoading } = (0, $dmDX7.usePendingRequestExists)(t2);
    const readyToSendRequest = !hasRequestedEditPermission && !pendingRequestExists && !pendingRequestCheckLoading;
    let t3;
    if ($[6] !== contentId || $[7] !== contentType || $[8] !== createAnalyticsEvent || $[9] !== flags || $[10] !== formatMessage || $[11] !== pendingRequestExists || $[12] !== readyToSendRequest || $[13] !== requestToEditContent) {
        t3 = async ()=>{
            if (readyToSendRequest) {
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "requestAccessButton",
                        source: "moreActionsMenu",
                        attributes: {
                            contentType: contentType,
                            accessType: "edit",
                            contentId: contentId,
                            editDeniedButCanView: true
                        }
                    }
                }).fire();
                await requestToEditContent();
            } else if (pendingRequestExists) flags.showInfoFlag({
                id: "ask-to-edit.ellipsis.pending-edit-request-exists.flag",
                title: formatMessage($5d3293071a1569ba$var$i18n.askToEditPendingRequestExistsFlagTitle),
                description: formatMessage($5d3293071a1569ba$var$i18n.askToEditPendingRequestExistsFlagDescription),
                isAutoDismiss: true
            });
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = createAnalyticsEvent;
        $[9] = flags;
        $[10] = formatMessage;
        $[11] = pendingRequestExists;
        $[12] = readyToSendRequest;
        $[13] = requestToEditContent;
        $[14] = t3;
    } else t3 = $[14];
    const handleItemClick = t3;
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: ""
        });
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== hasRequestedEditPermission || $[17] !== pendingRequestExists) {
        t5 = (hasRequestedEditPermission || pendingRequestExists) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            duration: "medium"
        }, $5d3293071a1569ba$var$_temp);
        $[16] = hasRequestedEditPermission;
        $[17] = pendingRequestExists;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5d3293071a1569ba$var$i18n.askToEditContentLabel);
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== askToEditKey || $[21] !== handleItemClick || $[22] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: askToEditKey,
            onClick: handleItemClick,
            elemBefore: t4,
            elemAfter: t5
        }, t6));
        $[20] = askToEditKey;
        $[21] = handleItemClick;
        $[22] = t5;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
};
function $5d3293071a1569ba$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5d3293071a1569ba$var$i18n.askToEditPendingLabel)));
}


const $511857b10ace36ca$export$bcce08436c9de127 = 'action-move-page-dialog-link';
const $511857b10ace36ca$export$c7733ea6d8e45875 = 'action-move-blogpost-dialog-link';
const $511857b10ace36ca$export$da4fec526a505196 = 'action-remove-content-link';
const $511857b10ace36ca$export$94db61d2b880af44 = 'action-copy-page-link';
const $511857b10ace36ca$export$d81a93c80838b765 = 'action-archive-link';
const $511857b10ace36ca$export$21b8b89e4603550f = 'action-restore-link';
const $511857b10ace36ca$export$84c7eab054d974db = 'action-give-feedback-link';
const $511857b10ace36ca$export$a751f1adb88d1383 = 'view-resolved-comments';
const $511857b10ace36ca$export$e14cf657321c833b = 'action-view-version-history-link';
const $511857b10ace36ca$export$fc2e34cd983af5d6 = 'action-view-history-link';
const $511857b10ace36ca$export$bbe81b5a8b0eaf4 = 'action-export-pdf-link';
const $511857b10ace36ca$export$5da5719a925f973 = 'action-export-word-link';
const $511857b10ace36ca$export$b1a4c392275ea35a = 'action-templates-and-import';
const $511857b10ace36ca$export$2728c726be07790 = 'action-templates';
const $511857b10ace36ca$export$f1ffcc01948271f7 = 'action-import';
const $511857b10ace36ca$export$5497d83bbd1b1232 = 'action-convert-page-to-blog';
const $511857b10ace36ca$export$7767afe5b675f4b1 = 'action-convert-page-to-folder';
const $511857b10ace36ca$export$8ba85686c8897eca = 'action-convert-live-doc-to-page';
const $511857b10ace36ca$export$f9e89fba7e6b4574 = 'preferences';
const $511857b10ace36ca$export$d588519b9727f1cc = 'export-file';
const $511857b10ace36ca$export$f0ae5a9b5b44d373 = 'open-find-replace';
const $511857b10ace36ca$export$cce5e117e5e43bc = 'whiteboard-import';
const $511857b10ace36ca$export$240b6ef4a1c531f6 = 'presentation-mode';
const $511857b10ace36ca$export$10f4bed2ae52719b = 'action-switch-to-live-edit';
const $511857b10ace36ca$export$c9981a2480d638b0 = 'action-revert-to-previous';
const $511857b10ace36ca$export$fe2b6e9bf8b31ecc = 'action-revert-editor';
const $511857b10ace36ca$export$12b5e6890d8e049c = 'fullscreen';
const $511857b10ace36ca$export$5f2e846fff4ab830 = 'whiteboard-documentation';
const $511857b10ace36ca$export$d4cf3906d3082596 = 'whiteboard-templates';
const $511857b10ace36ca$export$cc1f11fb5e07970e = 'whiteboard-to-live-doc-with-rovo';
const $511857b10ace36ca$export$348fd9bd77c132d9 = 'action-favourite-content';
const $511857b10ace36ca$export$35f02acdf766e275 = 'action-favourite-space';
const $511857b10ace36ca$export$e242b9905c10e726 = 'action-watch-content';
const $511857b10ace36ca$export$6bb183703c5072f1 = 'ask-to-edit-content';
const $511857b10ace36ca$export$74317f458aa33c63 = 'action-preview-content';
const $511857b10ace36ca$export$461acb5c5f9c7b12 = 'action-manage-content';
const $511857b10ace36ca$export$244b90a342b60d9f = 'action-classify-content';
const $511857b10ace36ca$export$fe0a3b90b0b6010b = 'action-automations';
const $511857b10ace36ca$export$52e1dc7e5d9b8b02 = 'action-advanced';
const $511857b10ace36ca$export$da9876ab77cf10e8 = 'action-view-storage-link';
const $511857b10ace36ca$export$ecf44b2b0a73d53f = 'action-view-source-link';
const $511857b10ace36ca$export$2594f905f6c1490e = 'databases-copy-structure';
const $511857b10ace36ca$export$6563b47d35bee4f1 = 'databases-undo';
const $511857b10ace36ca$export$fe723f15ba37849b = 'databases-redo';
const $511857b10ace36ca$export$be7385413e15c3ea = 'databases-templates';
const $511857b10ace36ca$export$e07ca208ff99048e = 'databases-export';
const $511857b10ace36ca$export$d7bae9f2073f40be = 'databases-lock-structure';
const $511857b10ace36ca$export$95f3debc4a615fda = 'databases-get-help';
const $511857b10ace36ca$export$54ed9c94f2cfe2b6 = 'databases-devtools';
const $511857b10ace36ca$export$23eaedbb3a44a3b5 = 'action-edit-embed-link';
const $511857b10ace36ca$export$a6381225def83c4b = 'action-page-permissions-link';
const $511857b10ace36ca$export$ab4fe2a2881747b5 = 'action-export-content';
const $511857b10ace36ca$export$3192aea0628d957a = 'action-convert-content';
const $511857b10ace36ca$export$654801d4f89a934 = 'action-company-hub-feedback';
const $511857b10ace36ca$export$43db96fb923dc5c7 = 'action-editor-undo';
const $511857b10ace36ca$export$4e316098da1efb3e = 'action-editor-redo';
const $511857b10ace36ca$export$8f2c4b97a6e00f7f = 'action-editor-find-replace'; // --- Nested / Combined Actions ---
const $511857b10ace36ca$var$COMBINED_ACTION_ARCHIVE = 'combined-action-archive';
const $511857b10ace36ca$var$isWebItem = (item)=>{
    return typeof item === 'object' && 'id' in item;
};
const $511857b10ace36ca$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-types-header.content-types.more-actions.label",
        defaultMessage: "More actions"
    },
    tooltip: {
        id: "content-types-header.content-types.more-actions.disabled-tooltip",
        defaultMessage: "Coming soon"
    },
    templatesImportLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.templates",
        defaultMessage: "Templates and import"
    },
    templatesLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.templates-only",
        defaultMessage: "Templates"
    },
    importLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.import-only",
        defaultMessage: "Import"
    },
    presentLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.present",
        defaultMessage: "Present"
    },
    revertLabel: {
        id: "content-types-header.revert.label",
        defaultMessage: "Revert to previous version"
    },
    revertEditor: {
        id: "content-types-header.revert.editor.label",
        defaultMessage: "Revert to legacy editor"
    },
    help: {
        id: "content-types-header.ellipsis.open.ellipsis.help",
        defaultMessage: "Help"
    },
    previewLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.preview",
        defaultMessage: "Preview"
    },
    manageLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.manage",
        defaultMessage: "Manage"
    },
    versionHistoryLabel: {
        id: "content-types-header.version.history.label",
        defaultMessage: "Version history"
    },
    convertToPage: {
        id: "content-types-header.ellipsis.open.ellipsis.convert-to-page",
        defaultMessage: "Convert to page"
    },
    companyHubFeedback: {
        id: "content-types-header.ellipsis.open.ellipsis.hub.share-feedback",
        defaultMessage: "Give feedback on Company hub"
    },
    editorUndoLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.editor-undo",
        defaultMessage: "Undo"
    },
    editorRedoLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.editor-redo",
        defaultMessage: "Redo"
    },
    editorFindReplaceLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.editor-find-replace",
        defaultMessage: "Find and replace"
    }
});
const $511857b10ace36ca$var$dropdownMenuContainerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    minWidth: '24px',
    display: 'flex',
    alignItems: 'center'
});
const $511857b10ace36ca$var$dropdownMenuContentStyles = (0, $ecnYn.xcss)({
    minWidth: '260px'
});
const $511857b10ace36ca$var$dropdownTriggerBoxStyles = (0, $ecnYn.xcss)({
    position: 'relative'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $511857b10ace36ca$var$KeyboardShortcutIcon = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ppf _2rkofajl _bfhki8nm _syaz1q3r",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // NOTE: These styles are directly copied from ContentTools.tsx in @confluence/content-tools
const $511857b10ace36ca$var$ResolvedCommentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $511857b10ace36ca$var$ResolvedCommentsLabelContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlcs5v _1o9zkb7n _i0dlf1ug _2hwx12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $511857b10ace36ca$var$isItemGroup = (item)=>{
    return !!item.items;
};
const $511857b10ace36ca$var$createActionsMap = (actions)=>{
    const map = {};
    actions?.forEach((action)=>{
        if (action?.id) map[action.id] = action;
    });
    return map;
};
const $511857b10ace36ca$var$useOpenWatchMenuQueryParam = (0, $dPJCf.createSingleQueryParamHook)('openWatchModal');
const $511857b10ace36ca$export$6e6eb6019781c337 = (t0)=>{
    const $ = (0, $frIzR.c)(358);
    const { moreActions: moreActions, contentId: contentId, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey, allowedFeatures: allowedFeatures, hasArchivePermission: hasArchivePermission, showVersionHistorySpotlight: showVersionHistorySpotlight, setShowVersionHistorySpotlight: setShowVersionHistorySpotlight, flags: flags, contentData: contentData, readOnly: readOnly, isConvertToFolderHighlighted: t1, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted } = t0;
    const isConvertToFolderHighlighted = t1 === undefined ? false : t1;
    const intl = (0, $8C5kA.default)();
    const history = (0, $dPJCf.useHistory)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[0] !== contentId || $[1] !== contentMode || $[2] !== contentType || $[3] !== createAnalyticsEvent || $[4] !== spaceKey) {
        t2 = async (eventName)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: eventName,
                    actionSubject: "askToEditContent",
                    source: "moreActionsMenu",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        isContentWrapper: (0, $6mKj3.expValEquals)("confluence_ask_to_edit_across_content_type", "cohort", "test"),
                        spaceKey: spaceKey,
                        contentMode: contentMode || "view"
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = contentMode;
        $[2] = contentType;
        $[3] = createAnalyticsEvent;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const triggerAnalyticsEvent = t2;
    const { saveDraft: saveDraft, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, isContentCreationPanelOpen: isContentCreationPanelOpen, contentCreationPanelMode: contentCreationPanelMode, showRevertDialog: showRevertDialog, onPreviewClicked: onPreviewClicked, hasEditPermission: hasEditPermission, validatePageAndOpenModal: validatePageAndOpenModal, canUndo: editorCanUndo, canRedo: editorCanRedo, undo: editorUndo, redo: editorRedo, activateFindReplace: editorActivateFindReplace } = (0, $3o3i5.useEditorObjectHeaderContext)();
    let t3;
    if ($[6] !== contentId || $[7] !== contentType) {
        t3 = {
            contentId: contentId,
            contentType: contentType
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = t3;
    } else t3 = $[8];
    const isPageOrBlogAutoConverted = (0, $0633edcc0f21cf62$export$38d9182f14dddb00)(t3);
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            source: "hubEditorEllipsisDropdown",
            type: (0, $4cOi8.FeedbackType).COMPANY_HUB
        };
        $[9] = t4;
    } else t4 = $[9];
    const openCompanyHubFeedbackCollector = (0, $lOeVN.useFeedbackCollector)(t4);
    let t5;
    if ($[10] !== validatePageAndOpenModal) {
        t5 = validatePageAndOpenModal?.("OverflowMenuConvertToPage");
        $[10] = validatePageAndOpenModal;
        $[11] = t5;
    } else t5 = $[11];
    const publishPage = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== contentId) {
        t7 = {
            variables: {
                contentId: contentId,
                location: (0, $eSLr0.TOOLS_MENU_CONTAINER),
                locations: t6,
                spaceKey: null,
                version: null
            }
        };
        $[13] = contentId;
        $[14] = t7;
    } else t7 = $[14];
    const [preloadWebItemsQuery, t8] = (0, $lvOsp.useLazyQueryInterop)((0, $iEfsZ.default), t7);
    const { data: webItemsData, called: isWebItemsQueryCalled, error: error, loading: loading } = t8;
    const { showMove: shouldShowMove, showArchive: shouldShowArchive, showCopy: shouldShowCopy, showClassificationMenuAction: shouldShowClassification } = allowedFeatures;
    const [isCopyContentModalOpen, setIsCopyContentModalOpen] = (0, $42omo.useState)(false);
    const [isMoveContentModalOpen, setIsMoveContentModalOpen] = (0, $42omo.useState)(false);
    const [isShortcutTriggered, setIsShortcutTriggered] = (0, $42omo.useState)(false);
    const { isMenuOpen: isMenuOpen, isCloseMenuDisabled: isCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuState)();
    const { setIsMenuOpen: setIsMenuOpen } = (0, $c54hr.useMoreActionsMenuActions)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { edition: edition, isLoggedIn: isLoggedIn, isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const isFreeUser = edition === (0, $euL71.ConfluenceEdition).FREE;
    const isPremiumUser = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const isCommentsEnabled = (0, $1b70db1d5649f5f3$export$5dc260e4e702b5d0)(contentType);
    const isVersionHistoryEnabled = (0, $5thep.useIsVersionHistoryEnabled)(contentType);
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const [nestedPopup, setNestedPopup] = (0, $42omo.useState)(undefined);
    const { showSidePanel: showSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const isExternalCollaborator = (0, $foQ4a.useIsExternalCollaborator)();
    let isSpaceOverviewPage;
    let t9;
    if ($[15] !== contentMode || $[16] !== contentType) {
        isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
        t9 = (0, $ff966189b275be15$export$a2eada40e8c9a2ed)(contentType, contentMode, isSpaceOverviewPage);
        $[15] = contentMode;
        $[16] = contentType;
        $[17] = isSpaceOverviewPage;
        $[18] = t9;
    } else {
        isSpaceOverviewPage = $[17];
        t9 = $[18];
    }
    const isPresentRendered = t9;
    const isLivePage = contentType === "page" && contentMode === "live";
    const [t10] = (0, $efvKr.useLivePageMode)();
    const { mode: livePageMode } = t10;
    const isLivePageViewOnlyPermissions = isLivePage && !hasEditPermission;
    let t11;
    if ($[19] !== contentData?.operations) {
        t11 = (type)=>contentData?.operations?.some((operation)=>operation?.targetType === type && operation?.operation === "update");
        $[19] = contentData?.operations;
        $[20] = t11;
    } else t11 = $[20];
    const hasUpdateOperation = t11;
    let t12;
    if ($[21] !== hasUpdateOperation) {
        t12 = (type_0)=>!hasUpdateOperation(type_0) && (0, $6mKj3.expValEquals)("confluence_ask_to_edit_across_content_type", "cohort", "test");
        $[21] = hasUpdateOperation;
        $[22] = t12;
    } else t12 = $[22];
    const isAskToEditEnabled = t12;
    let t13;
    if ($[23] !== contentType || $[24] !== hasUpdateOperation) {
        t13 = contentType === "page" && !hasUpdateOperation(contentType);
        $[23] = contentType;
        $[24] = hasUpdateOperation;
        $[25] = t13;
    } else t13 = $[25];
    const isPageViewOnlyPermissions = t13;
    let t14;
    if ($[26] !== contentType || $[27] !== isAskToEditEnabled) {
        t14 = (0, $1ggpj.isCanvasContentType)(contentType) && isAskToEditEnabled(contentType);
        $[26] = contentType;
        $[27] = isAskToEditEnabled;
        $[28] = t14;
    } else t14 = $[28];
    const isCanvasViewOnlyPermissions = t14;
    let t15;
    if ($[29] !== contentType || $[30] !== isAskToEditEnabled) {
        t15 = contentType === "database" && isAskToEditEnabled(contentType);
        $[29] = contentType;
        $[30] = isAskToEditEnabled;
        $[31] = t15;
    } else t15 = $[31];
    const isDatabaseViewOnlyPermissions = t15;
    let t16;
    if ($[32] !== contentType || $[33] !== isAskToEditEnabled) {
        t16 = contentType === "blogpost" && isAskToEditEnabled(contentType);
        $[32] = contentType;
        $[33] = isAskToEditEnabled;
        $[34] = t16;
    } else t16 = $[34];
    const isBlogViewOnlyPermissions = t16;
    const isContentViewOnlyPermissions = isLivePageViewOnlyPermissions || isPageViewOnlyPermissions || isCanvasViewOnlyPermissions || isDatabaseViewOnlyPermissions || isBlogViewOnlyPermissions;
    const contentStatus = contentData?.status || undefined;
    const isArchived = contentData?.status === "archived";
    const isStarringEnabledForContentType = (0, $2cKGu.useIsStarringEnabled)(contentType, contentMode);
    const [t17] = (0, $7J5Uc.useThemingState)();
    const { theme: theme } = t17;
    const openWatchModalQueryParam = Boolean($511857b10ace36ca$var$useOpenWatchMenuQueryParam());
    const { setQueryParams: setQueryParams, push: push } = (0, $dPJCf.useRouteActions)();
    let t18;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = {
            step: (0, $bzwhi.MoreActionsObjectSidebarTourSteps).FIRST
        };
        $[35] = t18;
    } else t18 = $[35];
    const { activeSpotlight: activeSpotlight, isHintVisible: isHintVisible, resetTour: resetTour } = (0, $bzwhi.useMoreActionsObjectSidebarTour)(t18);
    let t19;
    if ($[36] !== contentData?.operations || $[37] !== contentType) {
        t19 = contentData?.operations?.filter((operation_0)=>operation_0?.targetType === contentType && operation_0?.operation === "read").length;
        $[36] = contentData?.operations;
        $[37] = contentType;
        $[38] = t19;
    } else t19 = $[38];
    const hasReadPermission = Boolean(t19);
    const shouldRenderStarContentMenuItem = isStarringEnabledForContentType && !!allowedFeatures.showFavourite && !isSpaceOverviewPage && hasReadPermission;
    const shouldRenderStarSpaceMenuItem = isSpaceOverviewPage && isLoggedIn;
    let t20;
    if ($[39] !== spaceKey) {
        t20 = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        $[39] = spaceKey;
        $[40] = t20;
    } else t20 = $[40];
    const isCompanyHub = t20;
    let t21;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = [
            (0, $aYZaZ.Buttons).DELETE_DRAFT,
            (0, $aYZaZ.Buttons).MANAGE,
            (0, $aYZaZ.Buttons).RESOLVED_COMMENTS,
            (0, $aYZaZ.Buttons).VIEW_CHANGES
        ];
        $[41] = t21;
    } else t21 = $[41];
    const companyHubEllipsisButtons = t21;
    let t22;
    if ($[42] !== isCompanyHub) {
        const allowedEllipsisButtons = isCompanyHub ? companyHubEllipsisButtons : [
            (0, $aYZaZ.Buttons).PUBLISH_WITHOUT_NOTIFY,
            (0, $aYZaZ.Buttons).DELETE_DRAFT,
            (0, $aYZaZ.Buttons).EDIT_LABELS,
            (0, $aYZaZ.Buttons).MOVE_PAGE,
            (0, $aYZaZ.Buttons).PREVIEW,
            (0, $aYZaZ.Buttons).RESOLVED_COMMENTS,
            (0, $aYZaZ.Buttons).TEMPLATE_BROWSER,
            (0, $aYZaZ.Buttons).VIEW_CHANGES,
            (0, $aYZaZ.Buttons).SWITCH_TO_LIVE_EDIT,
            (0, $aYZaZ.Buttons).CLASSIFY_CONTENT
        ];
        t22 = (menuItem)=>allowedEllipsisButtons?.includes(menuItem) ?? true;
        $[42] = isCompanyHub;
        $[43] = t22;
    } else t22 = $[43];
    const isAllowed = t22;
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    let t23;
    let t24;
    if ($[44] !== setIsMenuOpen || $[45] !== showVersionHistorySpotlight) {
        t23 = ()=>{
            if (showVersionHistorySpotlight) setIsMenuOpen(true);
            return ()=>{
                setIsMenuOpen(false);
            };
        };
        t24 = [
            setIsMenuOpen,
            showVersionHistorySpotlight
        ];
        $[44] = setIsMenuOpen;
        $[45] = showVersionHistorySpotlight;
        $[46] = t23;
        $[47] = t24;
    } else {
        t23 = $[46];
        t24 = $[47];
    }
    (0, $42omo.useEffect)(t23, t24);
    let t25;
    let t26;
    if ($[48] !== isConvertToFolderHighlighted || $[49] !== setIsMenuOpen) {
        t25 = ()=>{
            if (isConvertToFolderHighlighted) {
                setIsMenuOpen(isConvertToFolderHighlighted);
                setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Convert);
            }
        };
        t26 = [
            isConvertToFolderHighlighted,
            setIsMenuOpen
        ];
        $[48] = isConvertToFolderHighlighted;
        $[49] = setIsMenuOpen;
        $[50] = t25;
        $[51] = t26;
    } else {
        t25 = $[50];
        t26 = $[51];
    }
    (0, $42omo.useEffect)(t25, t26);
    let t27;
    if ($[52] !== allowedFeatures.showWatchDialog || $[53] !== contentMode || $[54] !== contentType || $[55] !== loading || $[56] !== openWatchModalQueryParam || $[57] !== setIsMenuOpen || $[58] !== setQueryParams) {
        t27 = ()=>{
            if (openWatchModalQueryParam && contentType && contentMode && !loading) {
                if ((0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && !!allowedFeatures.showWatchDialog) {
                    setIsMenuOpen(true);
                    setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch);
                }
                setQueryParams({
                    openWatchModal: null
                });
            }
        };
        $[52] = allowedFeatures.showWatchDialog;
        $[53] = contentMode;
        $[54] = contentType;
        $[55] = loading;
        $[56] = openWatchModalQueryParam;
        $[57] = setIsMenuOpen;
        $[58] = setQueryParams;
        $[59] = t27;
    } else t27 = $[59];
    let t28;
    if ($[60] !== allowedFeatures || $[61] !== contentMode || $[62] !== contentType || $[63] !== loading || $[64] !== openWatchModalQueryParam || $[65] !== setIsMenuOpen || $[66] !== setQueryParams) {
        t28 = [
            openWatchModalQueryParam,
            setQueryParams,
            contentType,
            contentMode,
            loading,
            allowedFeatures,
            setIsMenuOpen
        ];
        $[60] = allowedFeatures;
        $[61] = contentMode;
        $[62] = contentType;
        $[63] = loading;
        $[64] = openWatchModalQueryParam;
        $[65] = setIsMenuOpen;
        $[66] = setQueryParams;
        $[67] = t28;
    } else t28 = $[67];
    (0, $42omo.useEffect)(t27, t28);
    let t29;
    if ($[68] !== isShortcutTriggered || $[69] !== loading || $[70] !== webItemsData?.webItemSections) {
        t29 = ()=>{
            if (isShortcutTriggered && !loading) {
                if (webItemsData?.webItemSections?.some($511857b10ace36ca$var$_temp)) {
                    (0, $4GDP8.openMoreActionsMenuClick)();
                    (0, $4GDP8.simulateItemClick)($511857b10ace36ca$export$240b6ef4a1c531f6);
                }
                setIsShortcutTriggered(false);
            }
        };
        $[68] = isShortcutTriggered;
        $[69] = loading;
        $[70] = webItemsData?.webItemSections;
        $[71] = t29;
    } else t29 = $[71];
    let t30;
    if ($[72] !== isShortcutTriggered || $[73] !== loading || $[74] !== webItemsData) {
        t30 = [
            isShortcutTriggered,
            webItemsData,
            loading
        ];
        $[72] = isShortcutTriggered;
        $[73] = loading;
        $[74] = webItemsData;
        $[75] = t30;
    } else t30 = $[75];
    (0, $42omo.useEffect)(t29, t30);
    let t31;
    if ($[76] !== activeSpotlight || $[77] !== contentId || $[78] !== createAnalyticsEvent || $[79] !== isCloseMenuDisabled || $[80] !== resetTour || $[81] !== setIsConvertToFolderHighlighted || $[82] !== setIsMenuOpen || $[83] !== spaceId) {
        t31 = (t32)=>{
            const { isOpen: isOpen } = t32;
            if (!isOpen && isCloseMenuDisabled && (0, $9wGTI.fg)("cc_modernize_ga_changeboarding")) return;
            if (activeSpotlight) return;
            setIsMenuOpen(isOpen);
            if (!isOpen) {
                resetTour();
                setNestedPopup(undefined);
                setIsConvertToFolderHighlighted?.(false);
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contentTypeHeaderMoreActions",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader",
                    attributes: {
                        isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                    }
                }
            }).fire();
        };
        $[76] = activeSpotlight;
        $[77] = contentId;
        $[78] = createAnalyticsEvent;
        $[79] = isCloseMenuDisabled;
        $[80] = resetTour;
        $[81] = setIsConvertToFolderHighlighted;
        $[82] = setIsMenuOpen;
        $[83] = spaceId;
        $[84] = t31;
    } else t31 = $[84];
    const handleOpenChange = t31;
    let t32;
    if ($[85] !== preloadWebItemsQuery) {
        t32 = ()=>{
            preloadWebItemsQuery();
        };
        $[85] = preloadWebItemsQuery;
        $[86] = t32;
    } else t32 = $[86];
    const preloadWebItems = t32;
    let t33;
    if ($[87] !== nestedPopup) {
        t33 = (nestedMenuType)=>{
            if (nestedPopup === nestedMenuType) setNestedPopup(undefined);
            else setNestedPopup(nestedMenuType);
        };
        $[87] = nestedPopup;
        $[88] = t33;
    } else t33 = $[88];
    const handleNestedMenuItemClick = t33;
    let t34;
    if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = ()=>{
            setNestedPopup(undefined);
        };
        $[89] = t34;
    } else t34 = $[89];
    const handleNestedMenuItemClose = t34;
    let t35;
    if ($[90] !== moreActions || $[91] !== nestedPopup) {
        t35 = ()=>{
            if (!moreActions?.items?.length) return;
            return moreActions.items.map((itemGroup, idx)=>itemGroup.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                    key: idx,
                    hasSeparator: true
                }, itemGroup.map((item)=>{
                    if ($511857b10ace36ca$var$isItemGroup(item)) {
                        const { id: groupId, items: groupItems, text: groupText } = item;
                        const handleOnOpenChange = (t36)=>{
                            const { isOpen: isOpen_0 } = t36;
                            if (isOpen_0) setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).MoreSupport);
                            else setNestedPopup(undefined);
                        };
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
                            key: groupId,
                            placement: "left-start",
                            trigger: (t37)=>{
                                const { triggerRef: triggerRef, ...triggerProps } = t37;
                                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                                    ...triggerProps,
                                    ref: triggerRef,
                                    testId: `${groupId}-button`,
                                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                        color: "var(--ds-icon-subtle, #505258)",
                                        label: "",
                                        size: "small"
                                    })
                                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, groupText));
                            },
                            isOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).MoreSupport,
                            onOpenChange: handleOnOpenChange,
                            shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-truedisco")
                        }, groupItems.map($511857b10ace36ca$var$_temp2));
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item,
                        key: item.id
                    });
                })));
        };
        $[90] = moreActions;
        $[91] = nestedPopup;
        $[92] = t35;
    } else t35 = $[92];
    const renderMoreActions = t35;
    let t36;
    if ($[93] !== contentId || $[94] !== contentType || $[95] !== experienceTracker || $[96] !== setIsMenuOpen) {
        t36 = (dialogs)=>{
            experienceTracker.start({
                name: (0, $irVI7.DELETE_PAGE_EXPERIENCE)
            });
            dialogs.showModal((0, $6ykQV.DeleteNestedPagesActionLoader), {
                contentId: contentId,
                source: "contentTypesHeader",
                shouldRedirectOnSuccess: true,
                contentType: contentType
            });
            setIsMenuOpen(false);
        };
        $[93] = contentId;
        $[94] = contentType;
        $[95] = experienceTracker;
        $[96] = setIsMenuOpen;
        $[97] = t36;
    } else t36 = $[97];
    const onDeleteClick = t36;
    let t37;
    if ($[98] !== contentId || $[99] !== spaceKey) {
        t37 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bHd1w.MovePageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: ()=>setIsMoveContentModalOpen(false),
                onCloseComplete: ()=>setIsMoveContentModalOpen(false),
                referrer: "content-types-header"
            });
        $[98] = contentId;
        $[99] = spaceKey;
        $[100] = t37;
    } else t37 = $[100];
    const renderMoveContentModal = t37;
    let t38;
    if ($[101] !== contentId || $[102] !== contentMode || $[103] !== experienceTracker || $[104] !== spaceKey) {
        t38 = (dialogs_0)=>{
            experienceTracker.start({
                name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
            });
            dialogs_0.showDialog((0, $bHd1w.MovePageDialog), {
                spaceKey: spaceKey,
                contentId: contentId,
                referrer: "view-page-actions-menu",
                isMovingDraftVersion: contentMode === "edit",
                isUnpublishedDraft: contentMode === "draft"
            });
        };
        $[101] = contentId;
        $[102] = contentMode;
        $[103] = experienceTracker;
        $[104] = spaceKey;
        $[105] = t38;
    } else t38 = $[105];
    const renderMovePageModal = t38;
    let t39;
    if ($[106] !== contentId || $[107] !== contentMode || $[108] !== spaceKey) {
        t39 = (dialogs_1)=>{
            dialogs_1.showModal((0, $78wUU.MoveBlogModalLoader), {
                currentSpaceKey: spaceKey,
                blogPostId: contentId,
                isEditMode: contentMode === "edit",
                isUnpublishedDraft: contentMode === "draft"
            });
        };
        $[106] = contentId;
        $[107] = contentMode;
        $[108] = spaceKey;
        $[109] = t39;
    } else t39 = $[109];
    const renderMoveBlogModal = t39;
    let t40;
    if ($[110] !== contentId || $[111] !== spaceKey) {
        t40 = ()=>(0, $6mKj3.expVal)("confluence_modernized_copy_dialog", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3J7TU.CopyPageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: async ()=>setIsCopyContentModalOpen(false)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5FwhF.CopyPageTreeDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: async ()=>setIsCopyContentModalOpen(false)
            });
        $[110] = contentId;
        $[111] = spaceKey;
        $[112] = t40;
    } else t40 = $[112];
    const renderCopyContentModal = t40;
    let t41;
    if ($[113] !== contentId || $[114] !== experienceTracker || $[115] !== isFreeUser || $[116] !== setIsMenuOpen) {
        t41 = (dialogs_2)=>{
            if (isFreeUser) dialogs_2.showDialog((0, $k22lL.ArchiveUpsellDialog));
            else {
                experienceTracker.start({
                    name: (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE)
                });
                dialogs_2.showDialog((0, $2WH1B.ArchivePagesLoader), {
                    contentId: contentId,
                    source: "contentTypesHeader"
                });
            }
            setIsMenuOpen(false);
        };
        $[113] = contentId;
        $[114] = experienceTracker;
        $[115] = isFreeUser;
        $[116] = setIsMenuOpen;
        $[117] = t41;
    } else t41 = $[117];
    const onArchiveClick = t41;
    let t42;
    if ($[118] !== contentId || $[119] !== contentType || $[120] !== createAnalyticsEvent || $[121] !== setShowVersionHistorySpotlight || $[122] !== showSidePanel || $[123] !== showVersionHistorySpotlight || $[124] !== trackExperience) {
        t42 = ()=>{
            setShowVersionHistorySpotlight?.(false);
            trackExperience({
                contentType: contentType,
                experience: "sidePanel",
                task: "start"
            });
            showSidePanel();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "versionHistory",
                    source: "moreActionsMenu",
                    objectId: contentId,
                    objectType: contentType,
                    attributes: {
                        spotlighted: showVersionHistorySpotlight ? 1 : 0,
                        isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                    }
                }
            }).fire();
        };
        $[118] = contentId;
        $[119] = contentType;
        $[120] = createAnalyticsEvent;
        $[121] = setShowVersionHistorySpotlight;
        $[122] = showSidePanel;
        $[123] = showVersionHistorySpotlight;
        $[124] = trackExperience;
        $[125] = t42;
    } else t42 = $[125];
    const handleViewVersionHistory = t42;
    let t43;
    if ($[126] !== createAnalyticsEvent || $[127] !== saveDraft || $[128] !== showRevertDialog) {
        t43 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowRevert",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.({
                isOnClose: false
            });
            showRevertDialog?.();
        };
        $[126] = createAnalyticsEvent;
        $[127] = saveDraft;
        $[128] = showRevertDialog;
        $[129] = t43;
    } else t43 = $[129];
    const onRevertClick = t43;
    let t44;
    if ($[130] !== contentId || $[131] !== contentStatus || $[132] !== contentType || $[133] !== createAnalyticsEvent || $[134] !== push || $[135] !== saveDraft || $[136] !== spaceKey) {
        t44 = (dialogs_3)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowRevertToLegacyEditor",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.({
                isOnClose: false
            });
            dialogs_3.showDialog((0, $b66o6.RevertEditorDialog), {
                contentId: contentId,
                onPageRevert: ()=>(0, $d8oE8.onClickPageRevert)(push, contentType, spaceKey, contentId, (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true) ? contentStatus : undefined)
            });
        };
        $[130] = contentId;
        $[131] = contentStatus;
        $[132] = contentType;
        $[133] = createAnalyticsEvent;
        $[134] = push;
        $[135] = saveDraft;
        $[136] = spaceKey;
        $[137] = t44;
    } else t44 = $[137];
    const onRevertToLegacyEditorClick = t44;
    const onFeedbackClick = $511857b10ace36ca$var$_temp3;
    let t45;
    if ($[138] !== commentService || $[139] !== contentId) {
        t45 = (dialogs_5, context)=>{
            dialogs_5.showDialog((0, $6eFi0.ResolvedInlineCommentsDialogLoader), {
                contentId: contentId,
                context: context,
                onReopenResolvedCommentHandler: (commentIds)=>{
                    commentService.onReopenResolvedComment(commentIds);
                }
            });
        };
        $[138] = commentService;
        $[139] = contentId;
        $[140] = t45;
    } else t45 = $[140];
    const makeInlineCommentsDialogOpener = t45;
    let t46;
    if ($[141] !== contentId || $[142] !== createAnalyticsEvent || $[143] !== experienceTracker || $[144] !== spaceId || $[145] !== theme) {
        t46 = (enterPresenterMode)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "present",
                        source: "moreActions",
                        objectId: contentId,
                        containerId: spaceId,
                        attributes: {
                            currentThemePreference: theme,
                            OStheme: (0, $5yVAS.getSystemPreferredColorScheme)()
                        }
                    }
                }).fire();
                experienceTracker.start({
                    name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
                });
                enterPresenterMode();
            };
        $[141] = contentId;
        $[142] = createAnalyticsEvent;
        $[143] = experienceTracker;
        $[144] = spaceId;
        $[145] = theme;
        $[146] = t46;
    } else t46 = $[146];
    const makePresenterModeOpener = t46;
    let t47;
    if ($[147] !== contentId || $[148] !== contentType || $[149] !== createAnalyticsEvent) {
        t47 = (onPreviewClicked_0)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "previewPage",
                        source: "moreActions",
                        objectId: contentId,
                        objectType: contentType
                    }
                }).fire();
                onPreviewClicked_0(false);
            };
        $[147] = contentId;
        $[148] = contentType;
        $[149] = createAnalyticsEvent;
        $[150] = t47;
    } else t47 = $[150];
    const makePreviewContentHandler = t47;
    let t48;
    if ($[151] !== contentId) {
        t48 = (dialogs_6)=>()=>{
                dialogs_6.showModal((0, $1PC5x.LinkToThisPageDialog), {
                    contentId: contentId
                });
            };
        $[151] = contentId;
        $[152] = t48;
    } else t48 = $[152];
    const openLinkToThisPageDialog = t48;
    let t49;
    if ($[153] !== allowedFeatures.showWatchDialog || $[154] !== contentData?.title || $[155] !== contentId || $[156] !== contentMode || $[157] !== contentType || $[158] !== flags || $[159] !== handleNestedMenuItemClick || $[160] !== hasEditPermission || $[161] !== history || $[162] !== isArchived || $[163] !== isCompanyHub || $[164] !== isContentViewOnlyPermissions || $[165] !== isLoggedIn || $[166] !== isPresentRendered || $[167] !== makePresenterModeOpener || $[168] !== makePreviewContentHandler || $[169] !== nestedPopup || $[170] !== onPreviewClicked || $[171] !== setIsMenuOpen || $[172] !== shouldRenderStarContentMenuItem || $[173] !== shouldRenderStarSpaceMenuItem || $[174] !== spaceId || $[175] !== spaceKey || $[176] !== triggerAnalyticsEvent) {
        t49 = (t50)=>{
            const { webItemsMap: webItemsMap, customActionsMap: customActionsMap } = t50;
            const primaryActionsItems = [
                {
                    name: $511857b10ace36ca$export$35f02acdf766e275,
                    shouldRender: shouldRenderStarSpaceMenuItem,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kPqqM.SpaceStarMenuItemWithQuery), {
                            spaceKey: spaceKey
                        })
                },
                {
                    name: $511857b10ace36ca$export$348fd9bd77c132d9,
                    shouldRender: shouldRenderStarContentMenuItem && !isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daed94f8e5673bda$export$ab53347da13f94fa), {
                            contentId: contentId,
                            contentTitle: contentData?.title || "",
                            contentMode: contentMode || ""
                        })
                },
                {
                    name: $511857b10ace36ca$export$e242b9905c10e726,
                    shouldRender: (0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && !!allowedFeatures.showWatchDialog && !isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b864d3fa23503bf$export$f9409fd8f8b5a92d), {
                            isMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch,
                            contentId: contentId,
                            contentType: contentType,
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            setIsMenuOpen: setIsMenuOpen,
                            onMenuClose: handleNestedMenuItemClose,
                            onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch)
                        })
                },
                {
                    name: $511857b10ace36ca$export$6bb183703c5072f1,
                    shouldRender: isLoggedIn && !isArchived && isContentViewOnlyPermissions,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d3293071a1569ba$export$84d0de3613f64b9a), {
                            contentType: contentType,
                            contentId: contentId,
                            flags: flags,
                            triggerAnalyticsEvent: triggerAnalyticsEvent,
                            askToEditKey: $511857b10ace36ca$export$6bb183703c5072f1
                        })
                },
                {
                    name: $511857b10ace36ca$export$74317f458aa33c63,
                    shouldRender: (0, $ff966189b275be15$export$74e87e549c7a0f96)(contentType, contentMode) && !isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$74317f458aa33c63,
                            onClick: makePreviewContentHandler(onPreviewClicked),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9vvQJ))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: $511857b10ace36ca$export$74317f458aa33c63,
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).PREVIEW
                                ]
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.previewLabel))
                },
                {
                    name: $511857b10ace36ca$export$461acb5c5f9c7b12,
                    shouldRender: isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$461acb5c5f9c7b12,
                            onClick: ()=>history?.push((0, $1NBp8.COMPANY_HUB_SETTINGS).toUrl(), {
                                    from: (0, $1NBp8.COMPANY_HUB_EDIT).name
                                }),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.manageLabel))
                },
                {
                    name: $511857b10ace36ca$export$12b5e6890d8e049c,
                    shouldRender: !!customActionsMap[$511857b10ace36ca$export$12b5e6890d8e049c],
                    component: ()=>{
                        const item_0 = customActionsMap[$511857b10ace36ca$export$12b5e6890d8e049c];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_0,
                            key: item_0.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($avrhI))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$f9e89fba7e6b4574,
                    shouldRender: (0, $ff966189b275be15$export$4a2abd609e31ae47)(contentType) && !!customActionsMap[$511857b10ace36ca$export$f9e89fba7e6b4574],
                    component: ()=>{
                        const item_1 = customActionsMap[$511857b10ace36ca$export$f9e89fba7e6b4574];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_1,
                            key: item_1.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$240b6ef4a1c531f6,
                    shouldRender: isPresentRendered && !!webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).COMMENTS,
                            key: webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6].completeKey
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5KL6w.LazyPresenterModeContextConsumer), {
                            key: `presenter-mode-menu-item-${webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6].completeKey}`
                        }, (enterPresenterMode_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                id: $511857b10ace36ca$export$240b6ef4a1c531f6,
                                key: $511857b10ace36ca$export$240b6ef4a1c531f6,
                                onClick: makePresenterModeOpener(enterPresenterMode_0),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3KUzn))), {
                                    label: ""
                                }),
                                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                                    shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT)
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.presentLabel))))
                },
                {
                    name: "viewEditToggle",
                    shouldShowSeparator: false,
                    shouldRender: Boolean(contentMode === "live" && hasEditPermission),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gDbO8.LivePagesModeChanger), {
                            contentId: contentId,
                            flags: flags,
                            analyticsSource: "livePagesEllipsisDropdown",
                            elemAfter: (0, $434c765ed6791bfa$export$d206439c03b979ee)
                        })
                }
            ];
            const actionsToRender = primaryActionsItems.filter($511857b10ace36ca$var$_temp4);
            return {
                key: "primary-actions",
                items: actionsToRender
            };
        };
        $[153] = allowedFeatures.showWatchDialog;
        $[154] = contentData?.title;
        $[155] = contentId;
        $[156] = contentMode;
        $[157] = contentType;
        $[158] = flags;
        $[159] = handleNestedMenuItemClick;
        $[160] = hasEditPermission;
        $[161] = history;
        $[162] = isArchived;
        $[163] = isCompanyHub;
        $[164] = isContentViewOnlyPermissions;
        $[165] = isLoggedIn;
        $[166] = isPresentRendered;
        $[167] = makePresenterModeOpener;
        $[168] = makePreviewContentHandler;
        $[169] = nestedPopup;
        $[170] = onPreviewClicked;
        $[171] = setIsMenuOpen;
        $[172] = shouldRenderStarContentMenuItem;
        $[173] = shouldRenderStarSpaceMenuItem;
        $[174] = spaceId;
        $[175] = spaceKey;
        $[176] = triggerAnalyticsEvent;
        $[177] = t49;
    } else t49 = $[177];
    const primaryActionData = t49;
    let t50;
    if ($[178] !== allowedFeatures.showArchive || $[179] !== allowedFeatures.showCopy || $[180] !== allowedFeatures.showMove || $[181] !== contentCreationPanelMode || $[182] !== contentId || $[183] !== contentMode || $[184] !== contentType || $[185] !== createAnalyticsEvent || $[186] !== flags || $[187] !== handleNestedMenuItemClick || $[188] !== hasArchivePermission || $[189] !== intl || $[190] !== isCompanyHub || $[191] !== isContentCreationPanelOpen || $[192] !== isConvertToFolderHighlighted || $[193] !== isFreeUser || $[194] !== isLivePageViewOnlyPermissions || $[195] !== isModernEmbeddedConfluence || $[196] !== isRovoEnabled || $[197] !== isSpaceOverviewPage || $[198] !== nestedPopup || $[199] !== onArchiveClick || $[200] !== onClickOpenContentCreationPanel || $[201] !== onDeleteClick || $[202] !== publishPage || $[203] !== readOnly || $[204] !== renderMoveBlogModal || $[205] !== renderMovePageModal || $[206] !== setIsMenuOpen || $[207] !== spaceId || $[208] !== spaceKey) {
        t50 = (t51)=>{
            const { webItems: webItems, webItemsMap: webItemsMap_0, customActionsMap: customActionsMap_0 } = t51;
            const hasArchive = !isCompanyHub && (0, $ff966189b275be15$export$32820bf57e654cf8)(contentType, contentMode) && (hasArchivePermission || isFreeUser) && allowedFeatures.showArchive && !!webItemsMap_0[$511857b10ace36ca$export$d81a93c80838b765];
            const hasDelete = !!webItemsMap_0[$511857b10ace36ca$export$da4fec526a505196];
            const modifyActionsToRender = [
                {
                    name: $511857b10ace36ca$export$21b8b89e4603550f,
                    shouldRender: !!webItemsMap_0[$511857b10ace36ca$export$21b8b89e4603550f],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${$511857b10ace36ca$export$21b8b89e4603550f}`
                        }, (dialogs_7)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$21b8b89e4603550f,
                                onClick: ()=>{
                                    createAnalyticsEvent({
                                        type: "sendUIEvent",
                                        data: {
                                            action: "clicked",
                                            actionSubject: "button",
                                            actionSubjectId: "overflowRestore",
                                            source: "overflowMenu",
                                            attributes: {
                                                isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                                            }
                                        }
                                    }).fire();
                                    dialogs_7.showModal((0, $1Zthr.UnarchivePagesDialogLoader), {
                                        contentId: contentId,
                                        source: "contentTypesHeader"
                                    });
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eix0u))), {
                                    label: ""
                                })
                            }, webItemsMap_0[$511857b10ace36ca$export$21b8b89e4603550f].label))
                },
                {
                    name: $511857b10ace36ca$export$cc1f11fb5e07970e,
                    shouldRender: contentType === "whiteboard" && isRovoEnabled && (0, $9wGTI.fg)("aifc_create_enabled"),
                    component: ()=>(0, $9wGTI.fg)("whiteboard_to_live_doc_header_action_enabled") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eb923bf92acc93d7$export$43890b7edce69789), {
                            spaceKey: spaceKey,
                            contentId: contentId
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
                },
                {
                    name: $511857b10ace36ca$export$94db61d2b880af44,
                    shouldRender: allowedFeatures.showCopy && (0, $ff966189b275be15$export$a130e0ea03d42b0b)(contentType, contentMode) && (!!webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44] || !!customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e]),
                    component: ()=>{
                        (0, $6mKj3.manuallyLogExpExposure)("make_a_copy_cta");
                        if (customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$3131530af790ffe2), {
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).CopyDatabase,
                            handleClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).CopyDatabase),
                            copyDatabaseItem: webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44],
                            copyStructureItem: customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e],
                            setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                            contentMode: contentMode,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        });
                        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$36ee254e582a74c2), {
                            setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                            closeParentMenu: ()=>setIsMenuOpen(false),
                            item: webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44]
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$bcce08436c9de127,
                    shouldRender: !isLivePageViewOnlyPermissions && allowedFeatures.showMove && !isCompanyHub && (0, $ff966189b275be15$export$dec488a51a9b97f0)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$bcce08436c9de127],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${$511857b10ace36ca$export$bcce08436c9de127}`
                        }, (dialogs_8)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$bcce08436c9de127,
                                onClick: ()=>renderMovePageModal(dialogs_8),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                                    label: ""
                                })
                            }, webItemsMap_0[$511857b10ace36ca$export$bcce08436c9de127].label))
                },
                {
                    name: $511857b10ace36ca$export$c7733ea6d8e45875,
                    shouldRender: allowedFeatures.showMove && (0, $ff966189b275be15$export$dec488a51a9b97f0)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$c7733ea6d8e45875],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${$511857b10ace36ca$export$c7733ea6d8e45875}`
                        }, (dialogs_9)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$c7733ea6d8e45875,
                                onClick: ()=>renderMoveBlogModal(dialogs_9),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                                    label: ""
                                })
                            }, webItemsMap_0[$511857b10ace36ca$export$c7733ea6d8e45875].label))
                },
                {
                    name: $511857b10ace36ca$export$b1a4c392275ea35a,
                    shouldRender: (!(0, $6mKj3.expVal)("cc_snippets", "isEnabled", false) || contentType !== "page") && (0, $ff966189b275be15$export$f7bde71715697ce0)(contentType, contentMode, readOnly) && !isContentCreationPanelOpen && !isLivePageViewOnlyPermissions && (!(0, $1ggpj.isCanvasContentType)(contentType) || !!customActionsMap_0[$511857b10ace36ca$export$d4cf3906d3082596] || !!customActionsMap_0[$511857b10ace36ca$export$cce5e117e5e43bc]),
                    component: ()=>{
                        if (customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea]) {
                            customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea].text = intl.formatMessage($511857b10ace36ca$var$i18n.templatesImportLabel);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                                item: customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea],
                                key: $511857b10ace36ca$export$be7385413e15c3ea,
                                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                    label: ""
                                })
                            });
                        } else {
                            if (customActionsMap_0[$511857b10ace36ca$export$d4cf3906d3082596] || customActionsMap_0[$511857b10ace36ca$export$cce5e117e5e43bc]) {
                                const nestedItems = [];
                                const createNestedItem = (actionKey)=>{
                                    const action = customActionsMap_0[actionKey];
                                    if (action) nestedItems.push({
                                        ...action,
                                        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                                                item: action,
                                                key: action.id
                                            })
                                    });
                                };
                                createNestedItem($511857b10ace36ca$export$d4cf3906d3082596);
                                createNestedItem($511857b10ace36ca$export$cce5e117e5e43bc);
                                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.templatesImportLabel),
                                    isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).TemplatesAndImport,
                                    onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).TemplatesAndImport),
                                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                        label: ""
                                    }),
                                    items: nestedItems,
                                    onMenuClose: handleNestedMenuItemClose
                                });
                            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$b1a4c392275ea35a,
                                onClick: ()=>onClickOpenContentCreationPanel?.(),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.templatesImportLabel));
                        }
                    }
                },
                {
                    name: $511857b10ace36ca$export$2728c726be07790,
                    shouldRender: contentType === "page" && (0, $ff966189b275be15$export$f7bde71715697ce0)(contentType, contentMode, readOnly) && !isLivePageViewOnlyPermissions && (!isContentCreationPanelOpen || contentCreationPanelMode === (0, $lJDEI.PANEL_MODE_IMPORT)) && (0, $6mKj3.expVal)("cc_snippets", "isEnabled", false),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$2728c726be07790,
                            onClick: ()=>onClickOpenContentCreationPanel?.((0, $lJDEI.PANEL_MODE_TEMPLATES)),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isFEX))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.templatesLabel))
                },
                {
                    name: $511857b10ace36ca$export$f1ffcc01948271f7,
                    shouldRender: contentType === "page" && !isModernEmbeddedConfluence && (0, $ff966189b275be15$export$f7bde71715697ce0)(contentType, contentMode, readOnly) && !isLivePageViewOnlyPermissions && (!isContentCreationPanelOpen || contentCreationPanelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES)) && (0, $6mKj3.expVal)("cc_snippets", "isEnabled", false),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$f1ffcc01948271f7,
                            onClick: ()=>onClickOpenContentCreationPanel?.((0, $lJDEI.PANEL_MODE_IMPORT)),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.importLabel))
                },
                {
                    name: $511857b10ace36ca$export$10f4bed2ae52719b,
                    shouldRender: (0, $ff966189b275be15$export$d790dfbcfcf44b71)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $690df6788a087387$export$d91fa1ff1d654586), {
                            item: webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b],
                            contentMode: contentMode,
                            flags: flags,
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            contentId: contentId,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        })
                },
                {
                    name: $511857b10ace36ca$export$8ba85686c8897eca,
                    shouldRender: (0, $ff966189b275be15$export$37d144a1b557c80d)(contentType, contentMode) && !isLivePageViewOnlyPermissions,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                            name: (0, $47zp4.CONVERT_TO_PAGE_SPOTLIGHT_TARGET)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$8ba85686c8897eca,
                            onClick: publishPage,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.convertToPage)))
                },
                {
                    name: $511857b10ace36ca$export$3192aea0628d957a,
                    shouldRender: (0, $ff966189b275be15$export$78b7a39935e0bb86)(contentType, contentMode, isSpaceOverviewPage) && (!!webItemsMap_0[$511857b10ace36ca$export$5497d83bbd1b1232] || !!webItemsMap_0[$511857b10ace36ca$export$7767afe5b675f4b1] || !!webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b]),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$1a264aaf74bdd787), {
                            webItemsMap: webItemsMap_0,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            spaceKey: spaceKey,
                            contentId: contentId,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            flags: flags,
                            spaceId: spaceId,
                            contentMode: contentMode,
                            closeParentMenu: ()=>setIsMenuOpen(false),
                            isConvertToFolderHighlighted: isConvertToFolderHighlighted
                        })
                },
                {
                    name: $511857b10ace36ca$export$ab4fe2a2881747b5,
                    shouldRender: (0, $ff966189b275be15$export$58a134bd2769b459)(contentType, contentMode) && (!!webItemsMap_0[$511857b10ace36ca$export$5da5719a925f973] || !!webItemsMap_0[$511857b10ace36ca$export$bbe81b5a8b0eaf4]),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b945ccaa4d42d330), {
                            webItemsMap: webItemsMap_0,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        })
                },
                {
                    name: $511857b10ace36ca$export$d588519b9727f1cc,
                    shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$d588519b9727f1cc],
                    component: ()=>{
                        const item_3 = customActionsMap_0[$511857b10ace36ca$export$d588519b9727f1cc];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_3,
                            key: item_3.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                                label: ""
                            }),
                            testId: "whiteboard-export-button"
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$f0ae5a9b5b44d373,
                    shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$f0ae5a9b5b44d373],
                    component: ()=>{
                        const item_4 = customActionsMap_0[$511857b10ace36ca$export$f0ae5a9b5b44d373];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_4,
                            key: item_4.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$e07ca208ff99048e,
                    shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$e07ca208ff99048e],
                    component: ()=>{
                        const item_5 = customActionsMap_0[$511857b10ace36ca$export$e07ca208ff99048e];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_5,
                            key: item_5.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                                label: ""
                            }),
                            testId: "database-export-button"
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$d81a93c80838b765,
                    shouldRender: hasArchive && !hasDelete,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f4be76d677f42fda), {
                            onArchiveClick: onArchiveClick
                        })
                },
                {
                    name: $511857b10ace36ca$export$da4fec526a505196,
                    shouldRender: hasDelete && !hasArchive,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$5ac124715785374c), {
                            contentMode: contentMode,
                            onDeleteClick: onDeleteClick,
                            createAnalyticsEvent: createAnalyticsEvent
                        })
                },
                {
                    name: $511857b10ace36ca$var$COMBINED_ACTION_ARCHIVE,
                    shouldRender: hasArchive && hasDelete,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$a05f0dd30396f811), {
                            webItems: webItems,
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Archive,
                            handleClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Archive),
                            onArchiveClick: onArchiveClick,
                            onDeleteClick: onDeleteClick,
                            contentMode: contentMode,
                            createAnalyticsEvent: createAnalyticsEvent,
                            handleNestedMenuItemClose: handleNestedMenuItemClose
                        })
                }
            ];
            const actionsToRender_0 = modifyActionsToRender.filter($511857b10ace36ca$var$_temp5);
            return {
                key: "modify-actions",
                items: actionsToRender_0
            };
        };
        $[178] = allowedFeatures.showArchive;
        $[179] = allowedFeatures.showCopy;
        $[180] = allowedFeatures.showMove;
        $[181] = contentCreationPanelMode;
        $[182] = contentId;
        $[183] = contentMode;
        $[184] = contentType;
        $[185] = createAnalyticsEvent;
        $[186] = flags;
        $[187] = handleNestedMenuItemClick;
        $[188] = hasArchivePermission;
        $[189] = intl;
        $[190] = isCompanyHub;
        $[191] = isContentCreationPanelOpen;
        $[192] = isConvertToFolderHighlighted;
        $[193] = isFreeUser;
        $[194] = isLivePageViewOnlyPermissions;
        $[195] = isModernEmbeddedConfluence;
        $[196] = isRovoEnabled;
        $[197] = isSpaceOverviewPage;
        $[198] = nestedPopup;
        $[199] = onArchiveClick;
        $[200] = onClickOpenContentCreationPanel;
        $[201] = onDeleteClick;
        $[202] = publishPage;
        $[203] = readOnly;
        $[204] = renderMoveBlogModal;
        $[205] = renderMovePageModal;
        $[206] = setIsMenuOpen;
        $[207] = spaceId;
        $[208] = spaceKey;
        $[209] = t50;
    } else t50 = $[209];
    const modifyActionData = t50;
    let t51;
    if ($[210] !== contentMode) {
        t51 = (customActionsMap_1)=>[
                {
                    name: $511857b10ace36ca$export$6563b47d35bee4f1,
                    shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$6563b47d35bee4f1] && contentMode !== "archived",
                    component: ()=>{
                        const item_7 = customActionsMap_1[$511857b10ace36ca$export$6563b47d35bee4f1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_7,
                            key: item_7.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$fe723f15ba37849b,
                    shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$fe723f15ba37849b] && contentMode !== "archived",
                    component: ()=>{
                        const item_8 = customActionsMap_1[$511857b10ace36ca$export$fe723f15ba37849b];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_8,
                            key: item_8.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFjZK))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$d7bae9f2073f40be,
                    shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$d7bae9f2073f40be],
                    component: ()=>{
                        const item_9 = customActionsMap_1[$511857b10ace36ca$export$d7bae9f2073f40be];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_9,
                            key: item_9.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                label: ""
                            })
                        });
                    }
                }
            ];
        $[210] = contentMode;
        $[211] = t51;
    } else t51 = $[211];
    const getDatabaseActionItems = t51;
    let t52;
    if ($[212] !== allowedFeatures.showClassificationMenuAction || $[213] !== contentData?.operations || $[214] !== contentData?.title || $[215] !== contentId || $[216] !== contentMode || $[217] !== contentType || $[218] !== createAnalyticsEvent || $[219] !== experienceTracker || $[220] !== getDatabaseActionItems || $[221] !== handleNestedMenuItemClick || $[222] !== handleViewVersionHistory || $[223] !== intl || $[224] !== isAllowed || $[225] !== isCommentsEnabled || $[226] !== isCompanyHub || $[227] !== isExternalCollaborator || $[228] !== isLivePage || $[229] !== isLivePageViewOnlyPermissions || $[230] !== isLoggedIn || $[231] !== isMenuOpen || $[232] !== isPageOrBlogAutoConverted || $[233] !== isPremiumUser || $[234] !== isSpaceOverviewPage || $[235] !== isVersionHistoryEnabled || $[236] !== makeInlineCommentsDialogOpener || $[237] !== nestedPopup || $[238] !== onRevertClick || $[239] !== onRevertToLegacyEditorClick || $[240] !== saveDraft || $[241] !== setIsMenuOpen || $[242] !== showVersionHistorySpotlight || $[243] !== spaceKey) {
        t52 = (t53)=>{
            const { webItemsMap: webItemsMap_1, customActionsMap: customActionsMap_2, webItems: webItems_0 } = t53;
            const databaseSecondaryActionItems = getDatabaseActionItems(customActionsMap_2);
            const hasEditPermissionRevertToLegacyEditor = contentData?.operations?.some((operation_1)=>operation_1?.targetType === contentType && operation_1?.operation === "update");
            const secondaryActionItems = [
                {
                    name: (0, $aYZaZ.Buttons).VIEW_CHANGES,
                    shouldRender: !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$caca47bf68c8998)(contentType, contentMode) && isAllowed((0, $aYZaZ.Buttons).VIEW_CHANGES),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: (0, $aYZaZ.Buttons).VIEW_CHANGES
                        }, (dialogs_10)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f28b24dc0422311f), {
                                contentId: contentId,
                                dialogs: dialogs_10,
                                saveDraft: saveDraft,
                                createAnalyticsEvent: createAnalyticsEvent
                            }))
                },
                {
                    name: $511857b10ace36ca$export$c9981a2480d638b0,
                    shouldRender: (0, $ff966189b275be15$export$d0c33a26470e0efe)(contentType, contentMode),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$c9981a2480d638b0,
                            onClick: onRevertClick,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.revertLabel))
                },
                {
                    name: $511857b10ace36ca$export$a751f1adb88d1383,
                    shouldRender: isCommentsEnabled && !!webItemsMap_1[$511857b10ace36ca$export$a751f1adb88d1383],
                    component: ()=>{
                        const item_10 = webItemsMap_1[$511857b10ace36ca$export$a751f1adb88d1383];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${item_10.id}`
                        }, (dialogs_11)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: item_10.id,
                                onClick: ()=>{
                                    if ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === "database") makeInlineCommentsDialogOpener(dialogs_11, contentType);
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsLabelContainer, null, item_10.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                                contentId: contentId
                            }))));
                    }
                },
                {
                    name: $511857b10ace36ca$export$a6381225def83c4b,
                    shouldRender: !isExternalCollaborator && !!webItemsMap_1[$511857b10ace36ca$export$a6381225def83c4b],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.RestrictionsDialogMenuPropsProvider), {
                            contentId: contentId
                        }, $511857b10ace36ca$var$_temp6)
                },
                {
                    name: $511857b10ace36ca$export$e14cf657321c833b,
                    shouldRender: isVersionHistoryEnabled && !!webItemsMap_1[$511857b10ace36ca$export$e14cf657321c833b],
                    component: ()=>{
                        const item_11 = webItemsMap_1[$511857b10ace36ca$export$e14cf657321c833b];
                        if (showVersionHistorySpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $330cc2928c11abea$export$cf692ceb431cd214), {
                            key: item_11.id,
                            contentType: contentType,
                            source: "moreActionsMenu"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_11.id,
                            onClick: handleViewVersionHistory,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.versionHistoryLabel)));
                        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_11.id,
                            onClick: handleViewVersionHistory,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.versionHistoryLabel));
                    }
                },
                {
                    name: $511857b10ace36ca$export$fc2e34cd983af5d6,
                    shouldRender: (0, $ff966189b275be15$export$458bbd6d88041c9d)(contentType, contentMode) && !!webItemsMap_1[$511857b10ace36ca$export$fc2e34cd983af5d6],
                    component: ()=>{
                        const item_12 = webItemsMap_1[$511857b10ace36ca$export$fc2e34cd983af5d6];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac5cc0f86197b0c1$export$ea7f8a8a3c6349fc), {
                            itemId: item_12?.id,
                            itemUrl: item_12?.url,
                            label: intl.formatMessage($511857b10ace36ca$var$i18n.versionHistoryLabel),
                            isLivePage: isLivePage,
                            contentType: contentType
                        });
                    }
                },
                ...(0, $9wGTI.fg)("databases-frontend-content-wrapper") ? [] : databaseSecondaryActionItems,
                {
                    name: (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID),
                    shouldRender: !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$11233ac17765daec)(contentType) && !!webItemsMap_1[0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$2ca3e90bac67fd87), {
                            key: (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID),
                            item: webItemsMap_1[0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID],
                            nestedPopup: nestedPopup,
                            setNestedPopup: setNestedPopup,
                            contentId: contentId,
                            setIsMenuOpen: setIsMenuOpen
                        })
                },
                {
                    name: $511857b10ace36ca$export$244b90a342b60d9f,
                    shouldRender: !isLivePageViewOnlyPermissions && !isCompanyHub && (0, $ff966189b275be15$export$5e9136e7e220ab40)(contentType) && allowedFeatures.showClassificationMenuAction,
                    component: $511857b10ace36ca$var$_temp7
                },
                {
                    name: $511857b10ace36ca$export$fe0a3b90b0b6010b,
                    shouldRender: isPremiumUser && isLoggedIn && (0, $ff966189b275be15$export$bb21210c1c36f22a)(contentType, contentMode, isSpaceOverviewPage),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$7e059d95fddc01f4), {
                            experienceTracker: experienceTracker,
                            contentId: contentId,
                            spaceKey: spaceKey,
                            pageTitle: contentData?.title || ""
                        })
                },
                {
                    name: $511857b10ace36ca$export$fe2b6e9bf8b31ecc,
                    shouldRender: (0, $6mKj3.expVal)("confluence_tinymce_deprecation_phase", "value", 0) < 3 && (hasEditPermissionRevertToLegacyEditor || !(0, $6mKj3.expValEquals)("confluence_edit_only_revert_to_legacy", "isEnabled", true)) && (0, $ff966189b275be15$export$493ddb7a4c710fed)(contentType, contentMode, isAllowed((0, $aYZaZ.Buttons).DELETE_DRAFT), (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true)) && isPageOrBlogAutoConverted,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).CC_EDITOR_AI,
                            key: "revert-to-legacy-editor-menu-item"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ]
                        }, (dialogs_12)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$c9981a2480d638b0,
                                onClick: ()=>onRevertToLegacyEditorClick(dialogs_12),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.revertEditor))))
                },
                {
                    name: $511857b10ace36ca$export$52e1dc7e5d9b8b02,
                    shouldRender: (0, $ff966189b275be15$export$49f8860e43af4419)(contentType, contentMode),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f404e2d5b48ab522), {
                            webItemsMap: webItemsMap_1,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        })
                },
                (0, $434c765ed6791bfa$export$f26eff3587fe7632)({
                    isAppsRendered: (0, $ff966189b275be15$export$8623af461a2f6a54)(contentType, contentMode),
                    spaceKey: spaceKey,
                    contentId: contentId,
                    isMenuOpen: isMenuOpen,
                    handleNestedMenuItemClick: handleNestedMenuItemClick,
                    nestedPopup: nestedPopup,
                    items: webItems_0,
                    createAnalyticsEvent: createAnalyticsEvent,
                    handleNestedMenuItemClose: handleNestedMenuItemClose,
                    closeParentMenu: ()=>setIsMenuOpen(false)
                }),
                {
                    name: $511857b10ace36ca$export$23eaedbb3a44a3b5,
                    shouldRender: !!customActionsMap_2[$511857b10ace36ca$export$23eaedbb3a44a3b5],
                    component: ()=>{
                        const item_13 = customActionsMap_2[$511857b10ace36ca$export$23eaedbb3a44a3b5];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_13,
                            key: item_13.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                                label: ""
                            })
                        });
                    }
                }
            ];
            const actionsToRender_1 = secondaryActionItems.filter($511857b10ace36ca$var$_temp8);
            return {
                key: "secondary-actions",
                items: actionsToRender_1
            };
        };
        $[212] = allowedFeatures.showClassificationMenuAction;
        $[213] = contentData?.operations;
        $[214] = contentData?.title;
        $[215] = contentId;
        $[216] = contentMode;
        $[217] = contentType;
        $[218] = createAnalyticsEvent;
        $[219] = experienceTracker;
        $[220] = getDatabaseActionItems;
        $[221] = handleNestedMenuItemClick;
        $[222] = handleViewVersionHistory;
        $[223] = intl;
        $[224] = isAllowed;
        $[225] = isCommentsEnabled;
        $[226] = isCompanyHub;
        $[227] = isExternalCollaborator;
        $[228] = isLivePage;
        $[229] = isLivePageViewOnlyPermissions;
        $[230] = isLoggedIn;
        $[231] = isMenuOpen;
        $[232] = isPageOrBlogAutoConverted;
        $[233] = isPremiumUser;
        $[234] = isSpaceOverviewPage;
        $[235] = isVersionHistoryEnabled;
        $[236] = makeInlineCommentsDialogOpener;
        $[237] = nestedPopup;
        $[238] = onRevertClick;
        $[239] = onRevertToLegacyEditorClick;
        $[240] = saveDraft;
        $[241] = setIsMenuOpen;
        $[242] = showVersionHistorySpotlight;
        $[243] = spaceKey;
        $[244] = t52;
    } else t52 = $[244];
    const secondaryActionData = t52;
    let t53;
    if ($[245] !== getDatabaseActionItems) {
        t53 = (t54)=>{
            const { customActionsMap: customActionsMap_3 } = t54;
            const databaseActionItems = getDatabaseActionItems(customActionsMap_3);
            const actionsToRender_2 = databaseActionItems.filter($511857b10ace36ca$var$_temp9);
            return {
                key: "database-actions",
                items: actionsToRender_2
            };
        };
        $[245] = getDatabaseActionItems;
        $[246] = t53;
    } else t53 = $[246];
    const databaseActionData = t53;
    let t54;
    if ($[247] !== contentMode || $[248] !== contentType || $[249] !== editorActivateFindReplace || $[250] !== editorCanRedo || $[251] !== editorCanUndo || $[252] !== editorRedo || $[253] !== editorUndo || $[254] !== hasEditPermission || $[255] !== livePageMode) {
        t54 = ()=>{
            if (!(0, $ff966189b275be15$export$71ad62dbe8638043)(contentType, contentMode, hasEditPermission, livePageMode)) return {
                key: "editor-actions",
                items: []
            };
            const editorActionItems = [
                {
                    name: $511857b10ace36ca$export$43db96fb923dc5c7,
                    shouldRender: !!editorUndo && !(0, $9wGTI.fg)("platform_editor_ai_aifc_streaming"),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$43db96fb923dc5c7,
                            isDisabled: !editorCanUndo,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: $511857b10ace36ca$export$43db96fb923dc5c7,
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).UNDO
                                ]
                            }),
                            onClick: async ()=>{
                                editorUndo?.();
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorUndoLabel))
                },
                {
                    name: $511857b10ace36ca$export$4e316098da1efb3e,
                    shouldRender: !!editorRedo && !(0, $9wGTI.fg)("platform_editor_ai_aifc_streaming"),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$4e316098da1efb3e,
                            isDisabled: !editorCanRedo,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFjZK))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: $511857b10ace36ca$export$4e316098da1efb3e,
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).REDO
                                ]
                            }),
                            onClick: async ()=>{
                                editorRedo?.();
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorRedoLabel))
                },
                {
                    name: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                    shouldRender: !!editorActivateFindReplace,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).FIND_REPLACE
                                ]
                            }),
                            onClick: async ()=>{
                                editorActivateFindReplace?.();
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorFindReplaceLabel))
                }
            ];
            const actionsToRender_3 = editorActionItems.filter($511857b10ace36ca$var$_temp0);
            return {
                key: "editor-actions",
                items: actionsToRender_3
            };
        };
        $[247] = contentMode;
        $[248] = contentType;
        $[249] = editorActivateFindReplace;
        $[250] = editorCanRedo;
        $[251] = editorCanUndo;
        $[252] = editorRedo;
        $[253] = editorUndo;
        $[254] = hasEditPermission;
        $[255] = livePageMode;
        $[256] = t54;
    } else t54 = $[256];
    const editorActionData = t54;
    let t55;
    if ($[257] !== contentType || $[258] !== handleNestedMenuItemClick || $[259] !== intl || $[260] !== isCompanyHub || $[261] !== nestedPopup || $[262] !== openCompanyHubFeedbackCollector) {
        t55 = (t56)=>{
            const { webItemsMap: webItemsMap_2, customActionsMap: customActionsMap_4, actions: actions } = t56;
            const additionalActionItems = [
                {
                    name: $511857b10ace36ca$export$84c7eab054d974db,
                    shouldRender: (0, $ff966189b275be15$export$46e46e0c15d57a1)(contentType) && !!webItemsMap_2[$511857b10ace36ca$export$84c7eab054d974db],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ]
                        }, (dialogs_13)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$84c7eab054d974db,
                                onClick: ()=>{
                                    onFeedbackClick(dialogs_13, contentType);
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                                    label: ""
                                })
                            }, webItemsMap_2[$511857b10ace36ca$export$84c7eab054d974db].label))
                },
                {
                    name: $511857b10ace36ca$export$5f2e846fff4ab830,
                    shouldRender: (0, $ff966189b275be15$export$1711931c27adfab0)(contentType) && !!customActionsMap_4[$511857b10ace36ca$export$5f2e846fff4ab830],
                    component: ()=>{
                        const items = actions.flat().map($511857b10ace36ca$var$_temp1);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.help),
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Help,
                            onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Help),
                            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                                label: ""
                            }),
                            items: items,
                            onMenuClose: handleNestedMenuItemClose
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$95f3debc4a615fda,
                    shouldRender: (0, $ff966189b275be15$export$1711931c27adfab0)(contentType) && !!customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda],
                    component: ()=>{
                        customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda].text = intl.formatMessage($511857b10ace36ca$var$i18n.help);
                        const item_17 = customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_17,
                            key: item_17.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$54ed9c94f2cfe2b6,
                    shouldRender: !!customActionsMap_4[$511857b10ace36ca$export$54ed9c94f2cfe2b6],
                    component: ()=>{
                        const item_18 = customActionsMap_4[$511857b10ace36ca$export$54ed9c94f2cfe2b6];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_18,
                            key: item_18.id
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$654801d4f89a934,
                    shouldRender: isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$654801d4f89a934,
                            onClick: openCompanyHubFeedbackCollector,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.companyHubFeedback))
                }
            ];
            const actionsToRender_4 = additionalActionItems.filter($511857b10ace36ca$var$_temp10);
            return {
                key: "additional-items",
                items: actionsToRender_4
            };
        };
        $[257] = contentType;
        $[258] = handleNestedMenuItemClick;
        $[259] = intl;
        $[260] = isCompanyHub;
        $[261] = nestedPopup;
        $[262] = openCompanyHubFeedbackCollector;
        $[263] = t55;
    } else t55 = $[263];
    const feedbackActionData = t55;
    let t56;
    if ($[264] !== contentId || $[265] !== hasArchivePermission || $[266] !== onArchiveClick || $[267] !== onDeleteClick || $[268] !== shouldShowArchive || $[269] !== shouldShowCopy || $[270] !== shouldShowMove) {
        t56 = (webItems_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, webItems_1.map((item_20)=>{
                if ($511857b10ace36ca$var$isWebItem(item_20)) {
                    if (shouldShowCopy && item_20?.id === $511857b10ace36ca$export$94db61d2b880af44) {
                        (0, $6mKj3.manuallyLogExpExposure)("make_a_copy_cta");
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_20.id,
                            onClick: ()=>setIsCopyContentModalOpen(true)
                        }, item_20.label);
                    }
                    if (shouldShowMove && item_20?.id === $511857b10ace36ca$export$bcce08436c9de127) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_20.id,
                        onClick: ()=>setIsMoveContentModalOpen(true)
                    }, item_20.label);
                    if (item_20?.id === $511857b10ace36ca$export$21b8b89e4603550f) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_20.id}`
                    }, (dialogs_14)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_20.id,
                            onClick: ()=>{
                                dialogs_14.showDialog((0, $1Zthr.UnarchivePagesDialogLoader), {
                                    contentId: contentId,
                                    source: "contentTypesHeader"
                                });
                            }
                        }, item_20.label));
                    if (item_20?.id === $511857b10ace36ca$export$da4fec526a505196) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_20.id}`
                    }, (dialogs_15)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_20.id,
                            onClick: ()=>{
                                onDeleteClick(dialogs_15);
                            }
                        }, item_20.label));
                    if (item_20?.id === $511857b10ace36ca$export$d81a93c80838b765 && hasArchivePermission && shouldShowArchive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_20.id}`
                    }, (dialogs_16)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_20.id,
                            onClick: ()=>{
                                onArchiveClick(dialogs_16);
                            }
                        }, item_20.label));
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.tooltip),
                    position: "left",
                    key: item_20.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                    isDisabled: true
                }, item_20.label));
                return null;
            }));
        $[264] = contentId;
        $[265] = hasArchivePermission;
        $[266] = onArchiveClick;
        $[267] = onDeleteClick;
        $[268] = shouldShowArchive;
        $[269] = shouldShowCopy;
        $[270] = shouldShowMove;
        $[271] = t56;
    } else t56 = $[271];
    const renderModifyContentActionsWebItems = t56;
    let t57;
    if ($[272] !== contentId || $[273] !== contentType || $[274] !== handleViewVersionHistory || $[275] !== isCommentsEnabled || $[276] !== isVersionHistoryEnabled || $[277] !== makeInlineCommentsDialogOpener || $[278] !== nestedPopup || $[279] !== setIsMenuOpen || $[280] !== shouldShowClassification || $[281] !== showVersionHistorySpotlight) {
        t57 = (webItems_2)=>{
            const webItemsToRender = webItems_2.map((item_21)=>{
                if ($511857b10ace36ca$var$isWebItem(item_21)) {
                    if (item_21?.id === $511857b10ace36ca$export$a751f1adb88d1383 && isCommentsEnabled && ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === "database")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_21.id}`
                    }, (dialogs_17)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_21.id,
                            onClick: ()=>makeInlineCommentsDialogOpener(dialogs_17, contentType)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsLabelContainer, null, item_21.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                            contentId: contentId
                        }))));
                    if (item_21?.id === $511857b10ace36ca$export$e14cf657321c833b && isVersionHistoryEnabled) {
                        if (showVersionHistorySpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $330cc2928c11abea$export$cf692ceb431cd214), {
                            key: item_21.id,
                            contentType: contentType,
                            source: "moreActionsMenu"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_21.id,
                            onClick: handleViewVersionHistory
                        }, item_21.label));
                        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_21.id,
                            onClick: handleViewVersionHistory
                        }, item_21.label);
                    }
                    if (item_21?.id === (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$2ca3e90bac67fd87), {
                        key: `container-${item_21.id}`,
                        item: item_21,
                        nestedPopup: nestedPopup,
                        setNestedPopup: setNestedPopup,
                        contentId: contentId,
                        setIsMenuOpen: setIsMenuOpen
                    });
                }
                return null;
            }).filter(Boolean);
            const itemsToRender = shouldShowClassification ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), {
                    key: "classify-content"
                }),
                ...webItemsToRender
            ] : webItemsToRender;
            return itemsToRender.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                hasSeparator: true
            }, itemsToRender) : null;
        };
        $[272] = contentId;
        $[273] = contentType;
        $[274] = handleViewVersionHistory;
        $[275] = isCommentsEnabled;
        $[276] = isVersionHistoryEnabled;
        $[277] = makeInlineCommentsDialogOpener;
        $[278] = nestedPopup;
        $[279] = setIsMenuOpen;
        $[280] = shouldShowClassification;
        $[281] = showVersionHistorySpotlight;
        $[282] = t57;
    } else t57 = $[282];
    const renderPrimaryContentActionsWebItems = t57;
    let t58;
    if ($[283] !== contentType) {
        t58 = (webItems_3)=>webItems_3.map((item_22)=>{
                if ($511857b10ace36ca$var$isWebItem(item_22)) {
                    if (item_22?.id === $511857b10ace36ca$export$84c7eab054d974db && contentType && (0, $1ggpj.CONTENT_TYPE_FEEDBACK_SOURCE)[contentType]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                        hasSeparator: true,
                        key: `container-${item_22.id}`
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ]
                    }, (dialogs_18)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_22.id,
                            onClick: ()=>{
                                onFeedbackClick(dialogs_18, contentType);
                            }
                        }, item_22.label)));
                }
                return null;
            });
        $[283] = contentType;
        $[284] = t58;
    } else t58 = $[284];
    const renderFeedbackWebItems = t58;
    let t59;
    if ($[285] !== contentType || $[286] !== databaseActionData || $[287] !== editorActionData || $[288] !== feedbackActionData || $[289] !== isCompanyHub || $[290] !== isHintVisible || $[291] !== modifyActionData || $[292] !== moreActions?.items || $[293] !== primaryActionData || $[294] !== secondaryActionData || $[295] !== setIsMenuOpen) {
        t59 = (t60)=>{
            const { webItems: webItems_4 } = t60;
            const webItemsMap_3 = $511857b10ace36ca$var$createActionsMap(webItems_4);
            const customActionsToRender = moreActions?.items?.flat() ?? [];
            const customActionsMap_5 = $511857b10ace36ca$var$createActionsMap(customActionsToRender);
            const [, , , feedbackCustomActions] = moreActions?.items ?? [];
            const actionGroupsToRender = [];
            const primaryActionGroup = primaryActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5
            });
            if (primaryActionGroup.items.length > 0) actionGroupsToRender.push(primaryActionGroup);
            const editorActionGroup = editorActionData();
            if (editorActionGroup.items.length > 0) actionGroupsToRender.push(editorActionGroup);
            if ((0, $9wGTI.fg)("databases-frontend-content-wrapper")) {
                const databaseActionGroup = databaseActionData({
                    customActionsMap: customActionsMap_5
                });
                if (databaseActionGroup.items.length > 0) actionGroupsToRender.push(databaseActionGroup);
            }
            const secondaryActionGroup = secondaryActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5,
                webItems: webItems_4
            });
            if (secondaryActionGroup.items.length > 0) actionGroupsToRender.push(secondaryActionGroup);
            const modifyActionGroup = modifyActionData({
                webItems: webItems_4,
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5
            });
            if (modifyActionGroup.items.length > 0) actionGroupsToRender.push(modifyActionGroup);
            const feedbackActionGroup = feedbackActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5,
                actions: feedbackCustomActions ?? []
            });
            if (feedbackActionGroup.items.length > 0) actionGroupsToRender.push(feedbackActionGroup);
            const shouldRenderMissingActionsHint = isHintVisible && !isCompanyHub && !(0, $1ggpj.isCanvasContentType)(contentType) && contentType !== "database";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $511857b10ace36ca$var$dropdownMenuContentStyles
            }, actionGroupsToRender.map($511857b10ace36ca$var$_temp12), shouldRenderMissingActionsHint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4af5663ac404949d$export$b0ffdc20cd96b8d0), {
                setIsMenuOpen: setIsMenuOpen
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.CONTENT_OVERFLOW_MENU)
            }));
        };
        $[285] = contentType;
        $[286] = databaseActionData;
        $[287] = editorActionData;
        $[288] = feedbackActionData;
        $[289] = isCompanyHub;
        $[290] = isHintVisible;
        $[291] = modifyActionData;
        $[292] = moreActions?.items;
        $[293] = primaryActionData;
        $[294] = secondaryActionData;
        $[295] = setIsMenuOpen;
        $[296] = t59;
    } else t59 = $[296];
    const renderActions = t59;
    let t60;
    if ($[297] === Symbol.for("react.memo_cache_sentinel")) {
        t60 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_OVERFLOW_MENU)
        });
        $[297] = t60;
    } else t60 = $[297];
    let t61;
    if ($[298] !== error) {
        t61 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.CONTENT_OVERFLOW_MENU),
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }));
        $[298] = error;
        $[299] = t61;
    } else t61 = $[299];
    let t62;
    if ($[300] !== isLivePage || $[301] !== isPresentRendered || $[302] !== isWebItemsQueryCalled || $[303] !== preloadWebItems) {
        t62 = isPresentRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: !isLivePage ? (0, $gnkil.PRESENTATION_MODE_SHORTCUT) : undefined,
            accelerator: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT),
            listener: ()=>{
                if (!isWebItemsQueryCalled) preloadWebItems();
                setIsShortcutTriggered(true);
            }
        });
        $[300] = isLivePage;
        $[301] = isPresentRendered;
        $[302] = isWebItemsQueryCalled;
        $[303] = preloadWebItems;
        $[304] = t62;
    } else t62 = $[304];
    let t63;
    if ($[305] !== contentData?.title || $[306] !== contentId || $[307] !== contentMode || $[308] !== contentType || $[309] !== shouldRenderStarContentMenuItem) {
        t63 = shouldRenderStarContentMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85cfaddd6945fc1f$export$2846eba8e457bfb), {
            contentId: contentId,
            contentTitle: contentData?.title || "",
            contentMode: contentMode,
            contentType: contentType
        });
        $[305] = contentData?.title;
        $[306] = contentId;
        $[307] = contentMode;
        $[308] = contentType;
        $[309] = shouldRenderStarContentMenuItem;
        $[310] = t63;
    } else t63 = $[310];
    let t64;
    if ($[311] !== contentMode || $[312] !== shouldRenderStarSpaceMenuItem || $[313] !== spaceKey) {
        t64 = shouldRenderStarSpaceMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6d97f54b872b96e$export$385015a3c6790101), {
            spaceKey: spaceKey,
            contentMode: contentMode
        });
        $[311] = contentMode;
        $[312] = shouldRenderStarSpaceMenuItem;
        $[313] = spaceKey;
        $[314] = t64;
    } else t64 = $[314];
    let t65;
    if ($[315] !== contentId || $[316] !== contentMode || $[317] !== contentType || $[318] !== isMenuOpen || $[319] !== setIsMenuOpen) {
        t65 = (0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c06b6cca0a728bb0$export$154e7cde95b8409b), {
            contentId: contentId,
            contentType: contentType,
            openWatchSettingsMenu: ()=>{
                if (!isMenuOpen) setIsMenuOpen(true);
                setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch);
            }
        });
        $[315] = contentId;
        $[316] = contentMode;
        $[317] = contentType;
        $[318] = isMenuOpen;
        $[319] = setIsMenuOpen;
        $[320] = t65;
    } else t65 = $[320];
    let t66;
    if ($[321] === Symbol.for("react.memo_cache_sentinel")) {
        t66 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[321] = t66;
    } else t66 = $[321];
    let t67;
    if ($[322] !== contentId || $[323] !== contentMode || $[324] !== isMenuOpen || $[325] !== livePageMode || $[326] !== openLinkToThisPageDialog || $[327] !== spaceKey) {
        t67 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t66
        }, (dialogs_19)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                deprecatedAccelerator: contentMode === "view" || contentMode === "live" && livePageMode === "view" ? (0, $gnkil.LINK_TO_THIS_PAGE_SHORTCUT) : undefined,
                accelerator: (0, $gnkil.UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT),
                listener: openLinkToThisPageDialog(dialogs_19)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b742140c6b014561$export$fcc1c0135b5761c6), {
                spaceKey: spaceKey,
                contentId: contentId,
                onLoadComplete: $511857b10ace36ca$var$_temp13,
                isDropdownMenuOpen: isMenuOpen,
                lazyLoaderPlaceholderComponent: ""
            }, $511857b10ace36ca$var$_temp15)));
        $[322] = contentId;
        $[323] = contentMode;
        $[324] = isMenuOpen;
        $[325] = livePageMode;
        $[326] = openLinkToThisPageDialog;
        $[327] = spaceKey;
        $[328] = t67;
    } else t67 = $[328];
    let t68;
    if ($[329] !== activeSpotlight || $[330] !== contentId || $[331] !== handleOpenChange || $[332] !== isMenuOpen || $[333] !== isModernEmbeddedConfluence || $[334] !== loading || $[335] !== preloadWebItems || $[336] !== renderActions || $[337] !== renderFeedbackWebItems || $[338] !== renderModifyContentActionsWebItems || $[339] !== renderMoreActions || $[340] !== renderPrimaryContentActionsWebItems) {
        t68 = !isModernEmbeddedConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && $511857b10ace36ca$var$dropdownMenuContainerStyles
            ],
            onMouseEnter: preloadWebItems
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            isOpen: isMenuOpen,
            onOpenChange: handleOpenChange,
            trigger: $511857b10ace36ca$var$_temp16,
            placement: "bottom-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
            "data-testid": "web-actions-test",
            contentId: contentId,
            location: (0, $eSLr0.TOOLS_MENU_CONTAINER),
            fetchPolicy: "cache-and-network",
            renderWhenLoading: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
        }, (t69)=>{
            const { webItems: webItems_5 } = t69;
            if ((0, $9wGTI.fg)("confluence_frontend_content_wrapper")) {
                if (loading || !webItems_5 || webItems_5.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownMenuContentSkeleton, null);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                    name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).MORE_ACTIONS_ITEMS
                }, renderActions({
                    webItems: webItems_5
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, activeSpotlight));
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                padding: "space.025"
            }, renderModifyContentActionsWebItems(webItems_5), renderPrimaryContentActionsWebItems(webItems_5), renderFeedbackWebItems(webItems_5), renderMoreActions());
        })));
        $[329] = activeSpotlight;
        $[330] = contentId;
        $[331] = handleOpenChange;
        $[332] = isMenuOpen;
        $[333] = isModernEmbeddedConfluence;
        $[334] = loading;
        $[335] = preloadWebItems;
        $[336] = renderActions;
        $[337] = renderFeedbackWebItems;
        $[338] = renderModifyContentActionsWebItems;
        $[339] = renderMoreActions;
        $[340] = renderPrimaryContentActionsWebItems;
        $[341] = t68;
    } else t68 = $[341];
    let t69;
    if ($[342] !== isCopyContentModalOpen || $[343] !== renderCopyContentModal) {
        t69 = isCopyContentModalOpen && renderCopyContentModal();
        $[342] = isCopyContentModalOpen;
        $[343] = renderCopyContentModal;
        $[344] = t69;
    } else t69 = $[344];
    let t70;
    if ($[345] !== isMoveContentModalOpen || $[346] !== renderMoveContentModal) {
        t70 = isMoveContentModalOpen && renderMoveContentModal();
        $[345] = isMoveContentModalOpen;
        $[346] = renderMoveContentModal;
        $[347] = t70;
    } else t70 = $[347];
    let t71;
    if ($[348] !== t61 || $[349] !== t62 || $[350] !== t63 || $[351] !== t64 || $[352] !== t65 || $[353] !== t67 || $[354] !== t68 || $[355] !== t69 || $[356] !== t70) {
        t71 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t60, t61, t62, t63, t64, t65, t67, t68, t69, t70);
        $[348] = t61;
        $[349] = t62;
        $[350] = t63;
        $[351] = t64;
        $[352] = t65;
        $[353] = t67;
        $[354] = t68;
        $[355] = t69;
        $[356] = t70;
        $[357] = t71;
    } else t71 = $[357];
    return t71;
};
const $511857b10ace36ca$var$DropdownMenuTrigger = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { triggerProps: triggerProps } = t0;
    let props;
    let triggerRef;
    if ($[0] !== triggerProps) {
        ({ triggerRef: triggerRef, ...props } = triggerProps);
        $[0] = triggerProps;
        $[1] = props;
        $[2] = triggerRef;
    } else {
        props = $[1];
        triggerRef = $[2];
    }
    const buttonRef = (0, $42omo.useRef)(null);
    const intl = (0, $8C5kA.default)();
    const { isPresenterModeActive: isPresenterModeActive, hasEnteredPresentMode: hasEnteredPresentMode } = (0, $5KL6w.usePresenterModeContext)();
    const [t1] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t1;
    let t2;
    if ($[3] !== isCollabOffline) {
        t2 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[3] = isCollabOffline;
        $[4] = t2;
    } else t2 = $[4];
    const isNetworkDisabled = t2;
    let t3;
    let t4;
    if ($[5] !== hasEnteredPresentMode || $[6] !== isPresenterModeActive) {
        t3 = ()=>{
            if (!isPresenterModeActive && hasEnteredPresentMode && buttonRef?.current) buttonRef.current?.focus();
        };
        t4 = [
            isPresenterModeActive,
            hasEnteredPresentMode
        ];
        $[5] = hasEnteredPresentMode;
        $[6] = isPresenterModeActive;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.triggerLabel);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== intl) {
        t6 = intl.formatMessage($511857b10ace36ca$var$i18n.triggerLabel);
        $[10] = intl;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== triggerRef) {
        t7 = (0, $4rwCt.mergeRefs)([
            triggerRef,
            buttonRef
        ]);
        $[12] = triggerRef;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== isNetworkDisabled || $[15] !== props || $[16] !== t6 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $511857b10ace36ca$var$dropdownTriggerBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "bottom",
            content: t5
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...props,
            label: t6,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
            ref: t7,
            appearance: "subtle",
            id: "more-actions-trigger",
            interactionName: "more-actions-overflow-menu",
            isDisabled: isNetworkDisabled
        })));
        $[14] = isNetworkDisabled;
        $[15] = props;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
};
const $511857b10ace36ca$var$DropdownMenuContentSkeleton = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "more-actions-overflow-menu-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $511857b10ace36ca$var$DropdownItemSkeleton = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            isShimmering: true,
            borderRadius: 0,
            width: 200,
            height: 20
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $511857b10ace36ca$var$_temp(section) {
    return section?.items?.length && section?.items[0]?.id === $511857b10ace36ca$export$240b6ef4a1c531f6;
}
function $511857b10ace36ca$var$_temp2(subItem) {
    const { id: innerId, url: innerUrl, target: innerTarget, onClick: innerOnClick, shortcutText: innerShortcutText, text: innerText } = subItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: innerId,
        href: innerUrl,
        target: innerTarget,
        onClick: innerOnClick,
        elemAfter: innerShortcutText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$KeyboardShortcutIcon, null, innerShortcutText) : undefined
    }, innerText);
}
function $511857b10ace36ca$var$_temp3(dialogs_4, contentTypeForFeedback) {
    dialogs_4.showModal((0, $dcvq8.GlobalFeedbackCollector), {
        feedbackSource: (0, $1ggpj.CONTENT_TYPE_FEEDBACK_SOURCE)[contentTypeForFeedback],
        showTypeField: true,
        contentType: contentTypeForFeedback
    });
}
function $511857b10ace36ca$var$_temp4(item_2) {
    return item_2.shouldRender;
}
function $511857b10ace36ca$var$_temp5(item_6) {
    return item_6.shouldRender;
}
function $511857b10ace36ca$var$_temp6(itemProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
        ...itemProps,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
            label: ""
        })
    });
}
function $511857b10ace36ca$var$_temp7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), {
        key: "classify-content",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GKfl))), {
            label: ""
        })
    });
}
function $511857b10ace36ca$var$_temp8(item_14) {
    return item_14.shouldRender;
}
function $511857b10ace36ca$var$_temp9(item_15) {
    return item_15.shouldRender;
}
function $511857b10ace36ca$var$_temp0(item_16) {
    return item_16.shouldRender;
}
function $511857b10ace36ca$var$_temp1(action_0) {
    return {
        ...action_0,
        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                item: action_0,
                key: action_0.id
            })
    };
}
function $511857b10ace36ca$var$_temp10(item_19) {
    return item_19.shouldRender;
}
function $511857b10ace36ca$var$_temp11(item_23) {
    return item_23.component();
}
function $511857b10ace36ca$var$_temp12(actionGroup, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        hasSeparator: index > 0,
        key: actionGroup.key
    }, actionGroup.items.map($511857b10ace36ca$var$_temp11));
}
function $511857b10ace36ca$var$_temp13() {}
function $511857b10ace36ca$var$_temp14(forgeMenuItem) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
        key: forgeMenuItem?.props?.extension?.id,
        module: forgeMenuItem?.props?.extension,
        action: ()=>{
            (0, $4GDP8.openForgeAppFromSubmenu)({
                parentmenuId: "#more-actions-trigger",
                submenuId: "[data-testid='third-party-button']",
                forgeItemId: forgeMenuItem?.props?.extension?.id
            });
        }
    });
}
function $511857b10ace36ca$var$_temp15(forgeMenuItems) {
    return forgeMenuItems.length > 0 && forgeMenuItems.map($511857b10ace36ca$var$_temp14);
}
function $511857b10ace36ca$var$_temp16(triggerProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownMenuTrigger, {
        triggerProps: triggerProps_0
    });
}



var $9xWyx = parcelRequire("9xWyx");








var $bLtXM = parcelRequire("bLtXM");

const $6967e8de26962a4d$export$99c2b779aa4e8b8b = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { collaborators: collaborators, contentId: contentId, contentType: contentType, contentMode: contentMode, isViewMode: isViewMode } = t0;
    const t1 = contentMode === "view" ? "viewPageScreen" : "editPageScreen";
    let t2;
    if ($[0] !== collaborators || $[1] !== contentId || $[2] !== contentType || $[3] !== isViewMode || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bLtXM.ContentHeaderPresence), {
            collaborators: collaborators,
            contentId: contentId,
            contentType: contentType,
            isViewMode: isViewMode,
            analyticSource: t1
        });
        $[0] = collaborators;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = isViewMode;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};





/**
 * @generated SignedSource<<c753ecb337a1d1138dbceafd7e7f672c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $826269c7e8f31d2c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "EditorCloseButtonGetDraftParentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            }
        ],
        "type": "Content"
    };
}();
$826269c7e8f31d2c$var$node.hash = "2b05313527c3eb54a3e1e06657506abb";
var $826269c7e8f31d2c$export$2e2bcd8739ae039 = $826269c7e8f31d2c$var$node;




















var $hYoU4 = parcelRequire("hYoU4");


var $5M5fB = parcelRequire("5M5fB");


var $1ch0f = parcelRequire("1ch0f");


var $2unW6 = parcelRequire("2unW6");


var $lu0E4 = parcelRequire("lu0E4");


var $5rEAe = parcelRequire("5rEAe");


var $3mmDo = parcelRequire("3mmDo");


var $atF9V = parcelRequire("atF9V");


var $lHzSp = parcelRequire("lHzSp");





var $5cryL = parcelRequire("5cryL");





var $jacyh = parcelRequire("jacyh");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $ecUYt = parcelRequire("ecUYt");


var $fFmJj = parcelRequire("fFmJj");










const $1d832c644d7a0658$var$i18n = (0, $cgtv4.defineMessages)({
    closeButtonText: {
        id: "content-types-header.close.name",
        defaultMessage: "Close"
    },
    closeButtonPublishTooltip: {
        id: "content-types-header.editor.close.publish.tooltip",
        defaultMessage: "Saves changes without publishing"
    },
    closeButtonUpdateTooltip: {
        id: "content-types-header.editor.close.update.tooltip",
        defaultMessage: "Saves changes without updating"
    },
    discardOnCloseButtonTooltip: {
        id: "content-types-header.editor.discard.close.tooltip",
        defaultMessage: "Discard empty draft"
    }
});
const $1d832c644d7a0658$export$f7109619a5e9e0d6 = 'next-FullPageEditorComponent';
const $1d832c644d7a0658$export$f64ffceb1bd6299f = (t0)=>{
    const $ = (0, $frIzR.c)(57);
    const { contentType: contentType, contentId: contentId, spaceKey: spaceKey, pageTreeStateUpdater: pageTreeStateUpdater, areMainButtonsDisabled: t1, isUnpublishedDraft: t2 } = t0;
    const areMainButtonsDisabled = t1 === undefined ? false : t1;
    const isUnpublishedDraft = t2 === undefined ? false : t2;
    const intl = (0, $8C5kA.default)();
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { saveDraft: saveDraft, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, version: version, editorActions: editorActions, title: title } = (0, $3o3i5.useEditorObjectHeaderContext)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fragmentSpec: (0, $826269c7e8f31d2c$export$2e2bcd8739ae039)
        };
        $[0] = t3;
    } else t3 = $[0];
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)(t3);
    const [t4] = (0, $hYoU4.useNativeCollabState)();
    const { collabEditProvider: collabEditProvider } = t4;
    const { isSingleUserSession: isSingleUserSession } = (0, $5M5fB.usePresence)(collabEditProvider);
    const { hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription } = (0, $lHzSp.useEmojiTitleCoverPictureAndContentState)();
    const { hasRestrictions: hasRestrictions } = (0, $atF9V.useRestrictions)();
    const hasLabels = (0, $2unW6.useLabels)(contentId);
    const hasTitle = Boolean(title);
    let t5;
    if ($[1] !== editorActions) {
        t5 = editorActions.isDocumentEmpty();
        $[1] = editorActions;
        $[2] = t5;
    } else t5 = $[2];
    const hasBody = !t5;
    let t6;
    if ($[3] !== hasBody || $[4] !== hasContentState || $[5] !== hasCoverPicture || $[6] !== hasEmoji || $[7] !== hasLabels || $[8] !== hasRestrictions || $[9] !== hasTitle || $[10] !== isSingleUserSession || $[11] !== isUnpublishedDraft) {
        t6 = {
            isUnpublishedDraft: isUnpublishedDraft,
            isSingleUserSession: isSingleUserSession,
            hasTitle: hasTitle,
            hasBody: hasBody,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            hasContentState: hasContentState,
            hasRestrictions: hasRestrictions,
            hasLabels: hasLabels
        };
        $[3] = hasBody;
        $[4] = hasContentState;
        $[5] = hasCoverPicture;
        $[6] = hasEmoji;
        $[7] = hasLabels;
        $[8] = hasRestrictions;
        $[9] = hasTitle;
        $[10] = isSingleUserSession;
        $[11] = isUnpublishedDraft;
        $[12] = t6;
    } else t6 = $[12];
    const discardDraftOnClose = (0, $3mmDo.useWillDeleteBlankDraftOnClose)(t6);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS));
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== version) {
        t8 = !(0, $9wGTI.fg)("cc_onboarding_experience") || version !== 1;
        $[14] = version;
        $[15] = t8;
    } else t8 = $[15];
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(t7, t8);
    let t9;
    if ($[16] !== onboardingStateData) {
        t9 = (0, $ivb8S.deserializeState)(onboardingStateData);
        $[16] = onboardingStateData;
        $[17] = t9;
    } else t9 = $[17];
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, recentSpotlightCompleted: recentSpotlightCompleted } = t9;
    const shouldShowRecentSpotlight = !onboardingStateLoading && editorOnboardingEligiblity && !recentSpotlightCompleted;
    let t10;
    if ($[18] !== contentId || $[19] !== contentType || $[20] !== createAnalyticsEvent || $[21] !== discardDraftOnClose || $[22] !== forceRefetchBlogTree || $[23] !== navigateOnClose || $[24] !== pageTreeStateUpdater || $[25] !== readFragmentInterop || $[26] !== saveDraft || $[27] !== setOnboardingState || $[28] !== shouldShowRecentSpotlight || $[29] !== triggerAnalyticsEvent) {
        t10 = async ()=>{
            if (contentType === "page") (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.EDITOR_CLOSE_BUTTON_CLICK));
            if (shouldShowRecentSpotlight) setOnboardingState({
                key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN,
                value: "true"
            });
            if (discardDraftOnClose) {
                triggerAnalyticsEvent("close", {
                    discarded: true
                });
                (0, $1ch0f.deleteDraft)({
                    contentId: contentId,
                    deleteOnlyIfBlank: true
                }).then(async (t11)=>{
                    const { data: data } = t11;
                    if (contentType === "blogpost") forceRefetchBlogTree();
                    triggerAnalyticsEvent("draftDiscarded", {
                        wasDeleted: !!data?.deleteContent?.wasDeleted
                    });
                    const parentId = await (0, $5rEAe.getParentOfDraft)(contentId, readFragmentInterop);
                    if (parentId) pageTreeStateUpdater.setForceFetchPageId(parentId);
                    else createAnalyticsEvent({
                        type: "sendOperationalEvent",
                        data: {
                            action: "notFound",
                            actionSubject: "discardedDraftParent",
                            objectType: contentType,
                            objectId: contentId
                        }
                    }).fire();
                });
                navigateOnClose({
                    isDiscarding: true
                });
            } else {
                triggerAnalyticsEvent("close");
                saveDraft({
                    isOnClose: true
                }).then(()=>navigateOnClose());
            }
        };
        $[18] = contentId;
        $[19] = contentType;
        $[20] = createAnalyticsEvent;
        $[21] = discardDraftOnClose;
        $[22] = forceRefetchBlogTree;
        $[23] = navigateOnClose;
        $[24] = pageTreeStateUpdater;
        $[25] = readFragmentInterop;
        $[26] = saveDraft;
        $[27] = setOnboardingState;
        $[28] = shouldShowRecentSpotlight;
        $[29] = triggerAnalyticsEvent;
        $[30] = t10;
    } else t10 = $[30];
    const onClose = t10;
    let t11;
    if ($[31] !== areMainButtonsDisabled || $[32] !== discardDraftOnClose || $[33] !== intl || $[34] !== isUnpublishedDraft) {
        t11 = ()=>{
            if (areMainButtonsDisabled) return;
            else {
                if (discardDraftOnClose) return intl.formatMessage($1d832c644d7a0658$var$i18n.discardOnCloseButtonTooltip);
                else {
                    if (isUnpublishedDraft) return intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonPublishTooltip);
                    else return intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonUpdateTooltip);
                }
            }
        };
        $[31] = areMainButtonsDisabled;
        $[32] = discardDraftOnClose;
        $[33] = intl;
        $[34] = isUnpublishedDraft;
        $[35] = t11;
    } else t11 = $[35];
    const getCloseButtonTooltip = t11;
    let t12;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $6mKj3.expValEquals)("platform_editor_hydratable_ui", "isEnabled", true);
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== getCloseButtonTooltip) {
        t13 = getCloseButtonTooltip();
        $[37] = getCloseButtonTooltip;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== intl) {
        t14 = intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonText);
        $[39] = intl;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== areMainButtonsDisabled || $[42] !== onClose || $[43] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            id: "close-button",
            appearance: "subtle",
            onClick: onClose,
            isDisabled: areMainButtonsDisabled,
            testId: "close-button"
        }, t14);
        $[41] = areMainButtonsDisabled;
        $[42] = onClose;
        $[43] = t14;
        $[44] = t15;
    } else t15 = $[44];
    let t16;
    if ($[45] !== t13 || $[46] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t13
        }, t15);
        $[45] = t13;
        $[46] = t15;
        $[47] = t16;
    } else t16 = $[47];
    let t17;
    if ($[48] !== contentId || $[49] !== contentType || $[50] !== isUnpublishedDraft || $[51] !== spaceKey || $[52] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
            name: "close-button",
            enabled: t12
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lu0E4.PreloadButtonWrapper), {
            isPublish: false,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }, t16));
        $[48] = contentId;
        $[49] = contentType;
        $[50] = isUnpublishedDraft;
        $[51] = spaceKey;
        $[52] = t16;
        $[53] = t17;
    } else t17 = $[53];
    let t18;
    if ($[54] !== emojiCoverPictureAndContentStateSubscription || $[55] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, emojiCoverPictureAndContentStateSubscription, t17);
        $[54] = emojiCoverPictureAndContentStateSubscription;
        $[55] = t17;
        $[56] = t18;
    } else t18 = $[56];
    return t18;
};
const $1d832c644d7a0658$export$e392907f0931982f = (0, $ecUYt.withPageTreeStateUpdater)($1d832c644d7a0658$export$f64ffceb1bd6299f);

























var $iXzFq = parcelRequire("iXzFq");


var $3oZ9l = parcelRequire("3oZ9l");



















var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");








var $jSnXV = parcelRequire("jSnXV");












var $6qdjm = parcelRequire("6qdjm");











var $jlIaF = parcelRequire("jlIaF");


var $8lYIw = parcelRequire("8lYIw");





var $kDhla = parcelRequire("kDhla");




















var $e4o8D = parcelRequire("e4o8D");


var $5G6sa = parcelRequire("5G6sa");


var $3jwuS = parcelRequire("3jwuS");













const $f294e68c8b2b1e6c$var$i18n = (0, $cgtv4.defineMessages)({
    saved: {
        id: "content-types-header.last-edited.saved",
        defaultMessage: "Saved"
    },
    shortJustNow: {
        id: "content-types-header.last-edited.shortJustNow",
        defaultMessage: "just now"
    },
    shortXMinutesAgo: {
        id: "content-types-header.last-edited.shortXMinutesAgo",
        defaultMessage: "{timeAgo}m ago"
    },
    shortXHoursAgo: {
        id: "content-types-header.last-edited.shortXHoursAgo",
        defaultMessage: "{timeAgo}h ago"
    },
    shortXDaysAgo: {
        id: "content-types-header.last-edited.shortXDaysAgo",
        defaultMessage: "{timeAgo}d ago"
    },
    tooltipFullDate: {
        id: "content-types-header.last-edited.tooltipFullDate",
        defaultMessage: "{date} at {time}"
    },
    tooltipDate: {
        id: "content-types-header.last-edited.tooltipDate",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{date}"
    },
    edited: {
        id: "content-types-header.last-edited.edited",
        defaultMessage: "Edited {timestamp}"
    },
    published: {
        id: "content-types-header.last-edited.published",
        defaultMessage: "Published {timestamp}"
    },
    updated: {
        id: "content-types-header.last-edited.updated",
        defaultMessage: "Updated {timestamp}"
    },
    editedOn: {
        id: "content-types-header.last-edited.editedOn",
        defaultMessage: "Edited by {contributor} on {timestamp}"
    },
    publishedOn: {
        id: "content-types-header.last-edited.publishedOn",
        defaultMessage: "Published by {contributor} on {timestamp}"
    },
    updatedOn: {
        id: "content-types-header.last-edited.updatedOn",
        defaultMessage: "Updated by {contributor} on {timestamp}"
    }
});
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_SECONDS = 1000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES = 60000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR = 3600000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_DAY = 86400000;
/**
 * Formats full server date in shortened form ('MMM DD') if in the same calendar year, otherwise uses long form ('MMM DD, YYYY)
 */ const $f294e68c8b2b1e6c$var$formatfriendlyWhen = (friendlyWhen)=>{
    const now = new Date();
    const currentYear = now.getUTCFullYear();
    if (friendlyWhen.includes(currentYear.toString())) {
        // We expect that full server date (version.friendlyWhen) is of the format 'MMM DD, YYYY' (Jan 01, 2025) format for US_en
        // If it is not in this format depending on localization, we take the entire date
        const splitDate = friendlyWhen.split(',');
        return splitDate.length === 2 ? splitDate[0] : friendlyWhen;
    }
    return friendlyWhen;
};
const $f294e68c8b2b1e6c$export$f87e4558f7028ac3 = (lastEditedTime, friendlyWhen, isEditMode, formatMessage, renderServerPlaceholder)=>{
    let headerTimestamp;
    const timeNow = new Date();
    let currentTimestamp;
    if (renderServerPlaceholder && window.__SSR_CURRENT_DATE__) currentTimestamp = window.__SSR_CURRENT_DATE__;
    else currentTimestamp = timeNow.getTime();
    const timeDifference = currentTimestamp - lastEditedTime.getTime();
    let isSavedIndicator = false;
    if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_SECONDS < 60) {
        if (isEditMode) {
            headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.saved);
            isSavedIndicator = true;
        } else headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortJustNow);
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES < 60) {
        const minutes = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXMinutesAgo, {
            timeAgo: minutes
        });
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 24) {
        const hours = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXHoursAgo, {
            timeAgo: hours
        });
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 48) {
        const days = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_DAY);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXDaysAgo, {
            timeAgo: days
        });
    } else // After 48 hours, include date in format MMM DD (shortened month 'Jan', for US_en) from server
    headerTimestamp = $f294e68c8b2b1e6c$var$formatfriendlyWhen(friendlyWhen);
    return {
        headerTimestamp: headerTimestamp,
        isSavedIndicator: isSavedIndicator
    };
};
const $f294e68c8b2b1e6c$export$442a454d04f6993d = (lastEditedTime, friendlyWhen, formatMessage, formatTime, formatDate, timeZone, renderServerPlaceholder)=>{
    let tooltipTimestamp;
    const timeNow = new Date();
    let currentTimestamp;
    if (renderServerPlaceholder && window.__SSR_CURRENT_DATE__) currentTimestamp = window.__SSR_CURRENT_DATE__;
    else currentTimestamp = timeNow.getTime();
    const timeDifference = currentTimestamp - lastEditedTime.getTime();
    // Format client timestamp for use when < 48 hours in the past
    const monthAndDay = formatDate(lastEditedTime, {
        month: 'short',
        day: 'numeric',
        timeZone: timeZone
    });
    const formattedTime = formatTime(lastEditedTime, {
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timeZone
    });
    if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 48) tooltipTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.tooltipFullDate, {
        date: monthAndDay,
        time: formattedTime
    });
    else // Use server friendlyWhen here because we want it to match the header timestamp
    tooltipTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.tooltipDate, {
        date: friendlyWhen
    });
    return tooltipTimestamp;
};
const $f294e68c8b2b1e6c$var$focusBorderStyles = (0, $ecnYn.xcss)({
    ':focus-visible': {
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineColor: 'color.border.focused',
        outlineOffset: 'space.025'
    }
});
const $f294e68c8b2b1e6c$export$736471da038a469 = ({ localizedHeaderTimestamp: localizedHeaderTimestamp, isSavedIndicator: isSavedIndicator, hasVersionHistory: hasVersionHistory, isPageOrBlog: isPageOrBlog, isEditMode: isEditMode, versionNumber: versionNumber, createChangeLink: createChangeLink, formatMessage: formatMessage })=>{
    if (isSavedIndicator) return hasVersionHistory ? createChangeLink(localizedHeaderTimestamp) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        tabIndex: 0,
        role: "tooltip",
        xcss: $f294e68c8b2b1e6c$var$focusBorderStyles
    }, localizedHeaderTimestamp);
    let headerMessage;
    if (isPageOrBlog) {
        let formattedTimestamp;
        if (isEditMode) formattedTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.edited, {
            timestamp: localizedHeaderTimestamp
        });
        else formattedTimestamp = versionNumber > 1 ? formatMessage($f294e68c8b2b1e6c$var$i18n.updated, {
            timestamp: localizedHeaderTimestamp
        }) : formatMessage($f294e68c8b2b1e6c$var$i18n.published, {
            timestamp: localizedHeaderTimestamp
        });
        headerMessage = hasVersionHistory ? createChangeLink(formattedTimestamp) : formattedTimestamp;
    } else {
        const formattedTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.edited, {
            timestamp: localizedHeaderTimestamp
        });
        headerMessage = hasVersionHistory ? createChangeLink(formattedTimestamp) : formattedTimestamp;
    }
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(headerMessage)) return headerMessage;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        tabIndex: 0,
        role: "tooltip",
        xcss: $f294e68c8b2b1e6c$var$focusBorderStyles
    }, headerMessage);
};
const $f294e68c8b2b1e6c$export$c5802041e21f264 = ({ localizedTooltipTimestamp: localizedTooltipTimestamp, isEditMode: isEditMode, isPageOrBlog: isPageOrBlog, versionNumber: versionNumber, fullName: fullName, formatMessage: formatMessage })=>{
    let tooltipMessage;
    if (isPageOrBlog) {
        if (isEditMode) tooltipMessage = formatMessage($f294e68c8b2b1e6c$var$i18n.editedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        });
        else tooltipMessage = versionNumber > 1 ? formatMessage($f294e68c8b2b1e6c$var$i18n.updatedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        }) : formatMessage($f294e68c8b2b1e6c$var$i18n.publishedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        });
    } else tooltipMessage = formatMessage($f294e68c8b2b1e6c$var$i18n.editedOn, {
        timestamp: localizedTooltipTimestamp,
        contributor: fullName
    });
    return tooltipMessage;
};


const $f00826a51c2021a6$var$lastEditedStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    alignItems: 'center',
    flexDirection: 'row',
    padding: 'space.050',
    textWrap: 'nowrap'
});
const $f00826a51c2021a6$var$linkStyles = {
    color: "var(--ds-text-subtle, #505258)"
};
const $f00826a51c2021a6$var$disabledLinkStyles = {
    ...$f00826a51c2021a6$var$linkStyles,
    pointerEvents: 'none',
    cursor: 'default'
};
const $f00826a51c2021a6$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    ':hover': {
        textDecoration: 'underline'
    }
});
const $f00826a51c2021a6$export$2fd1e1faefc578c4 = ({ contentId: contentId, version: version, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey })=>{
    const { showSidePanel: showSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { formatMessage: formatMessage, formatTime: formatTime, formatDate: formatDate } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)();
    // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const contentIdRef = (0, $42omo.useRef)(contentId);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { setWasTransitionedFromEditor: setWasTransitionedFromEditor } = (0, $5G6sa.useNewContentHistoryActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Debounce to avoid rapid calls and prevent performance lag
    const debouncedSetRecentVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            updateTimestampCache({
                contentId: contentIdRef.current // we need to use a ref for contentId so that the debounced timer doesn't reset every rerender
            });
        }, 3000), // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // intentionally do not add dependencies so that the debounce timer is not reset on every rerender
    );
    // Update time stamp to "Just now" on page edit and live page edit
    (0, $6qdjm.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    (0, $42omo.useEffect)(()=>{
        contentIdRef.current = contentId;
    }, [
        contentId
    ]);
    // Cancel any pending timers on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedSetRecentVersion
    ]);
    const fireOnClickAnalyticsEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'objectHeader',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lastEditedTimestamp',
                attributes: {
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentType,
        contentMode
    ]);
    const handleLinkClick = (0, $42omo.useCallback)(()=>{
        // Track when user navigates from editor to version history so we can redirect back to editor on back click
        // Only track for non-live pages when in edit mode since lives pages use the view page route
        const isEditMode = contentMode === 'edit';
        if (!isLivePage && isEditMode && (0, $6mKj3.expVal)('confluence_content_history_updates', 'isEnabled', false)) setWasTransitionedFromEditor(true);
        fireOnClickAnalyticsEvent();
    }, [
        isLivePage,
        contentMode,
        setWasTransitionedFromEditor,
        fireOnClickAnalyticsEvent
    ]);
    const createEditorChangeLink = (formattedMessage)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isNetworkDisabled ? $f00826a51c2021a6$var$disabledLinkStyles : $f00826a51c2021a6$var$linkStyles,
            href: `${(0, $jlIaF.CONTEXT_PATH)}/spaces/${spaceKey}/history/${contentId}`,
            onClick: isNetworkDisabled ? undefined : handleLinkClick
        }, formattedMessage);
    };
    const handleContentTypesLinkClick = ()=>{
        showSidePanel();
        fireOnClickAnalyticsEvent();
    };
    const createContentTypesChangeLink = (formattedMessage)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $f00826a51c2021a6$var$pressableStyles,
            backgroundColor: "color.background.neutral.subtle",
            onClick: handleContentTypesLinkClick
        }, formattedMessage);
    };
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const lastEditedHeaderResult = (0, $42omo.useMemo)(()=>{
        const lastEditedTime = new Date(version.when);
        const isEditMode = !(contentMode === 'view' || contentMode === 'archived');
        const { headerTimestamp: headerTimestamp, isSavedIndicator: isSavedIndicator } = (0, $f294e68c8b2b1e6c$export$f87e4558f7028ac3)(lastEditedTime, version.friendlyWhen, isEditMode, formatMessage, renderServerPlaceholder);
        return {
            headerTimestamp: headerTimestamp,
            isSavedIndicator: isSavedIndicator
        };
    }, [
        version.when,
        version.friendlyWhen,
        contentMode,
        formatMessage,
        renderServerPlaceholder
    ]);
    const lastEditedTooltipResult = (0, $42omo.useMemo)(()=>{
        const lastEditedTime = new Date(version.when);
        return (0, $f294e68c8b2b1e6c$export$442a454d04f6993d)(lastEditedTime, version.friendlyWhen, formatMessage, formatTime, formatDate, timeZone, renderServerPlaceholder);
    }, [
        version.when,
        version.friendlyWhen,
        formatMessage,
        formatTime,
        formatDate,
        timeZone,
        renderServerPlaceholder
    ]);
    /**
   * Formats header timestamp as well as tooltip timestamp
   */ const formatTimestamps = ()=>{
        let headerMessage;
        let tooltipMessage;
        const isEditMode = !(contentMode === 'view' || contentMode === 'archived');
        const { headerTimestamp: headerTimestamp, isSavedIndicator: isSavedIndicator } = lastEditedHeaderResult;
        const tooltipTimestamp = lastEditedTooltipResult;
        const isPageOrBlog = contentType === 'page' || contentType === 'blogpost';
        if (isPageOrBlog) {
            const hasEditorVersionHistory = !!spaceKey && contentMode !== 'draft';
            headerMessage = (0, $f294e68c8b2b1e6c$export$736471da038a469)({
                localizedHeaderTimestamp: headerTimestamp,
                isSavedIndicator: isSavedIndicator,
                hasVersionHistory: hasEditorVersionHistory,
                isPageOrBlog: isPageOrBlog,
                isEditMode: isEditMode,
                versionNumber: version.number,
                createChangeLink: createEditorChangeLink,
                formatMessage: formatMessage
            });
            tooltipMessage = (0, $f294e68c8b2b1e6c$export$c5802041e21f264)({
                localizedTooltipTimestamp: tooltipTimestamp,
                isEditMode: isEditMode,
                isPageOrBlog: isPageOrBlog,
                versionNumber: version.number,
                fullName: version.by.fullName,
                formatMessage: formatMessage
            });
        } else if ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database') {
            const hasContentTypesVersionHistory = !version.contentTypeModified;
            headerMessage = (0, $f294e68c8b2b1e6c$export$736471da038a469)({
                localizedHeaderTimestamp: headerTimestamp,
                isSavedIndicator: isSavedIndicator,
                hasVersionHistory: hasContentTypesVersionHistory,
                isPageOrBlog: isPageOrBlog,
                isEditMode: isEditMode,
                versionNumber: version.number,
                createChangeLink: createContentTypesChangeLink,
                formatMessage: formatMessage
            });
            tooltipMessage = (0, $f294e68c8b2b1e6c$export$c5802041e21f264)({
                localizedTooltipTimestamp: tooltipTimestamp,
                isEditMode: isEditMode,
                isPageOrBlog: isPageOrBlog,
                versionNumber: version.number,
                fullName: version.by.fullName,
                formatMessage: formatMessage
            });
        } else {
            headerMessage = null;
            tooltipMessage = null;
        }
        return {
            headerMessage: headerMessage,
            tooltipMessage: tooltipMessage
        };
    };
    // Ensures that timestamp will only display when most accurate timestamp is available
    if (contentMode === 'edit' && !version.when) return null;
    const { headerMessage: formattedHeaderMessage, tooltipMessage: formattedTooltipMessage } = formatTimestamps();
    // Only show tooltip if header timestamp is not full format > 2 days
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: (0, $3oZ9l.LAST_UPDATED_SPOTLIGHT_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $f00826a51c2021a6$var$lastEditedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        component: (0, $778018eca844ead1$export$7574cd0e3a4be128),
        content: formattedTooltipMessage,
        delay: 0
    }, formattedHeaderMessage)));
};


const $71eaeeab7c35a8b6$var$unpublishedChangesTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $71eaeeab7c35a8b6$var$unpublishedChangesLinkStyles = null; // this component is copied from content-header PageMetadataBanner.jsx to avoid circular dependency
const $71eaeeab7c35a8b6$export$87049fd2bc239211 = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { contentId: contentId, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey, version: version, hasEditPermission: hasEditPermission } = t0;
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] !== getQueryParams) {
        const queryParams = getQueryParams();
        t1 = (0, $c3Qwv.getSingleParamInt)(queryParams, "versionOverride", null);
        $[0] = getQueryParams;
        $[1] = t1;
    } else t1 = $[1];
    const versionOverride = t1;
    let t2;
    if ($[2] !== contentId || $[3] !== contentMode || $[4] !== contentType || $[5] !== hasEditPermission || $[6] !== spaceKey || $[7] !== version) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f00826a51c2021a6$export$2fd1e1faefc578c4), {
                contentId: contentId,
                version: version,
                contentType: contentType,
                contentMode: contentMode,
                spaceKey: spaceKey,
                hasEditPermission: hasEditPermission
            });
        $[2] = contentId;
        $[3] = contentMode;
        $[4] = contentType;
        $[5] = hasEditPermission;
        $[6] = spaceKey;
        $[7] = version;
        $[8] = t2;
    } else t2 = $[8];
    const renderLastEdited = t2;
    if (!(contentMode === "view" && (contentType === "page" || contentType === "blogpost"))) {
        let t3;
        if ($[9] !== renderLastEdited) {
            t3 = renderLastEdited();
            $[9] = renderLastEdited;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
        });
        $[11] = t3;
    } else t3 = $[11];
    const t4 = versionOverride || undefined;
    let t5;
    if ($[12] !== contentId || $[13] !== contentType || $[14] !== hasEditPermission || $[15] !== renderLastEdited || $[16] !== spaceKey) {
        t5 = (t6)=>{
            const { webItems: webItems } = t6;
            let unpublishedChangesItem = null;
            const editUrl = (0, $iXzFq.getUrlForContentType)({
                contentType: contentType,
                contentId: contentId,
                spaceKey: spaceKey,
                redirectToEditor: true
            });
            if (webItems.some($71eaeeab7c35a8b6$var$_temp)) unpublishedChangesItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                name: (0, $3oZ9l.LAST_UPDATED_SPOTLIGHT_TARGET)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $71eaeeab7c35a8b6$var$unpublishedChangesTextStyles
            }, hasEditPermission && editUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: editUrl,
                "data-testid": "unpublished-changes-edit-link",
                className: (0, $gMc0m.default)([
                    "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1rpy _10531rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $71eaeeab7c35a8b6$var$i18n.unpublishedChanges)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $71eaeeab7c35a8b6$var$i18n.unpublishedChanges)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
            }), unpublishedChangesItem || renderLastEdited());
        };
        $[12] = contentId;
        $[13] = contentType;
        $[14] = hasEditPermission;
        $[15] = renderLastEdited;
        $[16] = spaceKey;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== contentId || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            location: (0, $eSLr0.PAGE_METADATA_BANNER),
            contentId: contentId,
            version: t4
        }, t5));
        $[18] = contentId;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
};
const $71eaeeab7c35a8b6$var$i18n = (0, $cgtv4.defineMessages)({
    unpublishedChanges: {
        id: "content-types-header.object-header-items.unpublished-changes.link.text",
        defaultMessage: "Unpublished changes"
    }
});
function $71eaeeab7c35a8b6$var$_temp(item) {
    return item.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID);
}









var $gabmL = parcelRequire("gabmL");







const $85c7900526df4a2e$export$b0a1564bba9108e3 = (contentId, contentMode)=>{
    const $ = (0, $frIzR.c)(16);
    const isEditorMode = contentMode === "draft" || contentMode === "edit" || contentMode === "live";
    const t0 = !isEditorMode;
    let t1;
    if ($[0] !== contentId || $[1] !== t0) {
        t1 = {
            pageId: contentId,
            fetchPolicy: "cache-and-network",
            skip: t0
        };
        $[0] = contentId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const publicLinkData = (0, $gabmL.usePublicLinkPageDataProvider)(t1);
    let t2;
    let t3;
    if ($[3] !== isEditorMode || $[4] !== publicLinkData.errors) {
        t2 = ()=>{
            if (!isEditorMode) return;
            for (const error of publicLinkData.errors)(0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            isEditorMode,
            publicLinkData.errors
        ];
        $[3] = isEditorMode;
        $[4] = publicLinkData.errors;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $42omo.useEffect)(t2, t3);
    const { isPublishingContent: isPublishingContent, userOffline: userOffline, forceDisabled: forceDisabled, editorTitle: editorTitle, collabLimitReached: collabLimitReached } = (0, $3o3i5.useEditorObjectHeaderContext)();
    if (!isEditorMode) {
        let t4;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                shouldDisableEditorButtons: false,
                isPublishDisabledForPublishModal: false,
                isPublishDisabled: false,
                pageIsExternallyShared: false
            };
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    const publicLinkDataIsLoading = publicLinkData.isLoading;
    const pageIsExternallyShared = !publicLinkData.isLoading && publicLinkData.isPublicLinkFullyEnabled;
    const shouldDisableActions = isPublishingContent || userOffline || !!forceDisabled;
    const shouldDisableEditorButtons = shouldDisableActions || publicLinkDataIsLoading;
    let t4;
    if ($[8] !== editorTitle) {
        t4 = !editorTitle || !editorTitle.trim();
        $[8] = editorTitle;
        $[9] = t4;
    } else t4 = $[9];
    const isEditorTitleEmpty = t4;
    const isPublishDisabledForPublishModal = shouldDisableActions || Boolean(collabLimitReached);
    const isPublishDisabled = isEditorTitleEmpty || isPublishDisabledForPublishModal;
    let t5;
    if ($[10] !== isPublishDisabled || $[11] !== isPublishDisabledForPublishModal || $[12] !== pageIsExternallyShared || $[13] !== shouldDisableActions || $[14] !== shouldDisableEditorButtons) {
        t5 = {
            shouldDisableEditorButtons: shouldDisableEditorButtons,
            isPublishDisabledForPublishModal: isPublishDisabledForPublishModal,
            isPublishDisabled: isPublishDisabled,
            isCloseButtonDisabled: shouldDisableActions,
            pageIsExternallyShared: pageIsExternallyShared
        };
        $[10] = isPublishDisabled;
        $[11] = isPublishDisabledForPublishModal;
        $[12] = pageIsExternallyShared;
        $[13] = shouldDisableActions;
        $[14] = shouldDisableEditorButtons;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};





const $0ecb1ba642d20f26$export$b5190710ae2f673b = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { contentData: contentData, useDraftVersion: useDraftVersion } = t0;
    let t1;
    bb0: {
        if (useDraftVersion) {
            const t2 = contentData?.draftVersion?.contentTypeModified ?? false;
            const t3 = contentData?.draftVersion?.number ?? 1;
            const t4 = contentData?.draftVersion?.when ?? "";
            const t5 = contentData?.draftVersion?.friendlyWhen ?? "";
            const t6 = contentData?.draftVersion?.by?.displayName ?? "";
            let t7;
            if ($[0] !== t6) {
                t7 = {
                    fullName: t6
                };
                $[0] = t6;
                $[1] = t7;
            } else t7 = $[1];
            let t8;
            if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t7) {
                t8 = {
                    contentTypeModified: t2,
                    number: t3,
                    when: t4,
                    friendlyWhen: t5,
                    by: t7
                };
                $[2] = t2;
                $[3] = t3;
                $[4] = t4;
                $[5] = t5;
                $[6] = t7;
                $[7] = t8;
            } else t8 = $[7];
            t1 = t8;
            break bb0;
        }
        const t2 = contentData?.version?.contentTypeModified ?? false;
        const t3 = contentData?.version?.number ?? 1;
        const t4 = contentData?.version?.when ?? "";
        const t5 = contentData?.version?.friendlyWhen ?? "";
        const t6 = contentData?.version?.by?.displayName ?? "";
        let t7;
        if ($[8] !== t6) {
            t7 = {
                fullName: t6
            };
            $[8] = t6;
            $[9] = t7;
        } else t7 = $[9];
        let t8;
        if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t7) {
            t8 = {
                contentTypeModified: t2,
                number: t3,
                when: t4,
                friendlyWhen: t5,
                by: t7
            };
            $[10] = t2;
            $[11] = t3;
            $[12] = t4;
            $[13] = t5;
            $[14] = t7;
            $[15] = t8;
        } else t8 = $[15];
        t1 = t8;
    }
    const version = t1;
    return version;
};























const $bd64585724dda192$export$4aac5356fb0022cd = ()=>{
    const $ = (0, $frIzR.c)(8);
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $eSUdr.default)`query useIsPrivacyModeEnabledQuery($cloudId:ID!){confluence_isPrivacyModeEnabled(cloudId:$cloudId){isPrivacyModeEnabled}}`;
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== cloudId) {
        t1 = {
            cloudId: cloudId
        };
        $[1] = cloudId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== edition) {
        t2 = !(0, $9wGTI.fg)("ccir_privacy_mode") || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || Boolean(undefined);
        $[3] = edition;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const { data: data, error: error } = (0, $xQxzY.useQuery)(t0, t3);
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return data?.confluence_isPrivacyModeEnabled?.isPrivacyModeEnabled ?? false;
};


'use no memo';
const $2c279a34b2a89086$export$2ed55bc7ce9c518 = ({ contentId: contentId, contentType: contentType, contentMode: contentMode, contentActions: contentActions, handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight, allowedFeatures: allowedFeatures, contentData: contentData, renderCopyLink: renderCopyLink, renderShare: renderShare, showVersionHistorySpotlight: showVersionHistorySpotlight, setShowVersionHistorySpotlight: setShowVersionHistorySpotlight, isSpaceOverviewPage: isSpaceOverviewPage, readOnly: readOnly, isConvertToFolderHighlighted: isConvertToFolderHighlighted = false, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage })=>{
    const isWatchDialogEnabledForContentType = (0, $3dPSK.useIsWatchDialogEnabled)(contentType);
    const isStarringEnabledForContentType = (0, $2cKGu.useIsStarringEnabled)(contentType, contentMode);
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const { isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { loomExternalOpenRoute: loomExternalOpenRoute } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { isPublishingContent: isPublishingContent, onClickPublish: onClickPublish, editorTitle: editorTitle, saveDraft: saveDraft, isUnpublishedDraft: isUnpublishedDraft, shouldRenderPreview: shouldRenderPreview, onPreviewClicked: onPreviewClicked, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, viewMode: viewMode, onHoverPublish: onHoverPublish } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const { isPublishDisabledForPublishModal: isPublishDisabledForPublishModal, isPublishDisabled: isPublishDisabled, isCloseButtonDisabled: isCloseButtonDisabled } = (0, $85c7900526df4a2e$export$b0a1564bba9108e3)(contentId, contentMode);
    const isClassicEdit = (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'draft' || contentMode === 'edit');
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(contentData?.space?.key);
    const isClassificationEnabled = (0, $66bd5ba8343e39f0$export$48cea123122bbc52)(contentData?.type ?? '');
    const isArchived = contentData?.status === 'archived';
    const version = (0, $0ecb1ba642d20f26$export$b5190710ae2f673b)({
        contentData: contentData,
        useDraftVersion: isClassicEdit
    });
    const isPrivacyModeEnabled = (0, $bd64585724dda192$export$4aac5356fb0022cd)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const computedReadOnly = readOnly || isExternal || !contentData?.operations?.some((operation)=>operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation?.targetType) && operation?.operation === 'update');
    const isClassificationAllowedInMoreActions = !computedReadOnly && isClassificationEnabled;
    const moreActionsAllowedFeatures = isClassificationAllowedInMoreActions ? {
        ...allowedFeatures,
        showClassificationMenuAction: true
    } : allowedFeatures;
    const hasArchivePermission = contentData?.operations?.some((operation_0)=>{
        return operation_0?.targetType === contentType && operation_0?.operation === 'archive';
    });
    const renderLastEditedForDatabase = contentType === 'database' && (0, $9wGTI.fg)('databases-frontend-content-wrapper');
    const isPreviewPanelTestEnabled = (0, $4VJDS.default).getString('confluence_page_preview_panel_testing', '') !== '';
    const isCanvasPresenceEnabled = !isMobileApp && contentMode !== 'archived' && ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database');
    const isPagePresenceEnabled = [
        'page',
        'blogpost'
    ].includes(contentType) && contentMode !== 'archived';
    if (isVersionHistoryPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // don't show any header items or overflow items for version history page as they are irrelevant
    return [];
    if (isAttachmentsPage && (0, $6mKj3.expValEquals)('cc_attachments_page', 'isEnabled', true)) // don't show any header items or overflow items for attachments page as they are irrelevant
    return [];
    const currentUserHasEditPermission = contentData?.operations?.some((operation_1)=>{
        return operation_1?.targetType === contentType && operation_1?.operation === 'update';
    });
    return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
        {
            name: 'lastEdited',
            shouldShowSeparator: false,
            shouldRender: allowedFeatures.showLastEdited !== false && (renderLastEditedForDatabase || contentType !== 'embed' && contentType !== 'database' && !isSpaceOverviewPage),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71eaeeab7c35a8b6$export$87049fd2bc239211), {
                contentId: contentId,
                version: version,
                contentType: contentType,
                contentMode: contentMode,
                spaceKey: contentData?.space?.key ?? '',
                hasEditPermission: currentUserHasEditPermission ?? false
            }))
        },
        {
            name: 'aiAgentPresence',
            shouldShowSeparator: false,
            shouldRender: [
                'page',
                'blogpost'
            ].includes(contentType) && (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft'),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fc0e6c31b10b3145$export$ad537527a445740e), null)
        },
        {
            name: 'presence',
            shouldShowSeparator: isCompanyHub,
            shouldRender: allowedFeatures.showPresence !== false && (isPagePresenceEnabled || isCanvasPresenceEnabled) && !isPrivacyModeEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6967e8de26962a4d$export$99c2b779aa4e8b8b), {
                collaborators: contentActions?.collaborators,
                contentId: contentId,
                contentType: contentType,
                contentMode: contentMode,
                isViewMode: viewMode
            })
        },
        {
            name: 'preview',
            shouldShowSeparator: false,
            shouldRender: isCompanyHub,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9vvQJ))),
                appearance: "subtle",
                label: "",
                onClick: onPreviewClicked
            }))
        },
        {
            name: 'mainActions',
            // this only handles showing external link for embed object header
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.mainActions && !!allowedFeatures.showMainActions && (0, $9wGTI.fg)('open_in_new_tab_button_update'),
            children: !!contentActions?.mainActions && !!allowedFeatures.showMainActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48a5da156a2c7b78$export$a37ba60443eae06e), {
                mainActions: contentActions.mainActions.mainActions
            })) : null
        },
        {
            name: 'editIcon',
            shouldShowSeparator: false,
            shouldRender: (contentType === 'page' || contentType === 'blogpost') && contentMode === 'view',
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iAOfI.EditContentButton), {
                contentId: contentId
            }))
        },
        {
            name: 'previewPanelTest',
            shouldShowSeparator: false,
            shouldRender: isPreviewPanelTestEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0f9c0b3d7e5360a3$export$7c95b5e4cc9d3256), null)
        },
        {
            name: 'update',
            shouldShowSeparator: false,
            shouldRender: isClassicEdit,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
                name: "update-split-button",
                enabled: (0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jeQ9x.PublishButtonWithMoreOptions), {
                    onClickPublish: onClickPublish,
                    onHoverPublish: onHoverPublish,
                    publishButtonDisabled: isPublishDisabledForPublishModal ?? isPublishDisabled,
                    title: editorTitle,
                    onClickPreview: onPreviewClicked,
                    userViewingPreview: shouldRenderPreview,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    isUnpublishedDraft: isUnpublishedDraft,
                    flags: flags,
                    saveDraft: saveDraft,
                    contentType: contentType,
                    savingInProgress: isPublishingContent,
                    shouldShowWorldIcon: false,
                    shouldShowFooterButtons: true
                }))))
        },
        {
            name: 'close',
            shouldShowSeparator: false,
            shouldRender: contentMode === 'draft' || contentMode === 'edit',
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1d832c644d7a0658$export$e392907f0931982f), {
                contentType: contentType,
                contentId: contentId,
                spaceKey: contentData?.space?.key ?? '',
                areMainButtonsDisabled: !!isCloseButtonDisabled,
                isUnpublishedDraft: contentMode === 'draft'
            }))
        },
        {
            name: 'share',
            shouldShowSeparator: false,
            shouldRender: !isAnonymous && !isArchived && !!allowedFeatures.showShare && !isCompanyHub,
            children: renderShare()
        },
        {
            name: 'loomExternalOpen',
            shouldShowSeparator: false,
            shouldRender: (0, $9wGTI.fg)('mr2-meeting-recording-notes-confluence') && !!loomExternalOpenRoute,
            children: loomExternalOpenRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bjZbA.LoomExternalOpenButton), null) : null
        },
        {
            name: 'contentRestrictions',
            shouldShowSeparator: false,
            shouldRender: !isAnonymous && !!allowedFeatures.showContentRestrictions && isArchived,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextProvider), {
                contentId: contentId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.RestrictionsDialogTriggerWrapper), {
                contentId: contentId,
                key: "restrictions-dialog-trigger",
                triggeredFrom: "fromContentType"
            })))
        },
        {
            name: 'copy',
            shouldShowSeparator: false,
            shouldRender: isArchived,
            children: renderCopyLink()
        },
        {
            name: 'moreActions',
            shouldShowSeparator: false,
            shouldRenderInContainer: false,
            shouldRender: !!allowedFeatures.showMoreActions,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $511857b10ace36ca$export$6e6eb6019781c337), {
                    moreActions: contentActions?.moreActions,
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    spaceKey: contentData?.space?.key ?? '',
                    allowedFeatures: moreActionsAllowedFeatures,
                    hasArchivePermission: hasArchivePermission,
                    handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
                    setShowVersionHistorySpotlight: setShowVersionHistorySpotlight,
                    showVersionHistorySpotlight: showVersionHistorySpotlight,
                    flags: flags_0,
                    contentData: contentData,
                    readOnly: computedReadOnly,
                    isConvertToFolderHighlighted: isConvertToFolderHighlighted,
                    setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted
                }))))
        }
    ] : [
        {
            name: 'status',
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.contentStatus,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5194c70d50ff0c56$export$437945b454cdf5e5), {
                contentStatus: contentActions?.contentStatus
            })
        },
        {
            name: 'presence',
            shouldShowSeparator: isCompanyHub,
            shouldRender: allowedFeatures.showPresence !== false && isCanvasPresenceEnabled && !isPrivacyModeEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6967e8de26962a4d$export$99c2b779aa4e8b8b), {
                collaborators: contentActions?.collaborators,
                contentId: contentId,
                contentType: contentType,
                contentMode: contentMode,
                isViewMode: viewMode
            })
        },
        {
            name: 'mainActions',
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.mainActions && !!allowedFeatures.showMainActions && (0, $9wGTI.fg)('open_in_new_tab_button_update'),
            // For FG cleanup, remove this line and remove the second 'mainActions' item.
            children: !!contentActions?.mainActions && !!allowedFeatures.showMainActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48a5da156a2c7b78$export$a37ba60443eae06e), {
                mainActions: contentActions.mainActions.mainActions
            }) : null
        },
        {
            name: 'favourite',
            shouldShowSeparator: !isWatchDialogEnabledForContentType,
            shouldRender: isStarringEnabledForContentType && !!allowedFeatures.showFavourite,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxCWb.FavouriteButton), {
                contentId: contentId
            })
        },
        {
            name: 'watchDialog',
            shouldShowSeparator: true,
            shouldRender: isWatchDialogEnabledForContentType && !!allowedFeatures.showWatchDialog,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
                key: contentId,
                metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4c4ke.WatchDialog), {
                contentId: contentId,
                defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
                customTrigger: (0, $9xWyx.ContentTypesWatchDialogButtonLoader),
                useShortcut: true
            }))
        },
        {
            name: 'mainActions',
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.mainActions && !!allowedFeatures.showMainActions && !(0, $9wGTI.fg)('open_in_new_tab_button_update'),
            children: !!contentActions?.mainActions && !!allowedFeatures.showMainActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48a5da156a2c7b78$export$a37ba60443eae06e), {
                mainActions: contentActions.mainActions.mainActions
            }) : null
        },
        {
            name: 'contentRestrictions',
            shouldShowSeparator: isArchived,
            shouldRender: false,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextProvider), {
                contentId: contentId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.RestrictionsDialogTriggerWrapper), {
                contentId: contentId,
                key: "restrictions-dialog-trigger",
                triggeredFrom: "fromContentType"
            })))
        },
        {
            name: 'copy',
            shouldShowSeparator: false,
            shouldRender: isArchived,
            children: renderCopyLink()
        },
        {
            name: 'share',
            shouldShowSeparator: true,
            shouldRender: !isArchived && !!allowedFeatures.showShare,
            children: renderShare()
        },
        {
            name: 'loomExternalOpen',
            shouldShowSeparator: false,
            shouldRender: (0, $9wGTI.fg)('mr2-meeting-recording-notes-confluence') && !!loomExternalOpenRoute,
            children: loomExternalOpenRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bjZbA.LoomExternalOpenButton), null) : null
        },
        {
            name: 'moreActions',
            shouldShowSeparator: false,
            shouldRenderInContainer: false,
            shouldRender: !!allowedFeatures.showMoreActions,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $511857b10ace36ca$export$6e6eb6019781c337), {
                    moreActions: contentActions?.moreActions,
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: contentData?.space?.key ?? '',
                    allowedFeatures: moreActionsAllowedFeatures,
                    hasArchivePermission: hasArchivePermission,
                    handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
                    setShowVersionHistorySpotlight: setShowVersionHistorySpotlight,
                    showVersionHistorySpotlight: showVersionHistorySpotlight,
                    contentData: contentData,
                    flags: flags_1
                })))
        }
    ];
};



















var $5Vf1r = parcelRequire("5Vf1r");





var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $d8c6dd08bfe3a65f$var$getIsSideNavCollapsed = ()=>{
    const sideNavCollapsedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? 'expanded';
    return sideNavCollapsedValue === 'collapsed';
};
const $d8c6dd08bfe3a65f$export$49b33b1785ffa4cd = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentType: contentType, isSpaceOverviewPage: isSpaceOverviewPage, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage, isArchived: isArchived, isEditorToolbarShown: isEditorToolbarShown, isTitleFullyVisible: isTitleFullyVisible, isLegacyObjectSidebarShown: isLegacyObjectSidebarShown, contentId: contentId, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading } = t0;
    const hasMounted = (0, $42omo.useRef)(false);
    const shouldListenForTitleVisibilityChanges = (contentType === "blogpost" || contentType === "page") && !isSpaceOverviewPage && !isArchived && !isEditorToolbarShown && !isVersionHistoryPage && !isAttachmentsPage;
    const checkAndSetDisplayAttribute = $d8c6dd08bfe3a65f$var$_temp;
    const checkAndSetStyle = $d8c6dd08bfe3a65f$var$_temp2;
    let t1;
    if ($[0] !== contentTypesHeaderDataLoading || $[1] !== isAttachmentsPage || $[2] !== isEditorToolbarShown || $[3] !== isLegacyObjectSidebarShown || $[4] !== isSpaceOverviewPage || $[5] !== isTitleFullyVisible || $[6] !== isVersionHistoryPage || $[7] !== shouldListenForTitleVisibilityChanges) {
        t1 = ()=>{
            const toggleSpaceNameBreadcrumbListener = ()=>{
                const separator = document.getElementById("breadcrumbs-separator");
                const spaceName = document.getElementById("breadcrumbs-space-name");
                const chevron = document.getElementById("breadcrumbs-dropdown-chevron-button");
                const contentTitle = document.getElementById("breadcrumbs-content-title");
                const showOnlyContentTitle = ()=>{
                    checkAndSetDisplayAttribute(separator, "none");
                    checkAndSetDisplayAttribute(spaceName, "none");
                    checkAndSetDisplayAttribute(chevron, "block");
                    checkAndSetStyle(contentTitle, "opacity", "1");
                    checkAndSetStyle(contentTitle, "maxWidth", "800px");
                };
                const showOnlySpaceName = ()=>{
                    checkAndSetDisplayAttribute(separator, "none");
                    checkAndSetDisplayAttribute(spaceName, "inline");
                    checkAndSetDisplayAttribute(chevron, "block");
                    checkAndSetStyle(contentTitle, "opacity", "0");
                    checkAndSetStyle(contentTitle, "maxWidth", "0px");
                };
                const showFullBreadcrumbs = ()=>{
                    checkAndSetDisplayAttribute(separator, "inline");
                    checkAndSetDisplayAttribute(spaceName, "inline");
                    checkAndSetDisplayAttribute(chevron, "block");
                    checkAndSetStyle(contentTitle, "opacity", "1");
                    checkAndSetStyle(contentTitle, "maxWidth", "800px");
                };
                const hideEntireBreadcrumbs = ()=>{
                    checkAndSetDisplayAttribute(separator, "none");
                    checkAndSetDisplayAttribute(spaceName, "none");
                    checkAndSetDisplayAttribute(chevron, "none");
                    checkAndSetStyle(contentTitle, "opacity", "0");
                    checkAndSetStyle(contentTitle, "maxWidth", "0px");
                };
                if (!isEditorToolbarShown) checkAndSetStyle(contentTitle, "transition", "opacity 100ms linear");
                if (!isSpaceOverviewPage && !isVersionHistoryPage && !isAttachmentsPage) {
                    if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) {
                        if (shouldListenForTitleVisibilityChanges) {
                            if (isTitleFullyVisible) showOnlySpaceName();
                            else if (contentTypesHeaderDataLoading) hideEntireBreadcrumbs();
                            else showFullBreadcrumbs();
                        } else {
                            if (isEditorToolbarShown) showFullBreadcrumbs();
                            checkAndSetDisplayAttribute(separator, "inline");
                            checkAndSetDisplayAttribute(spaceName, "inline");
                        }
                    } else if (shouldListenForTitleVisibilityChanges) {
                        if (isTitleFullyVisible) {
                            if (isLegacyObjectSidebarShown) showOnlyContentTitle();
                            else hideEntireBreadcrumbs();
                        } else if (contentTypesHeaderDataLoading) hideEntireBreadcrumbs();
                        else showOnlyContentTitle();
                    } else {
                        if (isEditorToolbarShown) showOnlyContentTitle();
                        checkAndSetDisplayAttribute(separator, "none");
                        checkAndSetDisplayAttribute(spaceName, "none");
                    }
                }
            };
            window.addEventListener("resize", toggleSpaceNameBreadcrumbListener);
            if (!hasMounted.current) hasMounted.current = true;
            else toggleSpaceNameBreadcrumbListener();
            return ()=>{
                window.removeEventListener("resize", toggleSpaceNameBreadcrumbListener);
            };
        };
        $[0] = contentTypesHeaderDataLoading;
        $[1] = isAttachmentsPage;
        $[2] = isEditorToolbarShown;
        $[3] = isLegacyObjectSidebarShown;
        $[4] = isSpaceOverviewPage;
        $[5] = isTitleFullyVisible;
        $[6] = isVersionHistoryPage;
        $[7] = shouldListenForTitleVisibilityChanges;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== contentId || $[10] !== contentTypesHeaderDataLoading || $[11] !== isAttachmentsPage || $[12] !== isEditorToolbarShown || $[13] !== isLegacyObjectSidebarShown || $[14] !== isSpaceOverviewPage || $[15] !== isTitleFullyVisible || $[16] !== isVersionHistoryPage || $[17] !== shouldListenForTitleVisibilityChanges) {
        t2 = [
            isLegacyObjectSidebarShown,
            shouldListenForTitleVisibilityChanges,
            isSpaceOverviewPage,
            isVersionHistoryPage,
            isAttachmentsPage,
            contentId,
            isTitleFullyVisible,
            isEditorToolbarShown,
            contentTypesHeaderDataLoading
        ];
        $[9] = contentId;
        $[10] = contentTypesHeaderDataLoading;
        $[11] = isAttachmentsPage;
        $[12] = isEditorToolbarShown;
        $[13] = isLegacyObjectSidebarShown;
        $[14] = isSpaceOverviewPage;
        $[15] = isTitleFullyVisible;
        $[16] = isVersionHistoryPage;
        $[17] = shouldListenForTitleVisibilityChanges;
        $[18] = t2;
    } else t2 = $[18];
    (0, $42omo.useEffect)(t1, t2);
    if (!isVersionHistoryPage && !isAttachmentsPage) {
        if ((contentType === "blogpost" || contentType === "page") && !isSpaceOverviewPage && !isArchived) {
            if (contentTypesHeaderDataLoading && !isTitleFullyVisible) return (0, $5Vf1r.BREADCRUMBS_MODES).HIDDEN;
            if (isEditorToolbarShown) {
                if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
                else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
            } else if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) {
                if (isTitleFullyVisible) return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_SPACE_NAME;
                else return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
            } else {
                if (isTitleFullyVisible) {
                    if (isLegacyObjectSidebarShown) return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
                    return (0, $5Vf1r.BREADCRUMBS_MODES).HIDDEN;
                } else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
            }
        } else if (contentType === "database" || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === "embed") {
            if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
            else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
        }
    }
    return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
};
function $d8c6dd08bfe3a65f$var$_temp(element, displayProperty) {
    if (element && window.getComputedStyle(element).getPropertyValue("display") !== displayProperty) element?.setAttribute("style", `display: ${displayProperty};`);
}
function $d8c6dd08bfe3a65f$var$_temp2(element_0, property, value) {
    if (element_0 && element_0?.style?.[property] !== value) element_0.style[property] = value;
}



var $lEVfb = parcelRequire("lEVfb");










const $9234e6aea1a8bf8e$export$3a542eb6901fb0e2 = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { contentId: contentId, objectHeaderRef: objectHeaderRef, shouldUseProgressiveHeader: shouldUseProgressiveHeader } = t0;
    const [isIntersecting, setIsIntersecting] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== objectHeaderRef) {
        t1 = ()=>{
            if (objectHeaderRef?.current) {
                const title = document.getElementById("content-title-id") || document.getElementById("editor-title-id");
                if (title) {
                    const titleRect = title.getBoundingClientRect();
                    const headerRect = objectHeaderRef.current.getBoundingClientRect();
                    setIsIntersecting(titleRect.top < headerRect.bottom);
                }
            }
        };
        $[0] = objectHeaderRef;
        $[1] = t1;
    } else t1 = $[1];
    const checkIntersection = t1;
    let t2;
    if ($[2] !== checkIntersection || $[3] !== shouldUseProgressiveHeader) {
        t2 = ()=>{
            if (shouldUseProgressiveHeader) {
                if (!Boolean(window.__SSR_RENDERED__) || !(0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) checkIntersection();
                window.addEventListener("scroll", checkIntersection, true);
                window.addEventListener("resize", checkIntersection);
            }
            return ()=>{
                window.removeEventListener("scroll", checkIntersection, true);
                window.removeEventListener("resize", checkIntersection);
            };
        };
        $[2] = checkIntersection;
        $[3] = shouldUseProgressiveHeader;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== checkIntersection || $[6] !== contentId || $[7] !== objectHeaderRef || $[8] !== shouldUseProgressiveHeader) {
        t3 = [
            contentId,
            objectHeaderRef,
            checkIntersection,
            shouldUseProgressiveHeader
        ];
        $[5] = checkIntersection;
        $[6] = contentId;
        $[7] = objectHeaderRef;
        $[8] = shouldUseProgressiveHeader;
        $[9] = t3;
    } else t3 = $[9];
    (0, $42omo.useEffect)(t2, t3);
    return isIntersecting;
};


const $4e15ea858159a232$export$b109b4315ce03d6c = (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { contentType: contentType, contentMode: contentMode, isSpaceOverviewPage: isSpaceOverviewPage, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage, isArchived: isArchived, isLegacyObjectSidebarShown: isLegacyObjectSidebarShown, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading, objectHeaderRef: objectHeaderRef, contentId: contentId } = t0;
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t1;
    const t2 = !isLiveEditMode;
    let t3;
    if ($[0] !== t2) {
        t3 = {
            defaultDockedAtTop: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)(t3);
    const isPageOrBlog = contentType === "page" || contentType === "blogpost";
    const isViewOrViewLiveMode = contentMode === "view" || isLiveViewMode;
    const isInEditor = contentMode === "draft" || contentMode === "edit" || isLiveEditMode;
    const isEditorToolbarShown = isInEditor && isEditorToolbarDockedAtTop;
    const shouldUseProgressiveHeader = isPageOrBlog && isViewOrViewLiveMode || isInEditor && !isEditorToolbarShown || isVersionHistoryPage || isAttachmentsPage;
    let t4;
    if ($[2] !== contentId || $[3] !== objectHeaderRef || $[4] !== shouldUseProgressiveHeader) {
        t4 = {
            contentId: contentId,
            objectHeaderRef: objectHeaderRef,
            shouldUseProgressiveHeader: shouldUseProgressiveHeader
        };
        $[2] = contentId;
        $[3] = objectHeaderRef;
        $[4] = shouldUseProgressiveHeader;
        $[5] = t4;
    } else t4 = $[5];
    const isTitleIntersectingWithHeader = (0, $9234e6aea1a8bf8e$export$3a542eb6901fb0e2)(t4);
    const t5 = !isTitleIntersectingWithHeader;
    let t6;
    if ($[6] !== contentId || $[7] !== contentType || $[8] !== contentTypesHeaderDataLoading || $[9] !== isArchived || $[10] !== isAttachmentsPage || $[11] !== isEditorToolbarShown || $[12] !== isLegacyObjectSidebarShown || $[13] !== isSpaceOverviewPage || $[14] !== isVersionHistoryPage || $[15] !== t5) {
        t6 = {
            isVersionHistoryPage: isVersionHistoryPage,
            isAttachmentsPage: isAttachmentsPage,
            contentType: contentType,
            isSpaceOverviewPage: isSpaceOverviewPage,
            isArchived: isArchived,
            isEditorToolbarShown: isEditorToolbarShown,
            isTitleFullyVisible: t5,
            isLegacyObjectSidebarShown: isLegacyObjectSidebarShown,
            contentId: contentId,
            contentTypesHeaderDataLoading: contentTypesHeaderDataLoading
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = contentTypesHeaderDataLoading;
        $[9] = isArchived;
        $[10] = isAttachmentsPage;
        $[11] = isEditorToolbarShown;
        $[12] = isLegacyObjectSidebarShown;
        $[13] = isSpaceOverviewPage;
        $[14] = isVersionHistoryPage;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    const breadcrumbsDisplayMode = (0, $d8c6dd08bfe3a65f$export$49b33b1785ffa4cd)(t6);
    let isBorderlessHeader = !isSpaceOverviewPage && !isTitleIntersectingWithHeader && !isLegacyObjectSidebarShown && !isEditorToolbarShown || contentTypesHeaderDataLoading && isTitleIntersectingWithHeader;
    let t7;
    if ($[17] !== breadcrumbsDisplayMode || $[18] !== isBorderlessHeader || $[19] !== isEditorToolbarShown) {
        t7 = {
            breadcrumbsDisplayMode: breadcrumbsDisplayMode,
            isBorderlessHeader: isBorderlessHeader,
            isEditorToolbarShown: isEditorToolbarShown
        };
        $[17] = breadcrumbsDisplayMode;
        $[18] = isBorderlessHeader;
        $[19] = isEditorToolbarShown;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
};












var $7hXu9 = parcelRequire("7hXu9");


var $3vc4U = parcelRequire("3vc4U");


var $gKr8t = parcelRequire("gKr8t");





var $fJlJm = parcelRequire("fJlJm");








var $aMcHK = parcelRequire("aMcHK");





var $d9tcB = parcelRequire("d9tcB");

const $dfe2d565e9152de8$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined'
];
const $dfe2d565e9152de8$export$76c04e45533062c9 = (response, onDataReceived)=>{
    const payload = response?.subscriptionData?.data?.confluence_onContentModified;
    const _deltas = payload?._deltas;
    if (!payload || !Array.isArray(_deltas)) return;
    if (_deltas?.length === 0 || _deltas.indexOf('contentTitleUpdated') === -1) return;
    const { contentTitleUpdated: contentTitleUpdated } = payload;
    const title = contentTitleUpdated?.contentTitle;
    onDataReceived(title);
};
const $dfe2d565e9152de8$export$33a5663c83a12152 = (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { contentType: contentType, contentId: contentId, onDataReceived: onDataReceived, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== contentId || $[1] !== contentType) {
        t2 = {
            contentType: contentType,
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = t2;
    } else t2 = $[2];
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onSubscriptionData } = (0, $3vc4U.useSubscriptionValues)(t2);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $eSUdr.default)`subscription ContentTypesTitleSubscription($id:ID!){confluence_onContentModified(id:$id){type id __typename _deltas contentTitleUpdated{contentTitle __typename}}}`;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== extensions || $[5] !== id) {
        t4 = {
            id: id,
            __extensions: extensions
        };
        $[4] = extensions;
        $[5] = id;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== id || $[8] !== onDataReceived || $[9] !== onSubscriptionComplete || $[10] !== onSubscriptionData || $[11] !== skip || $[12] !== skipSubscriptionForAnonUsers || $[13] !== t4) {
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $gKr8t.getAGGClient)();
            $[15] = t6;
        } else t6 = $[15];
        t5 = {
            variables: t4,
            onSubscriptionComplete: onSubscriptionComplete,
            onSubscriptionData (response) {
                $dfe2d565e9152de8$export$76c04e45533062c9(response, onDataReceived);
                onSubscriptionData(response);
            },
            skip: skip || !id || skipSubscriptionForAnonUsers,
            client: t6
        };
        $[7] = id;
        $[8] = onDataReceived;
        $[9] = onSubscriptionComplete;
        $[10] = onSubscriptionData;
        $[11] = skip;
        $[12] = skipSubscriptionForAnonUsers;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    const { error: error } = (0, $7hXu9.useSubscription)(t3, t5);
    let t6;
    let t7;
    if ($[16] !== contentId || $[17] !== contentType || $[18] !== error) {
        t6 = ()=>{
            if (error) {
                const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
                const isIgnoredError = $dfe2d565e9152de8$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
                const statusCode = (0, $aMcHK.getStatusCode)(error) || error?.errors?.[0]?.extensions?.statusCode;
                if (statusCode !== 403 && !isIgnoredError) {
                    const e = new Error(`Subscription Error - ContentTypesTitleSubscription:${errorMessage}`);
                    (0, $fJlJm.setContentErrorAttributes)(e, {
                        objectId: contentId,
                        objectType: contentType
                    });
                    (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                    });
                }
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        t7 = [
            error,
            contentId,
            contentType
        ];
        $[16] = contentId;
        $[17] = contentType;
        $[18] = error;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $42omo.useEffect)(t6, t7);
    return null;
};









var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");





var $iiPY2 = parcelRequire("iiPY2");


var $knzfV = parcelRequire("knzfV");


var $bFMG7 = parcelRequire("bFMG7");





var $hl0fg = parcelRequire("hl0fg");








var $1u6lx = parcelRequire("1u6lx");

const $5b06a9a89418566a$export$4ad2c8d6c7cae594 = 1000;
const $5b06a9a89418566a$var$CONTENT_TITLE_MAX_LENGTH = 25;
const $5b06a9a89418566a$var$CLASSIFICATION_NAME_MAX_LENGTH = 25;
const $5b06a9a89418566a$var$TOTAL_MAX_LENGTH = $5b06a9a89418566a$var$CONTENT_TITLE_MAX_LENGTH + $5b06a9a89418566a$var$CLASSIFICATION_NAME_MAX_LENGTH;
// ~ "Add classification", in English
const $5b06a9a89418566a$var$APPROX_ADD_BUTTON_CHAR_LENGTH = 18;
const $5b06a9a89418566a$export$9dbd9e1965ba2157 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const { contentTitle: t1, classificationName: t2 } = t0;
    const contentTitle = t1 === undefined ? "" : t1;
    const classificationName = t2 === undefined ? "" : t2;
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const contentTitleLength = contentTitle.length;
    const tagLabelLength = classificationName === "" ? $5b06a9a89418566a$var$APPROX_ADD_BUTTON_CHAR_LENGTH : classificationName.length;
    const combinedLength = contentTitleLength + tagLabelLength;
    const isIconOnly = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594 : windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594 && combinedLength > $5b06a9a89418566a$var$TOTAL_MAX_LENGTH;
    return isIconOnly || renderServerPlaceholder ? (0, $1u6lx.TagButtonUIVariant).iconOnly : (0, $1u6lx.TagButtonUIVariant).default;
} : ({ contentTitle: contentTitle = '', classificationName: classificationName = '' })=>{
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const contentTitleLength = contentTitle.length;
    const tagLabelLength = classificationName === '' ? $5b06a9a89418566a$var$APPROX_ADD_BUTTON_CHAR_LENGTH : classificationName.length;
    const combinedLength = contentTitleLength + tagLabelLength;
    const isIconOnly = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594 : windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594 && combinedLength > $5b06a9a89418566a$var$TOTAL_MAX_LENGTH;
    // window is not availble in SSR so we need to need to render
    // the icon only while hydrating
    return isIconOnly || renderServerPlaceholder ? (0, $1u6lx.TagButtonUIVariant).iconOnly : (0, $1u6lx.TagButtonUIVariant).default;
};





/**
 * @generated SignedSource<<5a869015cfcf17ad719cec281143972f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dfd3aefd5b50ce2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentBasicInfoFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$4dfd3aefd5b50ce2$var$node.hash = "c75429b09fee9e0b10f7ca8e827e75a3";
var $4dfd3aefd5b50ce2$export$2e2bcd8739ae039 = $4dfd3aefd5b50ce2$var$node;











const $b19fb0df3b9373e6$export$26aebb14cb61773d = (0, $3u0dr.isReactCompilerActiveV2)() ? (fragmentNode, fragmentRef)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] !== fragmentNode) {
        t0 = {
            fragmentSpec: fragmentNode
        };
        $[0] = fragmentNode;
        $[1] = t0;
    } else t0 = $[1];
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)(t0);
    const t1 = `${fragmentRef?.__typename}:${fragmentRef?.id}`;
    let t2;
    if ($[2] !== readFragmentInterop || $[3] !== t1) {
        t2 = readFragmentInterop({
            id: t1
        });
        $[2] = readFragmentInterop;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (fragmentNode, fragmentRef)=>{
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: fragmentNode
    });
    return readFragmentInterop({
        id: `${fragmentRef?.__typename}:${fragmentRef?.id}`
    });
};


const $da1026f8e09cf81c$export$d21a46dab87be04 = (contentBasicInfoRef, externalShareContent)=>{
    if (externalShareContent) return {
        id: externalShareContent.id,
        title: externalShareContent.title,
        type: externalShareContent.type,
        subType: externalShareContent.subType,
        status: externalShareContent.status
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b19fb0df3b9373e6$export$26aebb14cb61773d)((0, $4dfd3aefd5b50ce2$export$2e2bcd8739ae039), contentBasicInfoRef);
};


/**
 * @generated SignedSource<<03895c0ed41af97ac87b6a1ead4897ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $428aade5a3e8b849$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentSpaceFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "alias"
        }
    ],
    "type": "Space"
};
$428aade5a3e8b849$var$node.hash = "5e7d3791ffec068935e152aaea16d3a4";
var $428aade5a3e8b849$export$2e2bcd8739ae039 = $428aade5a3e8b849$var$node;



const $437d3186ffdaf7cd$export$64efb28d9ab6d8a8 = (contentSpaceRef, externalShareContent)=>{
    if (externalShareContent?.space) return {
        id: externalShareContent.space.id,
        name: externalShareContent.space.name,
        key: externalShareContent.space.key,
        alias: externalShareContent.space.alias
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b19fb0df3b9373e6$export$26aebb14cb61773d)((0, $428aade5a3e8b849$export$2e2bcd8739ae039), contentSpaceRef);
};



// duplicated from ContentHeader
const $580936b329b9c958$var$ContentClassificationTagLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ifxj2",
    name: 'ContentClassificationTag',
    loader: async ()=>(await (parcelRequire("l0bby"))).ContentClassificationTag
});
const $580936b329b9c958$export$68383d0b588bf7b6 = ({ contentId: contentId, contentData: contentData, contentBasicInfoRef: contentBasicInfoRef, contentSpaceRef: contentSpaceRef, contentStatusContext: contentStatusContext, contentType: contentType, readOnly: readOnly, isSpaceOverviewPage: isSpaceOverviewPage, isObjectHeader: isObjectHeader })=>{
    let spaceKey, contentBasicInfo;
    if (contentBasicInfoRef && contentSpaceRef) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        contentBasicInfo = (0, $da1026f8e09cf81c$export$d21a46dab87be04)(contentBasicInfoRef);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        spaceKey = (0, $437d3186ffdaf7cd$export$64efb28d9ab6d8a8)(contentSpaceRef)?.key ?? '';
    } else {
        contentBasicInfo = contentData;
        spaceKey = contentData?.space?.key ?? '';
    }
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: true
    });
    const isClassificationEnabled = contentClassificationMetadata?.featureEnabled ?? false;
    const classificationTagUiVariant = (0, $5b06a9a89418566a$export$9dbd9e1965ba2157)({
        contentTitle: contentBasicInfo?.title ?? '',
        classificationName: contentClassificationMetadata.classification?.name
    });
    if (((0, $1ggpj.isCanvasContentType)(contentType.type) || contentType.type === 'database' || contentType.type === 'embed' || !isObjectHeader) && // from renderOriginalHeader in ContentTypesHeader
    isClassificationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        testId: "content-types-header-classification"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iiPY2.ContentTypeClassification), {
        variant: classificationTagUiVariant,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType.type,
        contentClassificationMetadata: contentClassificationMetadata,
        readOnly: readOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $knzfV.ClassificationEditModal), {
        contentId: contentId,
        spaceKey: spaceKey,
        contentClassificationMetadata: contentClassificationMetadata
    }));
    else if (contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit') return null;
    else if (isSpaceOverviewPage) // we want to render the classification tag in the header for space overview pages
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "content-classification-tag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($580936b329b9c958$var$ContentClassificationTagLoader, {
        contentId: contentId,
        contentType: contentType.type || null,
        contentClassificationMetadata: contentClassificationMetadata,
        isEditMode: false
    }));
    return null;
};




const $985b9df8a4afde11$export$e5688214a1861822 = {
    database: (0, $5qUgM.DATABASE_HEADER_SEGMENT_METRIC),
    embed: (0, $5qUgM.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC),
    whiteboard: (0, $5qUgM.WHITEBOARD_HEADER_SEGMENT_METRIC)
};
const $985b9df8a4afde11$var$contentTypesBreadcrumbsContainerStyles = (0, $ecnYn.xcss)({
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: '20px',
    paddingLeft: 'space.100' /* To align better with the ContentTypesTitle component */ ,
    paddingRight: 'space.0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$ContentActionsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkofajl _1yt4u2gc _bfhkvuon _lcxv1wug _1e0c1txw _1tke1ylp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
$985b9df8a4afde11$var$ContentActionsWrapper.displayName = 'ContentActionsWrapper'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$ContentActionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showSeparator: showSeparator, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.showSeparator && "_eq43ia51 _j9jr1nu5 _aetrb3bt _1qdg7vkz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
$985b9df8a4afde11$var$ContentActionContainer.displayName = 'ContentActionContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$ArchiveBannerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFullWidth: isFullWidth, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _lcxv1wug",
            __cmplp.isFullWidth ? "_18s8tmrp" : "_18s81hs1 _p12f1fdn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
$985b9df8a4afde11$var$ArchiveBannerContainer.displayName = 'ArchiveBannerContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$StyledShare = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8h8dc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
$985b9df8a4afde11$var$StyledShare.displayName = 'StyledShare';
const $985b9df8a4afde11$var$flexNavigationContainerStyles = (0, $ecnYn.xcss)({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxSizing: 'border-box',
    justifyContent: 'space-between'
});
const $985b9df8a4afde11$var$objectHeaderFlexNavigationContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.0',
    paddingRight: 'space.0',
    overflow: 'hidden'
});
const $985b9df8a4afde11$var$floatingHeaderContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    height: '58px'
});
const $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles = (0, $ecnYn.xcss)({
    gap: 'space.075',
    alignItems: 'center',
    minWidth: '176px'
});
const $985b9df8a4afde11$var$objectHeaderStyles = (0, $ecnYn.xcss)({
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'elevation.surface',
    height: '56px',
    zIndex: 'layer'
});
const $985b9df8a4afde11$var$objectHeaderSpotlightZIndexOverride = (0, $ecnYn.xcss)({
    zIndex: 'spotlight'
}); // If the object header's size changes, make sure to update the height constant
// FIXED_OBJECT_HEADER_SSR_HEIGHT in contentTypesHeaderConstants.ts
const $985b9df8a4afde11$var$fixedBorderHeaderContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.150',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $985b9df8a4afde11$var$borderHeaderFadeInStyles = (0, $ecnYn.xcss)({
    transition: 'border-bottom 100ms linear'
});
const $985b9df8a4afde11$var$fixedBorderlessHeaderContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.150',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-inverse, #FFFFFF)"}`
});
const $985b9df8a4afde11$var$floatingBlockHeaderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.100',
    backgroundColor: 'elevation.surface',
    height: '56px',
    pointerEvents: 'auto',
    minWidth: '176px'
});
const $985b9df8a4afde11$var$objectHeaderActionsContainerStyles = (0, $ecnYn.xcss)({
    flexShrink: 0,
    paddingRight: 'space.075'
});
const $985b9df8a4afde11$var$inlineRenameMarginStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.075'
});
const $985b9df8a4afde11$var$inlineRenameOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden'
});
const $985b9df8a4afde11$var$mobileAppWhiteboardStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'none',
    userSelect: 'none',
    touchAction: 'none'
});
const $985b9df8a4afde11$var$skeletonBreadcrumbsStyles = (0, $ecnYn.xcss)({
    height: '20px',
    width: '200px'
});
const $985b9df8a4afde11$var$skeletonTitleStyles = (0, $ecnYn.xcss)({
    height: '24px',
    width: '300px'
});
const $985b9df8a4afde11$var$skeletonActionSmallStyles = (0, $ecnYn.xcss)({
    height: '32px',
    width: '80px'
});
const $985b9df8a4afde11$var$skeletonActionLargeStyles = (0, $ecnYn.xcss)({
    height: '32px',
    width: '100px'
});
const $985b9df8a4afde11$var$getShareAction = (mode)=>mode === (0, $cD1qu.PageMode).EDIT ? (0, $cD1qu.PageMode).EDIT : (0, $cD1qu.PageMode).VIEW;
const $985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { shouldShowEmojiTitle: shouldShowEmojiTitle, contentId: contentId, readOnly: readOnly, contentType: contentType, title: title, spaceName: spaceName, onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler } = t0;
    const { isEditing: isEditing, setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub, updateCache: updateCache } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    const onDataReceivedRef = (0, $42omo.useRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (newTitle)=>onDataReceivedRef?.current?.(newTitle);
        $[0] = t1;
    } else t1 = $[0];
    const stableOnDataReceived = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && [
            $985b9df8a4afde11$var$inlineRenameMarginStyles,
            $985b9df8a4afde11$var$inlineRenameOverflowStyles
        ];
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $7xVCs.PageTreeStateUpdater)
        ];
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== contentId || $[4] !== contentType || $[5] !== isEditing || $[6] !== onCloseTitleSpotlight || $[7] !== readOnly || $[8] !== registerShowTitleSpotlightHandler || $[9] !== setUpdatedTitleFromPubsub || $[10] !== shouldShowEmojiTitle || $[11] !== spaceName || $[12] !== title || $[13] !== updateCache) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            gap: "space.075",
            alignItems: "center",
            testId: "inline-rename-breadcrumb-title",
            xcss: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t3
        }, (pageStateUpdater)=>{
            const updateContentTree = ()=>{
                pageStateUpdater.setForceFetchPageId(contentId);
            };
            const onDataReceived = (newTitle_0)=>{
                if (!isEditing) {
                    updateCache(newTitle_0);
                    updateContentTree();
                    setUpdatedTitleFromPubsub(undefined);
                } else setUpdatedTitleFromPubsub(newTitle_0);
            };
            onDataReceivedRef.current = onDataReceived;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.0",
                alignBlock: "center",
                xcss: (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && $985b9df8a4afde11$var$inlineRenameOverflowStyles
            }, shouldShowEmojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8z0fF.EmojiTitleSelection), {
                "data-testid": "emoji-title-selection",
                contentId: contentId,
                isTitleDisabled: false,
                isTitleCenterAligned: true,
                hasCoverPicture: false,
                isReadOnly: readOnly,
                contentType: contentType,
                updateContentTree: updateContentTree
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $778018eca844ead1$export$42d61ec2afde455f), {
                title: title ?? "",
                contentId: contentId,
                spaceName: spaceName ?? "",
                readOnly: readOnly,
                key: title,
                updateContentTree: updateContentTree,
                contentType: contentType ?? "",
                onCloseTitleSpotlight: onCloseTitleSpotlight,
                registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dfe2d565e9152de8$export$33a5663c83a12152), {
                contentId: contentId,
                contentType: contentType,
                onDataReceived: stableOnDataReceived,
                skip: !(0, $9wGTI.fg)("cc_fps_migration_content-title") || ![
                    "DUAL",
                    "GRAPHQL"
                ].includes((0, $4VJDS.default).getString("confluence-migrate-fps-to-graphql-subscription", ""))
            }));
        }));
        $[3] = contentId;
        $[4] = contentType;
        $[5] = isEditing;
        $[6] = onCloseTitleSpotlight;
        $[7] = readOnly;
        $[8] = registerShowTitleSpotlightHandler;
        $[9] = setUpdatedTitleFromPubsub;
        $[10] = shouldShowEmojiTitle;
        $[11] = spaceName;
        $[12] = title;
        $[13] = updateCache;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
};
$985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb.displayName = 'ContentTypesInlineRenameBreadcrumb';
const $985b9df8a4afde11$var$ContentTypesHeaderInner = ({ externalShareContent: externalShareContent, contentId: contentId, contentActions: contentActions, isFloating: isFloating = false, allowedFeatures: allowedFeatures = (0, $4cb3eaaf01c9d693$export$dce52735e291d3da), onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler, onHeightChange: onHeightChange, handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight, isHeaderPinned: isHeaderPinned = false, showVersionHistorySpotlight: showVersionHistorySpotlight, setShowVersionHistorySpotlight: setShowVersionHistorySpotlight, isSpaceOverviewPage: isSpaceOverviewPage = false, isConvertToFolderHighlighted: isConvertToFolderHighlighted = false, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted, whiteboardAIAgentService: whiteboardAIAgentService, viewOnlyBadge: viewOnlyBadge })=>{
    const isExternal = (0, $6S5EB.isExternalShareRequest)(); // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { bannerHeight: headerHeight, setBannerElement: setHeaderHeightElement } = (0, $bvJwp.useResizeBanner)(isSSR);
    const objectHeaderRef = (0, $42omo.useRef)(null); // If accessing these values outside of editor sessions, they will be default values
    const { editorTitle: editorTitle, shouldRenderPreview: shouldRenderPreview } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const isLegacyObjectSidebarShown = isObjectSidebarShown && !((0, $9wGTI.fg)('ads-panel-system-confluence-object-sidebar') && (0, $jvYFk.isMigratedToPanelSystem)(panel?.id));
    const isVersionHistoryPage = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.CONTENT_HISTORY).name
    });
    const isAttachmentsPage = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.ATTACHMENTS_PAGE).name
    }); // Automation manual trigger modal listening for query param
    (0, $hQBR9.useAutomationUrlParamTrigger)((0, $9wGTI.fg)('a4c-enable-automation-url-trigger'));
    (0, $42omo.useEffect)(()=>{
        onHeightChange?.(headerHeight);
    }, [
        headerHeight,
        onHeightChange
    ]);
    const fragmentSelectors = (0, $42omo.useMemo)(()=>{
        return {
            contentBasicInfo: (data)=>data?.content?.nodes?.[0],
            contentSpace: (data)=>data?.content?.nodes?.[0]?.space
        };
    }, []);
    let contentData, contentSpace, contentBasicInfo, contentTypesHeaderDataLoading, ContentTypesHeaderQueryError, fragmentRefs;
    if ((0, $9wGTI.fg)('confluence_use_fragmentized_queries')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $574d761bd3a496fb$export$b84ae570a1bec29f)((0, $dbf5442f5a3b49c0$export$2e2bcd8739ae039), {
            skip: !!externalShareContent,
            variables: {
                contentId: contentId,
                useObjectHeader: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
            },
            fetchPolicy: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 'cache-and-network' : 'cache-first'
        }, fragmentSelectors);
        contentData = externalShareContent || result?.data?.content?.nodes?.[0];
        contentTypesHeaderDataLoading = result?.loading;
        ContentTypesHeaderQueryError = result?.error;
        fragmentRefs = result?.fragmentRefs; // eslint-disable-next-line react-hooks/rules-of-hooks
        contentBasicInfo = (0, $da1026f8e09cf81c$export$d21a46dab87be04)(fragmentRefs?.contentBasicInfo, externalShareContent); // eslint-disable-next-line react-hooks/rules-of-hooks
        contentSpace = (0, $437d3186ffdaf7cd$export$64efb28d9ab6d8a8)(fragmentRefs?.contentSpace, externalShareContent);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks, graphql-relay-compat/no-import-graphql-operations
        const result = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
        (0, $6LsQQ.ContentTypesHeaderQuery), {
            skip: !!externalShareContent,
            variables: {
                contentId: contentId,
                useObjectHeader: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
            },
            fetchPolicy: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 'cache-and-network' : 'cache-first'
        });
        contentData = externalShareContent || result?.data?.content?.nodes?.[0];
        contentTypesHeaderDataLoading = result?.loading;
        ContentTypesHeaderQueryError = result?.error;
        contentSpace = contentData?.space;
        contentBasicInfo = contentData;
    }
    const spaceKey = contentSpace?.key || ''; // Different pieces of content can have different modes, which need to be reflected in this header.
    // Eg, pages & blogposts can be 'draft', 'archived', 'view', 'edit', or 'live' (or 'embedded', or 'legacy'!)
    const rawContentType = contentBasicInfo?.type ?? undefined; // ShareButton's shareContentType prop doesn't like null values
    const isArchived = contentBasicInfo?.status === 'archived';
    const isDraft = contentBasicInfo?.status === 'draft';
    const isViewEditOrLive = (0, $aSsfA.useGetPageMode)(); // we use subType value directly for live pages bc when a user is not on the live page route,
    // the live docs sweet state store is not populated and useIsCurrentPageLive in useGetPageMode returns false
    const subType = contentBasicInfo?.subType;
    const contentType = (0, $42omo.useMemo)(()=>({
            type: rawContentType,
            mode: (0, $cuWTe.getContentMode)(rawContentType, isArchived, isDraft, subType === 'live' ? subType : isViewEditOrLive)
        }), [
        rawContentType,
        isArchived,
        isDraft,
        subType,
        isViewEditOrLive
    ]);
    const isEditPage = (0, $42omo.useMemo)(()=>contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit', [
        contentType.mode
    ]);
    const { shouldDisableEditorButtons: shouldDisableEditorButtons } = (0, $85c7900526df4a2e$export$b0a1564bba9108e3)(contentId, contentType.mode);
    const isUnpublishedDraft = contentType.mode === 'draft';
    const isRecapSpotlightEligible = (0, $l7iY7.useRecapSpotlightEligibility)(isUnpublishedDraft);
    let contentStatusContext;
    if (contentType.mode === 'live') contentStatusContext = 'current-and-draft';
    else if (contentType.mode === 'edit' || contentType.mode === 'draft') contentStatusContext = 'draft-only';
    else contentStatusContext = 'current-only';
    const { breadcrumbsDisplayMode: breadcrumbsDisplayMode, isBorderlessHeader: isBorderlessHeader, isEditorToolbarShown: isEditorToolbarShown } = (0, $4e15ea858159a232$export$b109b4315ce03d6c)({
        contentType: contentType.type,
        contentMode: contentType.mode || '',
        isSpaceOverviewPage: isSpaceOverviewPage,
        isVersionHistoryPage: isVersionHistoryPage,
        isAttachmentsPage: isAttachmentsPage,
        isArchived: isArchived,
        isLegacyObjectSidebarShown: isLegacyObjectSidebarShown,
        contentTypesHeaderDataLoading: contentTypesHeaderDataLoading,
        objectHeaderRef: objectHeaderRef,
        contentId: contentId
    });
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isMobileAppWhiteboard = isMobileApp && contentType.type === 'whiteboard';
    const operations = externalShareContent?.operations || contentData?.operations;
    const readOnly = isMobileAppWhiteboard || isExternal || !operations?.some((operation)=>operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation?.targetType) && operation?.operation === 'update');
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const shouldShowEmojiTitle = (0, $99t4P.isEmojiTitleEnabled)(contentType.type); // Whiteboard and Database's archive banner renders in its own shell to account for a pinned solid header and a side panel
    // Similarly, pages and blogposts manage their own archive banner
    const showArchiveBanner = contentType.type === 'embed';
    const hasFullWidthBanner = contentType.type === 'embed';
    const showInlineRename = contentType.type !== 'page' && contentType.type !== 'blogpost';
    const { showBreadcrumbs: breadcrumbsIsAllowedFeature } = allowedFeatures;
    const renderCopyLink = ()=>{
        if (Object.values((0, $3WXN2.SUPPORTED_CONTENT_TYPES)).includes(contentType.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cVfpT.CopyLinkButtonLoader), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType.type,
            source: "contentHeader",
            /**
                                                                                                                                    * All currently-supported content types currently treats both viewing and
                                                                                                                                    * editing the same. To avoid issues, we'll refer to viewing to maintain
                                                                                                                                    * consistency, as using 'edit' would generate a different URL.
                                                                                                                                    */ pageMode: "view"
        });
    };
    const renderShare = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
            contentId: contentId,
            contentType: contentType.type,
            shareeAction: $985b9df8a4afde11$var$getShareAction(isViewEditOrLive),
            source: "contentHeader",
            isUnpublishedDraft: contentType.mode === 'draft',
            contentSubType: contentType.mode === 'live' ? 'live' : undefined
        });
    };
    const wrappedRenderShare = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $47zp4.LIVE_DOC_SHARE_BUTTON_TARGET)
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, renderShare()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$StyledShare, null, renderShare()));
    }; // The primary reason for this structure is to support programmatic control of when a separator should render
    const headerItems = (0, $2c279a34b2a89086$export$2ed55bc7ce9c518)({
        contentId: contentId,
        contentType: contentType.type,
        contentMode: contentType.mode,
        contentActions: contentActions,
        handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
        allowedFeatures: allowedFeatures,
        contentData: contentData,
        renderCopyLink: renderCopyLink,
        renderShare: wrappedRenderShare,
        showVersionHistorySpotlight: showVersionHistorySpotlight,
        setShowVersionHistorySpotlight: setShowVersionHistorySpotlight,
        isSpaceOverviewPage: isSpaceOverviewPage,
        readOnly: readOnly,
        isConvertToFolderHighlighted: isConvertToFolderHighlighted,
        setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted,
        whiteboardAIAgentService: whiteboardAIAgentService,
        isVersionHistoryPage: isVersionHistoryPage,
        isAttachmentsPage: isAttachmentsPage
    });
    const renderActionContainers = ()=>{
        const contentToRender = headerItems.filter((contentActions)=>contentActions.shouldRender);
        return contentToRender.map((contentAction, index)=>{
            const { name: name, shouldShowSeparator: shouldShowSeparator, children: children, shouldRenderInContainer: shouldRenderInContainer = true } = contentAction;
            const isLastEntry = index + 1 === contentToRender.length;
            const showSeparator = isLastEntry ? false : shouldShowSeparator;
            const testIdName = `${name}-action-container-${showSeparator ? 'with-separator' : 'without-separator'}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
                key: name
            }, shouldRenderInContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentActionContainer, {
                "data-testid": testIdName,
                showSeparator: showSeparator,
                "data-vc": testIdName
            }, children) : children);
        });
    };
    const hasActionsToRender = ()=>{
        return headerItems.some((contentAction)=>contentAction.shouldRender);
    };
    const renderOriginalHeader = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.TitleAndBreadcrumbsWrapper), {
            isContentHeaderPinned: isHeaderPinned
        }, breadcrumbsIsAllowedFeature && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$contentTypesBreadcrumbsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.BreadcrumbsNonLoadable), {
            contentId: contentId,
            spaceKey: spaceKey,
            showInlineRename: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb, {
            contentId: contentId,
            readOnly: readOnly,
            contentType: contentType.type,
            spaceName: contentSpace?.name,
            title: contentBasicInfo?.title,
            shouldShowEmojiTitle: shouldShowEmojiTitle,
            onCloseTitleSpotlight: onCloseTitleSpotlight,
            registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580936b329b9c958$export$68383d0b588bf7b6), {
            contentStatusContext: contentStatusContext,
            ...(0, $9wGTI.fg)('confluence_use_fragmentized_queries') ? {
                contentBasicInfoRef: fragmentRefs?.contentBasicInfo,
                contentSpaceRef: fragmentRefs?.contentSpace
            } : {
                contentData: contentData
            },
            contentId: contentId,
            contentType: contentType,
            readOnly: readOnly,
            isSpaceOverviewPage: isSpaceOverviewPage,
            isObjectHeader: false
        })), isMobile || isMobileApp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE)
        })) : hasActionsToRender() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentActionsWrapper, null, renderActionContainers()));
    };
    const renderObjectHeader = ()=>{
        if (shouldRenderPreview) return null;
        const isFloatingBlockHeader = contentType.type === 'whiteboard'; // Return link for Version History or Attachments breadcrumbs
        const contentLink = contentId && (isVersionHistoryPage || isAttachmentsPage) ? (0, $hzkzq.buildContentPath)({
            contentId: contentId,
            contentType: contentType.type === 'space' ? 'page' : contentType.type,
            isSpaceOverview: isSpaceOverviewPage,
            spaceKey: spaceKey
        }) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: [
                $985b9df8a4afde11$var$objectHeaderStyles,
                isRecapSpotlightEligible && $985b9df8a4afde11$var$objectHeaderSpotlightZIndexOverride,
                isFloatingBlockHeader && $985b9df8a4afde11$var$floatingHeaderContainerStyles,
                !isFloatingBlockHeader && isBorderlessHeader && $985b9df8a4afde11$var$fixedBorderlessHeaderContainerStyles,
                !isFloatingBlockHeader && !isBorderlessHeader && $985b9df8a4afde11$var$fixedBorderHeaderContainerStyles,
                !isEditorToolbarShown && $985b9df8a4afde11$var$borderHeaderFadeInStyles,
                isMobileAppWhiteboard && $985b9df8a4afde11$var$mobileAppWhiteboardStyles
            ],
            ref: objectHeaderRef,
            id: "object-header-container-id",
            testId: "object-header-container",
            "data-vc": "object-header-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: [
                $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles,
                isFloatingBlockHeader && $985b9df8a4afde11$var$floatingBlockHeaderStyles
            ]
        }, breadcrumbsIsAllowedFeature && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.BreadcrumbsNonLoadable), {
            contentId: contentId,
            // the alias because that is used in the route URL so SSR will pick that up as the
            // space key and use it in the preloading cache for the space detail query.  If we
            // use the true (UUID) space key here in the request, the SSR cache will not find it
            // in the cache and we won't see the breadcrumbs in the SSR'ed version of the header
            spaceKey: contentSpace?.alias ?? contentSpace?.key ?? '',
            contentTitle: (0, $71c531080fb6afdc$export$753f77420b5437b9)({
                isSpaceOverviewPage: isSpaceOverviewPage,
                contentMode: contentType.mode,
                editorTitle: editorTitle,
                contentTitle: contentBasicInfo?.title
            }),
            showInlineRename: showInlineRename,
            shouldDisableMoveButton: shouldDisableEditorButtons,
            displayMode: breadcrumbsDisplayMode,
            contentLink: contentLink,
            contentType: contentType.type,
            subType: contentType.mode === 'live' ? 'live' : undefined
        }), showInlineRename && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb, {
            contentId: contentId,
            readOnly: readOnly,
            contentType: contentType.type,
            spaceName: contentSpace?.name,
            title: contentBasicInfo?.title,
            shouldShowEmojiTitle: shouldShowEmojiTitle,
            onCloseTitleSpotlight: onCloseTitleSpotlight,
            registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
        }), viewOnlyBadge, !isEditPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580936b329b9c958$export$68383d0b588bf7b6), {
            contentStatusContext: contentStatusContext,
            ...(0, $9wGTI.fg)('confluence_use_fragmentized_queries') ? {
                contentBasicInfoRef: fragmentRefs?.contentBasicInfo,
                contentSpaceRef: fragmentRefs?.contentSpace
            } : {
                contentData: contentData
            },
            contentId: contentId,
            contentType: contentType,
            readOnly: readOnly,
            isSpaceOverviewPage: isSpaceOverviewPage,
            isObjectHeader: true
        })), !isMobile && !isMobileApp && hasActionsToRender() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.075",
            alignBlock: "center",
            alignInline: "end",
            xcss: [
                $985b9df8a4afde11$var$objectHeaderActionsContainerStyles,
                isFloatingBlockHeader && $985b9df8a4afde11$var$floatingBlockHeaderStyles
            ],
            testId: "object-header-actions-container"
        }, renderActionContainers())));
    };
    const segmentMetric = $985b9df8a4afde11$export$e5688214a1861822[contentType.type];
    const headerComponents = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? renderObjectHeader() : renderOriginalHeader(); // We moved the classification modal context provider to the fullpageeditor component level for page editor to be able to use it
    // in the page editor byline. We need to conditionally render it here for the other content types.
    const ConditionalClassificationProvider = (contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit') && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $42omo.Fragment) : (0, $40pD8.ClassificationModalContextProvider);
    const hasPointerEvents = contentType.type === 'whiteboard' ? false : (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC)
    }), segmentMetric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        metric: segmentMetric
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.ContentTypesHeaderContainer), {
        isFloating: isFloating,
        ref: setHeaderHeightElement,
        hasPointerEvents: hasPointerEvents,
        key: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $985b9df8a4afde11$var$flexNavigationContainerStyles,
            (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $985b9df8a4afde11$var$objectHeaderFlexNavigationContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConditionalClassificationProvider, null, headerComponents)), showArchiveBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ArchiveBannerContainer, {
        isFullWidth: hasFullWidthBanner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deZfn.ArchivedPageBanner), {
        contentId: contentId,
        marginStyle: "none"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        attributes: {
            contentId: contentId,
            contentType: contentType.type
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE),
        attributes: {
            contentId: contentId,
            contentType: contentType.type,
            contentMode: contentType.mode
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
        metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC),
        customData: {
            contentType: contentType.type,
            contentMode: contentType.mode
        }
    }), ContentTypesHeaderQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: ContentTypesHeaderQueryError
    }));
};
$985b9df8a4afde11$var$ContentTypesHeaderInner.displayName = 'ContentTypesHeaderInner';
const $985b9df8a4afde11$export$f6490cc19c07c23d = ()=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$skeletonBreadcrumbsStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$skeletonTitleStyles
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.ContentTypesHeaderContainer), {
            isFloating: false,
            hasPointerEvents: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$flexNavigationContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $985b9df8a4afde11$var$objectHeaderStyles
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.075",
            alignBlock: "center",
            alignInline: "end",
            xcss: $985b9df8a4afde11$var$objectHeaderActionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$skeletonActionSmallStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$skeletonActionLargeStyles
        })))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $985b9df8a4afde11$export$e3980b758fe4ea84 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$export$f6490cc19c07c23d, null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-types-header",
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInner, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
$985b9df8a4afde11$export$e3980b758fe4ea84.displayName = 'ContentTypesHeader';
module.exports["ContentTypesHeader"] = $985b9df8a4afde11$export$e3980b758fe4ea84;

});

parcelRegister("bvJwp", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $357714bfdc877a0f$export$75b569184a0dd765 = (isSSR)=>{
    const [bannerHeight, setBannerHeight] = (0, $42omo.useState)(0);
    const [bannerElement, setBannerElement] = (0, $42omo.useState)(null);
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!isSSR) return new ResizeObserver((entries)=>{
            for (const entry of entries)setBannerHeight(entry.borderBoxSize[0].blockSize);
        });
    }, [
        isSSR
    ]);
    (0, $42omo.useEffect)(()=>{
        if (bannerElement && resizeObserver) {
            resizeObserver.observe(bannerElement);
            return ()=>resizeObserver.unobserve(bannerElement);
        } else setBannerHeight(0);
    }, [
        bannerElement,
        resizeObserver
    ]);
    return {
        setBannerElement: setBannerElement,
        bannerHeight: bannerHeight,
        setBannerHeight: setBannerHeight
    };
};
module.exports["useResizeBanner"] = $357714bfdc877a0f$export$75b569184a0dd765;

});

parcelRegister("hQBR9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $jmjWc = parcelRequire("jmjWc");


const $89f8907be2f15304$var$PageUrlAutomationMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KurQn",
    name: "PageUrlAutomationMenu",
    loader: async ()=>(await (parcelRequire("hPcXe"))).PageUrlAutomationMenu
});
const $89f8907be2f15304$var$useRunAutomationIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('runAutomationId');
const $89f8907be2f15304$export$88bb754436f46ef4 = (featureGateEnabled = true)=>{
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    // These return 'undefined' from within modals for some reason, so have to get them here instead of inside PageUrlAutomationMenu
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // Need to get this here to know if we should call showModal() or not
    const runAutomationIdQueryParam = $89f8907be2f15304$var$useRunAutomationIdQueryParam();
    const [isFirstLoad, setIsFirstLoad] = (0, $42omo.useState)(true);
    const shouldShowModal = featureGateEnabled && runAutomationIdQueryParam && spaceKey && contentId && isFirstLoad;
    (0, $42omo.useEffect)(()=>{
        if (shouldShowModal) {
            // We only want show the modal once on page load
            setIsFirstLoad(false);
            showModal($89f8907be2f15304$var$PageUrlAutomationMenu, {
                spaceKey: spaceKey,
                pageId: contentId,
                preselectedRuleId: runAutomationIdQueryParam
            });
        }
    }, [
        spaceKey,
        contentId,
        shouldShowModal,
        runAutomationIdQueryParam,
        showModal
    ]);
};
module.exports["useAutomationUrlParamTrigger"] = $89f8907be2f15304$export$88bb754436f46ef4;

});

parcelRegister("hPcXe", function(module, exports) {

let $cfa13f8e7c21e093$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfa13f8e7c21e093$var$load("gC8Nc").then(()=>parcelRequire('dsFIi'));

});

parcelRegister("hg6fN", function(module, exports) {

let $c908c82e4a053997$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c908c82e4a053997$var$load("g9CVe"),
    $c908c82e4a053997$var$load("7Ftdh"),
    $c908c82e4a053997$var$load("34R0T")
]).then(()=>parcelRequire('f2tcq'));

});

parcelRegister("aCrkK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");

const $91a763c2849bb3c4$var$experienceMap = {
    whiteboard: {
        restoreModal: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    },
    slide: {
        restoreModal: (0, $irVI7.SLIDE_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.SLIDE_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.SLIDE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    },
    database: {
        restoreModal: (0, $irVI7.DATABASE_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.DATABASE_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.DATABASE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    }
};
const $91a763c2849bb3c4$export$9560419a530f63b5 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const trackExperience = ({ contentType: contentType, experience: experience, task: task })=>{
        if (!contentType || !experience || !task) return;
        if (contentType === 'whiteboard' || contentType === 'database' || contentType === 'slide') {
            const experienceName = $91a763c2849bb3c4$var$experienceMap[contentType]?.[experience];
            if (experienceName) {
                if (task === 'start') experienceTracker.start({
                    name: experienceName
                });
                else experienceTracker.succeed({
                    name: experienceName
                });
            }
        }
    };
    return {
        trackExperience: trackExperience
    };
};
module.exports["useVersionHistoryExperienceTracking"] = $91a763c2849bb3c4$export$9560419a530f63b5;

});

parcelRegister("5thep", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $d81f7457a684c10d$export$c72df13ba879849e = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
module.exports["useIsVersionHistoryEnabled"] = $d81f7457a684c10d$export$c72df13ba879849e;

});

parcelRegister("lQ86k", function(module, exports) {

let $fe64bd06e98cdf08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe64bd06e98cdf08$var$load("8hbZ5"),
    $fe64bd06e98cdf08$var$load("3yFtm")
]).then(()=>parcelRequire('dQUV0'));

});

parcelRegister("pskhd", function(module, exports) {
const $b218ab7927acda99$export$169d32883304392c = (data)=>{
    const isCurrentUserWatching = data?.singleContent?.currentUserIsWatching ?? false;
    const isWatchingSpace = data?.singleContent?.space?.currentUser?.isWatched ?? false;
    const isWatchingBlogs = data?.singleContent?.space?.currentUser?.isWatchingBlogs ?? false;
    // TODO remove type checks once watch with children gate cleaned up
    const isWatchingChildren = data?.singleContent && 'currentUserIsWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserIsWatchingChildren ?? false : false;
    const hasAncestorWatchingChildren = data?.singleContent && 'currentUserHasAncestorWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserHasAncestorWatchingChildren ?? false : false;
    return {
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingSpace: isWatchingSpace,
        isWatchingBlogs: isWatchingBlogs,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren
    };
};
module.exports["processWatchData"] = $b218ab7927acda99$export$169d32883304392c;

});

parcelRegister("kxAIf", function(module, exports) {

let $ef435e16a22b0379$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef435e16a22b0379$var$load("bzc8Q"),
    $ef435e16a22b0379$var$load("kyfJT")
]).then(()=>parcelRequire('dhbEh'));

});

parcelRegister("ewVsQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $8C5kA = parcelRequire("8C5kA");


var $eSUdr = parcelRequire("eSUdr");


var $6mKj3 = parcelRequire("6mKj3");


var $aXWbQ = parcelRequire("aXWbQ");

const $820cfbe605341dee$var$useRequestToEditContentRequestPageAccessMutation = (0, $eSUdr.default)`mutation useRequestToEditContentRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}`;
const $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID = 'request-to-edit-sent';
const $820cfbe605341dee$export$c3a30e09778accb4 = ({ contentId: contentId, flags: flags, triggerAnalyticsEvent: triggerAnalyticsEvent })=>{
    const [requestSent, setRequestSent] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    const showRequestToEditFailedFlag = (0, $42omo.useCallback)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('content.request.to.edit.failed');
        if (!flags) return;
        flags.showWarningFlag({
            title: intl.formatMessage((0, $aXWbQ.messages).notSentFlagTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).notSentFlagDescription),
            appearance: 'warning',
            isAutoDismiss: true
        });
    }, [
        flags,
        intl,
        triggerAnalyticsEvent
    ]);
    const showRequestToEditSentFlag = (0, $42omo.useCallback)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('content.request.to.edit.success');
        if (!flags) return;
        if (!(0, $6mKj3.expValEquals)('confluence_ask_to_edit_across_content_type', 'cohort', 'test')) // Old flag
        flags.showSuccessFlag({
            id: $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID,
            title: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagDescription),
            actions: [
                {
                    content: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagAction),
                    onClick: ()=>flags.hideFlag($820cfbe605341dee$var$REQUEST_SENT_FLAG_ID)
                }
            ]
        });
        else // New flag
        flags.showSuccessFlag({
            id: $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID,
            title: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagShortTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagDescription),
            isAutoDismiss: true
        });
    }, [
        flags,
        intl,
        triggerAnalyticsEvent
    ]);
    const handleRequestComplete = (result)=>{
        if (result?.requestPageAccess) {
            setRequestSent(true);
            showRequestToEditSentFlag();
        } else {
            showRequestToEditFailedFlag();
            setRequestSent(false);
        }
    };
    const handleRequestError = ()=>{
        showRequestToEditFailedFlag();
        setRequestSent(false);
    };
    const [requestToEditContent, { loading: loading }] = (0, $j1Ss3.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    $820cfbe605341dee$var$useRequestToEditContentRequestPageAccessMutation, {
        variables: {
            requestPageAccessInput: {
                pageId: contentId || '',
                accessType: 'EDIT'
            }
        },
        onCompleted: handleRequestComplete,
        onError: handleRequestError
    });
    return {
        requestToEditContent: requestToEditContent,
        loading: loading,
        hasRequestedEditPermission: requestSent
    };
};
module.exports["useRequestToEditContent"] = $820cfbe605341dee$export$c3a30e09778accb4;

});

parcelRegister("9xWyx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $8cjip = parcelRequire("8cjip");


var $fCjCI = parcelRequire("fCjCI");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $bl4QJ = parcelRequire("bl4QJ");


var $cMvQV = parcelRequire("cMvQV");

const $28dd515dedf67dfe$var$i18n = (0, $cgtv4.defineMessages)({
    startWatch: {
        id: "content-types-header.start.watch",
        defaultMessage: "Watch"
    },
    stopWatch: {
        id: "content-types-header.stop.watch",
        defaultMessage: "Stop watching"
    }
});
const $28dd515dedf67dfe$export$57961f75e08513d1 = (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { isWatching: isWatching, isSelected: isSelected, onClick: onClick, onMouseOver: onMouseOver, triggerProps: triggerProps, contentType: contentType } = t0;
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentType || $[1] !== createAnalyticsEvent || $[2] !== onClick) {
        t1 = async ()=>{
            onClick();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "content-watch-button",
                    source: "viewedContentScreen",
                    attributes: {
                        contentType: contentType
                    }
                }
            }).fire();
        };
        $[0] = contentType;
        $[1] = createAnalyticsEvent;
        $[2] = onClick;
        $[3] = t1;
    } else t1 = $[3];
    const handleWatchButton = t1;
    let t2;
    if ($[4] !== intl || $[5] !== isWatching) {
        t2 = isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))), {
            label: intl.formatMessage($28dd515dedf67dfe$var$i18n.stopWatch)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: intl.formatMessage($28dd515dedf67dfe$var$i18n.startWatch)
        });
        $[4] = intl;
        $[5] = isWatching;
        $[6] = t2;
    } else t2 = $[6];
    const icon = t2;
    let t3;
    if ($[7] !== intl || $[8] !== isWatching) {
        t3 = isWatching ? intl.formatMessage($28dd515dedf67dfe$var$i18n.stopWatch) : intl.formatMessage($28dd515dedf67dfe$var$i18n.startWatch);
        $[7] = intl;
        $[8] = isWatching;
        $[9] = t3;
    } else t3 = $[9];
    const tooltipContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT)
        };
        $[10] = t4;
    } else t4 = $[10];
    const tooltipShortcut = (0, $4tOXV.useShortcutStrings)(t4);
    let t5;
    if ($[11] !== handleWatchButton || $[12] !== icon || $[13] !== isSelected || $[14] !== onMouseOver || $[15] !== triggerProps) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: handleWatchButton,
            onMouseOver: onMouseOver,
            appearance: "subtle",
            iconBefore: icon,
            isSelected: isSelected,
            ...triggerProps,
            "data-testId": "watch-content-button"
        });
        $[11] = handleWatchButton;
        $[12] = icon;
        $[13] = isSelected;
        $[14] = onMouseOver;
        $[15] = triggerProps;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== t5 || $[18] !== tooltipContent || $[19] !== tooltipShortcut) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            shortcut: tooltipShortcut,
            position: "top",
            hideTooltipOnClick: true
        }, t5);
        $[17] = t5;
        $[18] = tooltipContent;
        $[19] = tooltipShortcut;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
};

const $28dd515dedf67dfe$export$b4175d4e6b5294b9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-rBZR",
    name: "ContentTypesWatchDialogButtonLoader",
    loader: async ()=>(await Promise.resolve(module.exports)).ContentTypesWatchDialogButton,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
module.exports["ContentTypesWatchDialogButton"] = $28dd515dedf67dfe$export$57961f75e08513d1;
module.exports["ContentTypesWatchDialogButtonLoader"] = $28dd515dedf67dfe$export$b4175d4e6b5294b9;

});

parcelRegister("l0bby", function(module, exports) {

let $f4a2463ad32749e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f4a2463ad32749e5$var$load("5odbj"),
    $f4a2463ad32749e5$var$load("frTOf")
]).then(()=>parcelRequire('8taxc'));

});

parcelRegister("eix0u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac60b703236e33e11860080af1a47ce0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a68c599b1c939bc9$var$_react = $a68c599b1c939bc9$var$_interopRequireDefault((parcelRequire("42omo")));

var $a68c599b1c939bc9$var$_baseNew = $a68c599b1c939bc9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a68c599b1c939bc9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Wrench".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a68c599b1c939bc9$var$WrenchIcon = (props)=>/*#__PURE__*/ $a68c599b1c939bc9$var$_react.default.createElement($a68c599b1c939bc9$var$_baseNew.default, Object.assign({
        name: "WrenchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.5 1.5a4 4 0 0 0-3.614 5.718.75.75 0 0 1-.146.853l-4.95 4.95a.841.841 0 0 0 1.189 1.19l4.95-4.95a.75.75 0 0 1 .853-.147 4 4 0 0 0 5.667-4.252L12.03 7.28a.75.75 0 0 1-1.06 0L8.72 5.03a.75.75 0 0 1 0-1.06l2.419-2.42a4 4 0 0 0-.639-.05M5 5.5A5.5 5.5 0 0 1 12.863.532a.75.75 0 0 1 .208 1.208L10.31 4.5l1.19 1.19 2.76-2.76a.75.75 0 0 1 1.208.207 5.5 5.5 0 0 1-6.832 7.539L4.038 15.27a2.34 2.34 0 1 1-3.31-3.31l4.595-4.596A5.5 5.5 0 0 1 5 5.5" clip-rule="evenodd"/>`
    }, props));
$a68c599b1c939bc9$var$WrenchIcon.displayName = 'WrenchIcon';
var $a68c599b1c939bc9$var$_default = module.exports.default = $a68c599b1c939bc9$var$WrenchIcon;

});


//# sourceMappingURL=FullPageEditorComponent.54df2492.js.map
